import * as moment_ from 'moment';
import { __decorate, __awaiter } from 'tslib';
import { CurrencyPipe, CommonModule } from '@angular/common';
import { Injectable, ɵɵdefineInjectable, ɵɵinject, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage';
import { UiBsOauthModule } from '@wlp/ui-bs-oauth';
import { HttpClient } from '@angular/common/http';

const moment = moment_;
class DateValidator {
    static ptDate(control) {
        const ptDatePattern = /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/g;
        if (!control.value.match(ptDatePattern)) {
            return { ptDate: true };
        }
        return null;
    }
    static usDate(control) {
        const usDatePattern = /^02\/(?:[01]\d|2\d)\/(?:19|20)(?:0[048]|[13579][26]|[2468][048])|(?:0[13578]|10|12)\/(?:[0-2]\d|3[01])\/(?:19|20)\d{2}|(?:0[469]|11)\/(?:[0-2]\d|30)\/(?:19|20)\d{2}|02\/(?:[0-1]\d|2[0-8])\/(?:19|20)\d{2}$/;
        if (!control.value.match(usDatePattern)) {
            return { usDate: true };
        }
        return null;
    }
    static validDate(control) {
        try {
            const val = control.value;
            if (val.length >= 9) {
                const date = val.split('/');
                const compareDate = moment(`${date[2]}-${date[1]}-${date[0]}`).set('hour', 0).set('minute', 0);
                const currentDate = moment();
                const duration = moment.duration(currentDate.diff(compareDate)).asYears();
                if (duration < 18) {
                    return { validDate: true };
                }
                return null;
            }
        }
        catch (err) {
            console.warn(err);
        }
    }
    static validDateMajor(control) {
        try {
            const val = control.value;
            if (val.length >= 9) {
                const date = val.split('/');
                const dateToCompare = new Date();
                const dataValidation = new Date(Number(date[2]), Number(date[1]) - 1, Number(date[0]));
                if (dataValidation > dateToCompare) {
                    return { validDateMajor: true };
                }
                return null;
            }
        }
        catch (err) {
            console.warn(err);
        }
    }
    static validDateAfter(control) {
        try {
            const val = control.value;
            if (val.length >= 9) {
                const date = val.split('/');
                const dateToCompare = new Date();
                dateToCompare.setHours(0, 0, 0, 0);
                const dataValidation = new Date(Number(date[2]), Number(date[1]) - 1, Number(date[0]) - 3);
                if (dataValidation < dateToCompare) {
                    return { validDateAfter: true };
                }
                return null;
            }
        }
        catch (err) {
            console.warn(err);
        }
    }
}

class DocumentValidator {
    /**
     * Valida se o CPF e o CNPJ são validos.
     */
    static isValidCPFCNPJ(control) {
        if (String(control.value).length < 15) {
            let cpf = String(control.value);
            cpf = cpf.replace(/[^\d]+/g, '');
            if (cpf) {
                let numbers, digits, sum, i, result, equalDigits;
                equalDigits = 1;
                if (cpf.length < 11) {
                    return { cpfNotValid: true };
                }
                for (i = 0; i < cpf.length - 1; i++) {
                    if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
                        equalDigits = 0;
                        break;
                    }
                }
                if (!equalDigits) {
                    numbers = cpf.substring(0, 9);
                    digits = cpf.substring(9);
                    sum = 0;
                    for (i = 10; i > 1; i--) {
                        sum += numbers.charAt(10 - i) * i;
                    }
                    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
                    if (result !== Number(digits.charAt(0))) {
                        return { cpfNotValid: true };
                    }
                    numbers = cpf.substring(0, 10);
                    sum = 0;
                    for (i = 11; i > 1; i--) {
                        sum += numbers.charAt(11 - i) * i;
                    }
                    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
                    if (result !== Number(digits.charAt(1))) {
                        return { cpfNotValid: true };
                    }
                    return null;
                }
                else {
                    return { cpfNotValid: true };
                }
            }
        }
        else {
            var cnpj = String(control.value);
            cnpj = cnpj.replace(/[^\d]+/g, '');
            if (cnpj == '')
                return { cnpjNotValid: true };
            if (cnpj.length != 14)
                return { cnpjNotValid: true };
            if (cnpj == '00000000000000' ||
                cnpj == '11111111111111' ||
                cnpj == '22222222222222' ||
                cnpj == '33333333333333' ||
                cnpj == '44444444444444' ||
                cnpj == '55555555555555' ||
                cnpj == '66666666666666' ||
                cnpj == '77777777777777' ||
                cnpj == '88888888888888' ||
                cnpj == '99999999999999')
                return { cnpjNotValid: true };
            // Valida DVs LINHA 23 -
            let tamanho = cnpj.length - 2;
            let numeros = cnpj.substring(0, tamanho);
            let digitos = cnpj.substring(tamanho);
            let soma = 0;
            let pos = tamanho - 7;
            for (let i = tamanho; i >= 1; i--) {
                soma += parseFloat(numeros.charAt(tamanho - i)) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
            if (resultado != parseFloat(digitos.charAt(0)))
                return { cnpjNotValid: true };
            tamanho = tamanho + 1;
            numeros = cnpj.substring(0, tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (let i = tamanho; i >= 1; i--) {
                soma += parseFloat(numeros.charAt(tamanho - i)) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
            if (resultado != parseFloat(digitos.charAt(1)))
                return { cnpjNotValid: true };
            return null;
        }
    }
    /**
     * Valida se o CPF é valido. Deve-se ser informado o CPF sem máscara.
     */
    static isValidCPF(control) {
        let cpf = String(control.value);
        cpf = cpf.replace(/[^\d]+/g, '');
        if (cpf) {
            let numbers, digits, sum, i, result, equalDigits;
            equalDigits = 1;
            if (cpf.length < 11) {
                return { cpfNotValid: true };
            }
            for (i = 0; i < cpf.length - 1; i++) {
                if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
                    equalDigits = 0;
                    break;
                }
            }
            if (!equalDigits) {
                numbers = cpf.substring(0, 9);
                digits = cpf.substring(9);
                sum = 0;
                for (i = 10; i > 1; i--) {
                    sum += numbers.charAt(10 - i) * i;
                }
                result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
                if (result !== Number(digits.charAt(0))) {
                    return { cpfNotValid: true };
                }
                numbers = cpf.substring(0, 10);
                sum = 0;
                for (i = 11; i > 1; i--) {
                    sum += numbers.charAt(11 - i) * i;
                }
                result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
                if (result !== Number(digits.charAt(1))) {
                    return { cpfNotValid: true };
                }
                return null;
            }
            else {
                return { cpfNotValid: true };
            }
        }
    }
    static isValidCNPJ(control) {
        var cnpj = String(control.value);
        cnpj = cnpj.replace(/[^\d]+/g, '');
        if (cnpj == '')
            return { cnpjNotValid: true };
        if (cnpj.length != 14)
            return { cnpjNotValid: true };
        if (cnpj == '00000000000000' ||
            cnpj == '11111111111111' ||
            cnpj == '22222222222222' ||
            cnpj == '33333333333333' ||
            cnpj == '44444444444444' ||
            cnpj == '55555555555555' ||
            cnpj == '66666666666666' ||
            cnpj == '77777777777777' ||
            cnpj == '88888888888888' ||
            cnpj == '99999999999999')
            return { cnpjNotValid: true };
        // Valida DVs LINHA 23 -
        let tamanho = cnpj.length - 2;
        let numeros = cnpj.substring(0, tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += parseFloat(numeros.charAt(tamanho - i)) * pos--;
            if (pos < 2)
                pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != parseFloat(digitos.charAt(0)))
            return { cnpjNotValid: true };
        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += parseFloat(numeros.charAt(tamanho - i)) * pos--;
            if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != parseFloat(digitos.charAt(1)))
            return { cnpjNotValid: true };
        return null;
    }
}

class MatchValidator {
    static mustMatch(controlName, matchingControlName) {
        const fn = (formGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];
            if (matchingControl.errors && !matchingControl.errors.mustMatch) {
                // return if another validator has already found an error on the matchingControl
                return;
            }
            // set error on matchingControl if validation fails
            if (control.value !== matchingControl.value || matchingControl.value == '') {
                matchingControl.setErrors({ mustMatch: true });
            }
            else {
                matchingControl.setErrors(null);
            }
        };
        return fn;
    }
}

class PasswordValidator {
    static hasEmptySpace(control) {
        if (String(control.value).match(/\s/g)) {
            return { hasEmptySpace: true };
        }
        return null;
    }
    static minChar(control) {
        const pMinPattern = /.{8,}/;
        if (!String(control.value).match(pMinPattern)) {
            return { minChar: true };
        }
        return null;
    }
    static minUpperChar(control) {
        const pMinPattern = /[A-Z]{1,}/;
        if (!String(control.value).match(pMinPattern)) {
            return { minUpperChar: true };
        }
        return null;
    }
    static minLowerChar(control) {
        const pMinPattern = /[a-z]{1,}/;
        if (!String(control.value).match(pMinPattern)) {
            return { minLowerChar: true };
        }
        return null;
    }
    static minNumberChar(control) {
        const pMinPattern = /[0-9]{1,}/;
        if (!control.value.match(pMinPattern)) {
            return { minNumberChar: true };
        }
        return null;
    }
    static minSpecialChar(control) {
        const pMinPattern = /[@$!%*?&#]{1,}/;
        if (!String(control.value).match(pMinPattern)) {
            return { minSpecialChar: true };
        }
        return null;
    }
}

/**
 * usado para validar se o valor usado na renda seja inferior a {MIN_VALUE}
 */
// valor minimo para a validacao de renda
const MIN_VALUE = 300;
function minValueValidator() {
    return (control) => {
        if (control.value === '' || control.value === null)
            return null; // se vazio, nao validar o campo!
        const cost = control.value.substring(control.value.search(/\d/)).replace(',', '.');
        return (Number(cost) <= MIN_VALUE) ? { minSalaryValue: true } : null;
    };
}

class MoneyValidator {
    /**
     * Valida o valor é maior que zero
     */
    static isValid(control) {
        if (control.value.length > 0) {
            let value = String(control.value);
            value = value.replace('.', '').replace(',', '.');
            if (Number(value) < 1) {
                return { validMoney: true };
            }
            return null;
        }
    }
    static min(control) {
        if (control.value.length > 0) {
            let value = String(control.value);
            value = value.replace('.', '').replace(',', '.');
            if (Number(value) < 100) {
                return { validMoneyMin: true };
            }
            return null;
        }
    }
    static max(control) {
        if (control.value.length > 0) {
            let value = String(control.value);
            value = value.replace('.', '').replace(',', '.');
            if (Number(value) > 15000) {
                return { validMoneyMax: true };
            }
            return null;
        }
    }
}

let BanksService = class BanksService {
    constructor() {
        // private listBanks = [
        //   { code: '001', name: '001 – Banco do Brasil S.A.', value: 'Banco do Brasil S.A.' },
        //   { code: '003', name: '003 – Banco da Amazônia S.A.', value: 'Banco da Amazônia S.A.' },
        //   { code: '033', name: '033 – Banco Santander S.A.', value: 'Banco Santander S.A.' },
        //   { code: '082', name: '082 – Banco Topázio S.A.', value: 'Banco Topázio S.A.' },
        //   { code: '077', name: '077 – Banco Inter S.A.', value: 'Banco Inter S.A.' },
        //   { code: '104', name: '104 – Caixa Econômica Federal', value: 'Caixa Econômica Federal' },
        //   { code: '212', name: '212 – Banco Original S.A.', value: 'Banco Original S.A.' },
        //   { code: '229', name: '229 – Banco Cruzeiro do Sul S.A.', value: 'Banco Cruzeiro do Sul S.A.' },
        //   { code: '336', name: '336 – Banco C6 S.A.', value: 'Banco C6 S.A.' },
        //   { code: '237', name: '237 – Banco Bradesco S.A.', value: 'Banco Bradesco S.A.' },
        //   { code: '260', name: '260 – Nu Pagamentos S.A.', value: 'Nu Pagamentos S.A.' },
        //   { code: '263', name: '263 – Banco Cacique S.A.', value: 'Banco Cacique S.A.' },
        //   { code: '318', name: '318 – Banco BMG S.A.', value: 'Banco BMG S.A.' },
        //   { code: '341', name: '341 – Banco Itaú S.A.', value: 'Banco Itaú S.A.' },
        //   { code: '376', name: '376 – Banco J. P. Morgan S.A.', value: 'Banco J. P. Morgan S.A.' },
        //   { code: '389', name: '389 – Banco Mercantil do Brasil S.A.', value: 'Banco Mercantil do Brasil S.A.' },
        //   { code: '422', name: '422 – Banco Safra S.A.', value: 'Banco Safra S.A.' },
        //   { code: '453', name: '453 – Banco Rural S.A.', value: 'Banco Rural S.A.' },
        //   { code: '623', name: '623 – Banco Panamericano S.A.', value: 'Banco Panamericano S.A.' },
        //   { code: '633', name: '633 – Banco Rendimento S.A.', value: 'Banco Rendimento S.A.' },
        //   { code: '637', name: '637 – Banco Sofisa S.A.', value: 'Banco Sofisa S.A.' },
        //   { code: '745', name: '745 – Banco Citibank S.A.', value: 'Banco Citibank S.A.' },
        //   { code: '748', name: '748 – Banco Cooperativo Sicredi S.A.', value: 'Banco Cooperativo Sicredi S.A.' },
        //   { code: '756', name: '756 – Banco Cooperativo do Brasil S.A. – BANCOOB', value: 'Banco Cooperativo do Brasil S.A. – BANCOOB' },
        //   { code: '070', name: '070 - BRB - BANCO DE BRASILIA S.A.', value: 'BRB - BANCO DE BRASILIA S.A.'},
        //   { code: '002', name: '002 - BANCO CENTRAL DO BRASIL', value: 'BANCO CENTRAL DO BRASIL'},
        //   { code: '272', name: '272 - AGK Corretora de Cambio S.A.', value: 'AGK Corretora de Cambio S.A.'},
        //   { code: '136', name: '136 - UNICRED', value: 'UNICRED'},
        //   { code: '741', name: '741 - BANCO RIBEIRAO PRETO SA', value: 'BANCO RIBEIRAO PRETO SA'},
        //   { code: '330', name: '330 - Banco Bari de Investimentos e Financiame', value: 'Banco Bari de Investimentos e Financiame'},
        //   { code: '739', name: '739 - Cetelem', value: 'Cetelem'},
        //   { code: '743', name: '743 - BANCO SEMEAR S.A.', value: 'BANCO SEMEAR S.A.'},
        //   { code: '100', name: '100 - SC PLANNER', value: 'SC PLANNER'},
        //   { code: '096', name: '096 - BANCO B3 S.A.', value: 'BANCO B3 S.A.'},
        //   { code: '747', name: '747 - BANCO RABOBANK INTERNATIONAL BRASIL S.A.', value: 'BANCO RABOBANK INTERNATIONAL BRASIL S.A.'},
        //   { code: '362', name: '362 - CIELO S.A.', value: 'CIELO S.A.'},
        //   { code: '322', name: '322 - Cooperativa de Credito Rural de Abelardo', value: 'Cooperativa de Credito Rural de Abelardo'},
        //   { code: '350', name: '350 - COOPERATIVA DE CREDITO RURAL DE PEQUENOS', value: 'COOPERATIVA DE CREDITO RURAL DE PEQUENOS'},
        //   { code: '752', name: '752 - BANCO BNP PARIBAS BRASIL S.A', value: 'BANCO BNP PARIBAS BRASIL S.A'},
        //   { code: '091', name: '091 - CC Unicred Central RS', value: 'CC Unicred Central RS'},
        //   { code: '379', name: '379 - COOPERFORTE - COOPERATIVA DE ECONOMIA E', value: 'COOPERFORTE - COOPERATIVA DE ECONOMIA E'},
        //   { code: '399', name: '399 - KIRTON BANK S.A. - BANCO MULTI', value: 'KIRTON BANK S.A. - BANCO MULTI'},
        //   { code: '108', name: '108 - SCFI PORTOCRED', value: 'SCFI PORTOCRED'},
        //   { code: '378', name: '378 - BBC LEASING S.A. - ARRENDAMENTO MERCANTI', value: 'BBC LEASING S.A. - ARRENDAMENTO MERCANTI'},
        //   { code: '360', name: '360 - TRINUS CAPITAL DISTRIBUIDORA DE TITULOS', value: 'TRINUS CAPITAL DISTRIBUIDORA DE TITULOS'},
        //   { code: '757', name: '757 - Keb Hana do Brasil', value: 'Keb Hana do Brasil'},
        //   { code: '102', name: '102 - SC XP INVESTIMENTOS', value: 'SC XP INVESTIMENTOS'},
        //   { code: '084', name: '084 - Uniprime Norte do Parana - Cooperativa d', value: 'Uniprime Norte do Parana - Cooperativa d'},
        //   { code: '180', name: '180 - SC CM Capital Markets', value: 'SC CM Capital Markets'},
        //   { code: '066', name: '066 - MORGAN STANLEY', value: 'MORGAN STANLEY'},
        //   { code: '015', name: '015 - SC LINK', value: 'SC LINK'},
        //   { code: '143', name: '143 - SC TREVISO', value: 'SC TREVISO'},
        //   { code: '062', name: '062 - HIPERCARD BANCO MULTIPLO SA', value: 'HIPERCARD BANCO MULTIPLO SA'},
        //   { code: '074', name: '074 - BANCO J. SAFRA S.A.', value: 'BANCO J. SAFRA S.A.'},
        //   { code: '099', name: '099 - UNIPRIME CENTRAL - CENTRAL INT DE COOP D', value: 'UNIPRIME CENTRAL - CENTRAL INT DE COOP D'},
        //   { code: '387', name: '387 - Banco Toyota do Brasil S.A.', value: 'Banco Toyota do Brasil S.A.'},
        //   { code: '326', name: '326 - PARATI - CREDITO, FINANCIAMENTO E INVEST', value: 'PARATI - CREDITO, FINANCIAMENTO E INVEST'},
        //   { code: '025', name: '025 - BANCO ALFA S/A', value: 'BANCO ALFA S/A'},
        //   { code: '315', name: '315 - PI Distribuidora de Titulos e Valores Mo', value: 'PI Distribuidora de Titulos e Valores Mo'},
        //   { code: '075', name: '075 - ABN AMRO', value: 'ABN AMRO'},
        //   { code: '040', name: '040 - Banco Cargill S.A.', value: 'Banco Cargill S.A.'},
        //   { code: '307', name: '307 - Terra Investimentos Distribuidora de Tit', value: 'Terra Investimentos Distribuidora de Tit'},
        //   { code: '190', name: '190 - Servicoop - Cooperativa de Credito dos S', value: 'Servicoop - Cooperativa de Credito dos S'},
        //   { code: '296', name: '296 - Vision S.A. Corretora de Cambio', value: 'Vision S.A. Corretora de Cambio'},
        //   { code: '063', name: '063 - BANCO BRADESCARD S.A.', value: 'BANCO BRADESCARD S.A.'},
        //   { code: '191', name: '191 - SC Nova Futura', value: 'SC Nova Futura'},
        //   { code: '382', name: '382 - FIDUCIA SOCIEDADE DE CREDITO AO MICROEMP', value: 'FIDUCIA SOCIEDADE DE CREDITO AO MICROEMP'},
        //   { code: '064', name: '064 - GOLDMAN SACHS DO BRASIL-BANCO MULTIPLO S', value: 'GOLDMAN SACHS DO BRASIL-BANCO MULTIPLO S'},
        //   { code: '097', name: '097 - Credisis - Central de Cooperativas de Cr', value: 'Credisis - Central de Cooperativas de Cr'},
        //   { code: '016', name: '016 - CC CREDITRAN', value: 'CC CREDITRAN'},
        //   { code: '299', name: '299 - Sorocred - Credito, Financiamento e Inve', value: 'Sorocred - Credito, Financiamento e Inve'},
        //   { code: '012', name: '012 - Banco Inbursa S.A.', value: 'Banco Inbursa S.A.'},
        //   { code: '060', name: '060 - CONFIDENCE CORRETORA DE CAMBIO', value: 'CONFIDENCE CORRETORA DE CAMBIO'},
        //   { code: '037', name: '037 - BANCO DO ESTADO DO PARA SA', value: 'BANCO DO ESTADO DO PARA SA'},
        //   { code: '359', name: '359 - ZEMA CREDITO, FINANCIAMENTO E INVESTIMEN', value: 'ZEMA CREDITO, FINANCIAMENTO E INVESTIMEN'},
        //   { code: '159', name: '159 - Casa do Credito S.A. Sociedade de Credit', value: 'Casa do Credito S.A. Sociedade de Credit'},
        //   { code: '085', name: '085 - Cooperativa Central de Credito - Ailos', value: 'Cooperativa Central de Credito - Ailos'},
        //   { code: '114', name: '114 - Central Cooperativa de Credito no Estado', value: 'Central Cooperativa de Credito no Estado'},
        //   { code: '036', name: '036 - BANCO BRADESCO BBI S.A', value: 'BANCO BRADESCO BBI S.A'},
        //   { code: '394', name: '394 - BANCO BRADESCO FINANCIAMENTOS S.A.', value: 'BANCO BRADESCO FINANCIAMENTOS S.A.'},
        //   { code: '004', name: '004 - BANCO DO NORDESTE DO BRASIL S.A.', value: 'BANCO DO NORDESTE DO BRASIL S.A.'},
        //   { code: '320', name: '320 - CCB Brasil', value: 'CCB Brasil'},
        //   { code: '189', name: '189 - SCFI HS', value: 'SCFI HS'},
        //   { code: '105', name: '105 - SCFI LECCA', value: 'SCFI LECCA'},
        //   { code: '076', name: '076 - KDB DO BRASIL', value: 'KDB DO BRASIL'},
        //   { code: '286', name: '286 - Cooperativa de Credito Rural de Ouro Sul', value: 'Cooperativa de Credito Rural de Ouro Sul'},
        //   { code: '093', name: '093 - SCM POLOCRED', value: 'SCM POLOCRED'},
        //   { code: '391', name: '391 - COOPERATIVA DE CREDITO RURAL DE IBIAM -', value: 'COOPERATIVA DE CREDITO RURAL DE IBIAM -'},
        //   { code: '273', name: '273 - Cooperativa de Credito Rural de Sao Migu', value: 'Cooperativa de Credito Rural de Sao Migu'},
        //   { code: '368', name: '368 - Banco CSF S.A.', value: 'Banco CSF S.A.'},
        //   { code: '290', name: '290 - Pagseguro Internet S.A.', value: 'Pagseguro Internet S.A.'},
        //   { code: '259', name: '259 - MONEYCORP BANCO DE CAMBIO S.A.', value: 'MONEYCORP BANCO DE CAMBIO S.A.'},
        //   { code: '364', name: '364 - GERENCIANET S A', value: 'GERENCIANET S A'},
        //   { code: '157', name: '157 - SC ICAP', value: 'SC ICAP'},
        //   { code: '183', name: '183 - Socred S.A. - Sociedade de Credito ao Mi', value: 'Socred S.A. - Sociedade de Credito ao Mi'},
        //   { code: '014', name: '014 - State Street Brasil S.A. - Banco Comerci', value: 'State Street Brasil S.A. - Banco Comerci'},
        //   { code: '130', name: '130 - SCFI CARUANA', value: 'SCFI CARUANA'},
        //   { code: '127', name: '127 - SC CODEPE', value: 'SC CODEPE'},
        //   { code: '079', name: '079 - Banco Original do Agronegocio S.A.', value: 'Banco Original do Agronegocio S.A.'},
        //   { code: '340', name: '340 - Super Pagamentos e Administracao de Meio', value: 'Super Pagamentos e Administracao de Meio'},
        //   { code: '081', name: '081 - BancoSeguro S.A.', value: 'BancoSeguro S.A.'},
        //   { code: '133', name: '133 - Confederacao Nacional das Cooperativas C', value: 'Confederacao Nacional das Cooperativas C'},
        //   { code: '323', name: '323 - MercadoPago.com Representacoes Ltda.', value: 'MercadoPago.com Representacoes Ltda.'},
        //   { code: '121', name: '121 - Banco Agibank S.A.', value: 'Banco Agibank S.A.'},
        //   { code: '083', name: '083 - BANCO DA CHINA BRASIL S.A.', value: 'BANCO DA CHINA BRASIL S.A.'},
        //   { code: '138', name: '138 - SC GET MONEY', value: 'SC GET MONEY'},
        //   { code: '024', name: '024 - BANCO DE PERNAMBUCO S.A.-BANDEPE', value: 'BANCO DE PERNAMBUCO S.A.-BANDEPE'},
        //   { code: '384', name: '384 - GLOBAL FINANCAS SOCIEDADE DE CREDITO AO', value: 'GLOBAL FINANCAS SOCIEDADE DE CREDITO AO'},
        //   { code: '319', name: '319 - OM Distribuidora de Titulos e Valores Mo', value: 'OM Distribuidora de Titulos e Valores Mo'},
        //   { code: '274', name: '274 - Money Plus Sociedade de Credito ao Micro', value: 'Money Plus Sociedade de Credito ao Micro'},
        //   { code: '095', name: '095 - Travelex Banco de Cambio S.A.', value: 'Travelex Banco de Cambio S.A.'},
        //   { code: '094', name: '094 - Finaxis', value: 'Finaxis'},
        //   { code: '276', name: '276 - Senff S.A. - Credito, Financiamento e In', value: 'Senff S.A. - Credito, Financiamento e In'},
        //   { code: '092', name: '092 - BRK S.A. Credito, Financiamento e Invest', value: 'BRK S.A. Credito, Financiamento e Invest'},
        //   { code: '047', name: '047 - BANCO DO ESTADO DE SERGIPE S.A.', value: 'BANCO DO ESTADO DE SERGIPE S.A.'},
        //   { code: '144', name: '144 - Bexs Banco de Cambio S.A.', value: 'Bexs Banco de Cambio S.A.'},
        //   { code: '332', name: '332 - Acesso Solucoes de Pagamento S.A.', value: 'Acesso Solucoes de Pagamento S.A.'},
        //   { code: '126', name: '126 - BI BR PARTNERS', value: 'BI BR PARTNERS'},
        //   { code: '325', name: '325 - Orama Distribuidora de Titulos e Valores', value: 'Orama Distribuidora de Titulos e Valores'},
        //   { code: '301', name: '301 - BPP Instituicao de Pagamento S.A.', value: 'BPP Instituicao de Pagamento S.A.'},
        //   { code: '173', name: '173 - DTVM BRL Trust', value: 'DTVM BRL Trust'},
        //   { code: '331', name: '331 - Fram Capital Distribuidora de Titulos e', value: 'Fram Capital Distribuidora de Titulos e'},
        //   { code: '119', name: '119 - WESTERN UNION', value: 'WESTERN UNION'},
        //   { code: '396', name: '396 - HUB PAGAMENTOS S.A', value: 'HUB PAGAMENTOS S.A'},
        //   { code: '309', name: '309 - Cambionet Corretora de Cambio Ltda.', value: 'Cambionet Corretora de Cambio Ltda.'},
        //   { code: '254', name: '254 - PARANA BANCO S.A.', value: 'PARANA BANCO S.A.'},
        //   { code: '268', name: '268 - Bari Companhia Hipotecaria', value: 'Bari Companhia Hipotecaria'},
        //   { code: '107', name: '107 - Banco Bocom BBM S.A.', value: 'Banco Bocom BBM S.A.'},
        //   { code: '412', name: '412 - BANCO CAPITAL S.A.', value: 'BANCO CAPITAL S.A.'},
        //   { code: '124', name: '124 - BANCO WOORI BANK DO BRASIL S.A', value: 'BANCO WOORI BANK DO BRASIL S.A'},
        //   { code: '149', name: '149 - SCFI Facta Financeira', value: 'SCFI Facta Financeira'},
        //   { code: '197', name: '197 - Stone Pagamentos S.A.', value: 'Stone Pagamentos S.A.'},
        //   { code: '313', name: '313 - AMAZONIA CORRETORA DE CAMBIO LTDA.', value: 'AMAZONIA CORRETORA DE CAMBIO LTDA.'},
        //   { code: '142', name: '142 - SC BROKER BRASIL', value: 'SC BROKER BRASIL'},
        //   { code: '184', name: '184 - ITAU BBA', value: 'ITAU BBA'},
        //   { code: '634', name: '634 - BANCO TRIANGULO SA', value: 'BANCO TRIANGULO SA'},
        //   { code: '545', name: '545 - SC SENSO', value: 'SC SENSO'},
        //   { code: '132', name: '132 - ICBC do Brasil Banco Multiplo S.A.', value: 'ICBC do Brasil Banco Multiplo S.A.'},
        //   { code: '298', name: '298 - Vip s Corretora de Cambio Ltda.', value: 'Vip s Corretora de Cambio Ltda.'},
        //   { code: '377', name: '377 - BMS SOCIEDADE DE CREDITO DIRETO S A', value: 'BMS SOCIEDADE DE CREDITO DIRETO S A'},
        //   { code: '321', name: '321 - Crefaz Sociedade de Credito ao Microempr', value: 'Crefaz Sociedade de Credito ao Microempr'},
        //   { code: '129', name: '129 - UBS BRASIL BANCO DE INVESTIMENTO S.A.', value: 'UBS BRASIL BANCO DE INVESTIMENTO S.A.'},
        //   { code: '128', name: '128 - BCam MS Bank', value: 'BCam MS Bank'},
        //   { code: '194', name: '194 - Parmetal Distribuidora de Titulos e Valo', value: 'Parmetal Distribuidora de Titulos e Valo'},
        //   { code: '383', name: '383 - BOLETOBANCARIO.COM TECNOLOGIA DE PAGAMEN', value: 'BOLETOBANCARIO.COM TECNOLOGIA DE PAGAMEN'},
        //   { code: '324', name: '324 - CARTOS SOCIEDADE DE CREDITO DIRETO S.A.', value: 'CARTOS SOCIEDADE DE CREDITO DIRETO S.A.'},
        //   { code: '310', name: '310 - Vortx Distribuidora de Titulos e Valores', value: 'Vortx Distribuidora de Titulos e Valores'},
        //   { code: '380', name: '380 - PICPAY SERVICOS S A', value: 'PICPAY SERVICOS S A'},
        //   { code: '163', name: '163 - Commerzbank Brasil S.A. - Banco Multiplo', value: 'Commerzbank Brasil S.A. - Banco Multiplo'},
        //   { code: '280', name: '280 - Avista S.A. Credito, Financiamento e Inv', value: 'Avista S.A. Credito, Financiamento e Inv'},
        //   { code: '146', name: '146 - SC GUITTA', value: 'SC GUITTA'},
        //   { code: '343', name: '343 - FFA Sociedade de Credito ao Microempreen', value: 'FFA Sociedade de Credito ao Microempreen'},
        //   { code: '279', name: '279 - Cooperativa de Credito Rural de Primaver', value: 'Cooperativa de Credito Rural de Primaver'},
        //   { code: '335', name: '335 - Banco Digio S.A.', value: 'Banco Digio S.A.'},
        //   { code: '349', name: '349 - AL5 S A CREDITO FINANCIAMENTO E INVEST', value: 'AL5 S A CREDITO FINANCIAMENTO E INVEST'},
        //   { code: '374', name: '374 - REALIZE CREDITO FINANCIAMENTO E INVESTI', value: 'REALIZE CREDITO FINANCIAMENTO E INVESTI'},
        //   { code: '278', name: '278 - Genial Investimentos Corretora de Valore', value: 'Genial Investimentos Corretora de Valore'},
        //   { code: '271', name: '271 - IB Corretora de Cambio, Titulos e Valore', value: 'IB Corretora de Cambio, Titulos e Valore'},
        //   { code: '021', name: '021 - BANESTES S.A BANCO DO ESTADO DO ESPIRITO', value: 'BANESTES S.A BANCO DO ESTADO DO ESPIRITO'},
        //   { code: '246', name: '246 - BANCO ABC BRASIL S.A.', value: 'BANCO ABC BRASIL S.A.'},
        //   { code: '292', name: '292 - BS2 Distribuidora de Titulos e Valores M', value: 'BS2 Distribuidora de Titulos e Valores M'},
        //   { code: '000', name: '000 - CIP C3', value: 'CIP C3'},
        //   { code: '751', name: '751 - Scotiabank Brasil S.A. Banco Multiplo', value: 'Scotiabank Brasil S.A. Banco Multiplo'},
        //   { code: '352', name: '352 - TORO CORRETORA DE TITULOS E VALORES MOBI', value: 'TORO CORRETORA DE TITULOS E VALORES MOBI'},
        //   { code: '208', name: '208 - BANCO BTG PACTUAL S.A.', value: 'BANCO BTG PACTUAL S.A.'},
        //   { code: '746', name: '746 - BANCO MODAL S.A.', value: 'BANCO MODAL S.A.'},
        //   { code: '241', name: '241 - BANCO CLASSICO SA', value: 'BANCO CLASSICO SA'},
        //   { code: '612', name: '612 - BANCO GUANABARA S.A.', value: 'BANCO GUANABARA S.A.'},
        //   { code: '604', name: '604 - BANCO INDUSTRIAL DO BRASIL S. A.', value: 'BANCO INDUSTRIAL DO BRASIL S. A.'},
        //   { code: '505', name: '505 - BANCO CREDIT SUISSE (BRASIL) S.A.', value: 'BANCO CREDIT SUISSE (BRASIL) S.A.'},
        //   { code: '329', name: '329 - QI Sociedade de Credito Direto S.A.', value: 'QI Sociedade de Credito Direto S.A.'},
        //   { code: '196', name: '196 - Fair Corretora de Cambio S.A.', value: 'Fair Corretora de Cambio S.A.'},
        //   { code: '342', name: '342 - Creditas Sociedade de Credito Direto S.A', value: 'Creditas Sociedade de Credito Direto S.A'},
        //   { code: '300', name: '300 - BANCO DE LA NACION ARGENTINA', value: 'BANCO DE LA NACION ARGENTINA'},
        //   { code: '477', name: '477 - CITIBANK N.A.', value: 'CITIBANK N.A.'},
        //   { code: '266', name: '266 - BANCO CEDULA S.A.', value: 'BANCO CEDULA S.A.'},
        //   { code: '122', name: '122 - BRADESCO BERJ', value: 'BRADESCO BERJ'},
        //   { code: '348', name: '348 - Banco XP S.A.', value: 'Banco XP S.A.'},
        //   { code: '473', name: '473 - Banco Caixa Geral Brasil S A', value: 'Banco Caixa Geral Brasil S A'},
        //   { code: '120', name: '120 - BANCO RODOBENS S.A', value: 'BANCO RODOBENS S.A'},
        //   { code: '265', name: '265 - BANCO FATOR S.A.', value: 'BANCO FATOR S.A.'},
        //   { code: '007', name: '007 - BNDES', value: 'BNDES'},
        //   { code: '188', name: '188 - Ativa Investimentos S.A. Corretora de Ti', value: 'Ativa Investimentos S.A. Corretora de Ti'},
        //   { code: '134', name: '134 - DTVM BGC LIQUIDEZ', value: 'DTVM BGC LIQUIDEZ'},
        //   { code: '029', name: '029 - ITAU CONSIGNADO', value: 'ITAU CONSIGNADO'},
        //   { code: '243', name: '243 - BANCO MAXIMA SA', value: 'BANCO MAXIMA SA'},
        //   { code: '397', name: '397 - LISTO SOCIEDADE DE CREDITO DIRETO S A', value: 'LISTO SOCIEDADE DE CREDITO DIRETO S A'},
        //   { code: '078', name: '078 - BI HAITONG DO BRASIL', value: 'BI HAITONG DO BRASIL'},
        //   { code: '355', name: '355 - Otimo Sociedade de Credito Direto S.A.', value: 'Otimo Sociedade de Credito Direto S.A.'},
        //   { code: '367', name: '367 - VITREO DISTRIBUIDORA DE TITULOS E VALORE', value: 'VITREO DISTRIBUIDORA DE TITULOS E VALORE'},
        //   { code: '373', name: '373 - UP.P SOCIEDADE DE EMPRESTIMO ENTRE PESSO', value: 'UP.P SOCIEDADE DE EMPRESTIMO ENTRE PESSO'},
        //   { code: '111', name: '111 - DTVM OLIVEIRA TRUST', value: 'DTVM OLIVEIRA TRUST'},
        //   { code: '408', name: '408 - BONUSCRED SOCIEDADE DE CREDITO DIRETO S', value: 'BONUSCRED SOCIEDADE DE CREDITO DIRETO S'},
        //   { code: '404', name: '404 - SUMUP SOCIEDADE DE CREDITO DIRETO S A', value: 'SUMUP SOCIEDADE DE CREDITO DIRETO S A'},
        //   { code: '403', name: '403 - CORA SOCIEDADE DE CREDITO DIRETO S A', value: 'CORA SOCIEDADE DE CREDITO DIRETO S A'},
        //   { code: '306', name: '306 - Portopar Distribuidora de Titulos e Valo', value: 'Portopar Distribuidora de Titulos e Valo'},
        //   { code: '017', name: '017 - BNY MELLON S.A.', value: 'BNY MELLON S.A.'},
        //   { code: '151', name: '151 - BANCO NOSSA CAIXA S.A', value: 'BANCO NOSSA CAIXA S.A'},
        //   { code: '174', name: '174 - PEFISA S A CREDITO FINANCIAMENTO E I', value: 'PEFISA S A CREDITO FINANCIAMENTO E I'},
        //   { code: '495', name: '495 - PROVINCIA B. AIRES', value: 'PROVINCIA B. AIRES'},
        //   { code: '125', name: '125 - Plural S.A. Banco Multiplo', value: 'Plural S.A. Banco Multiplo'},
        //   { code: '488', name: '488 - JPMORGAN CHASE BANK', value: 'JPMORGAN CHASE BANK'},
        //   { code: '065', name: '065 - AndBank', value: 'AndBank'},
        //   { code: '492', name: '492 - ING Bank', value: 'ING Bank'},
        //   { code: '145', name: '145 - SC Levycam', value: 'SC Levycam'},
        //   { code: '250', name: '250 - BCV - Banco de Credito e Varejo S/A', value: 'BCV - Banco de Credito e Varejo S/A'},
        //   { code: '354', name: '354 - Necton Investimentos S.A. Corretora de V', value: 'Necton Investimentos S.A. Corretora de V'},
        //   { code: '253', name: '253 - SC Bexs', value: 'SC Bexs'},
        //   { code: '269', name: '269 - BANCO HSBC S.A.', value: 'BANCO HSBC S.A.'},
        //   { code: '213', name: '213 - BANCO ARBI S.A.', value: 'BANCO ARBI S.A.'},
        //   { code: '139', name: '139 - Intesa Sanpaolo', value: 'Intesa Sanpaolo'},
        //   { code: '018', name: '018 - BM TRICURY', value: 'BM TRICURY'},
        //   { code: '630', name: '630 - Banco Smartbank S.A.', value: 'Banco Smartbank S.A.'},
        //   { code: '224', name: '224 - BANCO FIBRA S.A.', value: 'BANCO FIBRA S.A.'},
        //   { code: '393', name: '393 - Banco Volkswagen S.A.', value: 'Banco Volkswagen S.A.'},
        //   { code: '600', name: '600 - BANCO LUSO BRASILEIRO S.A.', value: 'BANCO LUSO BRASILEIRO S.A.'},
        //   { code: '390', name: '390 - BANCO GM S.A.', value: 'BANCO GM S.A.'},
        //   { code: '655', name: '655 - BANCO VOTORANTIM S.A.', value: 'BANCO VOTORANTIM S.A.'},
        //   { code: '479', name: '479 - BANCO ITAUBANK S.A.', value: 'BANCO ITAUBANK S.A.'},
        //   { code: '456', name: '456 - Banco MUFG Brasil S.A.', value: 'Banco MUFG Brasil S.A.'},
        //   { code: '464', name: '464 - BANCO SUMITOMO MITSUI BRASILEIRO S.A.', value: 'BANCO SUMITOMO MITSUI BRASILEIRO S.A.'},
        //   { code: '381', name: '381 - BANCO MERCEDES-BENZ DO BRASIL S.A.', value: 'BANCO MERCEDES-BENZ DO BRASIL S.A.'},
        //   { code: '613', name: '613 - Omni Banco S.A.', value: 'Omni Banco S.A.'},
        //   { code: '652', name: '652 - ITAU UNIBANCO HOLDING SA', value: 'ITAU UNIBANCO HOLDING SA'},
        //   { code: '653', name: '653 - BANCO INDUSVAL S.A.', value: 'BANCO INDUSVAL S.A.'},
        //   { code: '069', name: '069 - Banco Crefisa S.A.', value: 'Banco Crefisa S.A.'},
        //   { code: '230', name: '230 - UNICARD BANCO MULTIPLO S.A', value: 'UNICARD BANCO MULTIPLO S.A'},
        //   { code: '370', name: '370 - Mizuho', value: 'Mizuho'},
        //   { code: '249', name: '249 - BANCO INVESTCRED UNIBANCO S.A', value: 'BANCO INVESTCRED UNIBANCO S.A'},
        //   { code: '214', name: '214 - BANCO DIBENS S.A.', value: 'BANCO DIBENS S.A.'},
        //   { code: '626', name: '626 - BANCO C6 CONSIGNADO S.A.', value: 'BANCO C6 CONSIGNADO S.A.'},
        //   { code: '270', name: '270 - Sagitur Corretora de Cambio Ltda.', value: 'Sagitur Corretora de Cambio Ltda.'},
        //   { code: '366', name: '366 - BANCO SOCIETE GENERALE BRASIL S.A', value: 'BANCO SOCIETE GENERALE BRASIL S.A'},
        //   { code: '113', name: '113 - SC MAGLIANO', value: 'SC MAGLIANO'},
        //   { code: '131', name: '131 - SC TULLETT PREBON', value: 'SC TULLETT PREBON'},
        //   { code: '011', name: '011 - SC CREDIT SUISSE HG', value: 'SC CREDIT SUISSE HG'},
        //   { code: '611', name: '611 - BANCO PAULISTA S.A.', value: 'BANCO PAULISTA S.A.'},
        //   { code: '755', name: '755 - BANK OF AMERICA MERRILL LYNCH BANCO MULT', value: 'BANK OF AMERICA MERRILL LYNCH BANCO MULT'},
        //   { code: '089', name: '089 - COOPERATIVA DE CREDITO RURAL DA REGIAO D', value: 'COOPERATIVA DE CREDITO RURAL DA REGIAO D'},
        //   { code: '643', name: '643 - BANCO PINE S.A.', value: 'BANCO PINE S.A.'},
        //   { code: '140', name: '140 - SC EASYNVEST', value: 'SC EASYNVEST'},
        //   { code: '707', name: '707 - BANCO DAYCOVAL S.A.', value: 'BANCO DAYCOVAL S.A.'},
        //   { code: '288', name: '288 - Carol Distribuidora de Titulos e Valores', value: 'Carol Distribuidora de Titulos e Valores'},
        //   { code: '363', name: '363 - SINGULARE CORRETORA DE TITULOS E VALORES', value: 'SINGULARE CORRETORA DE TITULOS E VALORES'},
        //   { code: '101', name: '101 - DTVM RENASCENCA', value: 'DTVM RENASCENCA'},
        //   { code: '487', name: '487 - DEUTSCHE BANK S. A. - BANCO ALEMAO', value: 'DEUTSCHE BANK S. A. - BANCO ALEMAO'},
        //   { code: '233', name: '233 - Banco Cifra S.A.', value: 'Banco Cifra S.A.'},
        //   { code: '177', name: '177 - SC Guide', value: 'SC Guide'},
        //   { code: '365', name: '365 - SOLIDUS S.A. CORRETORA DE CAMBIO E VALOR', value: 'SOLIDUS S.A. CORRETORA DE CAMBIO E VALOR'},
        //   { code: '218', name: '218 - Banco BS2 S.A.', value: 'Banco BS2 S.A.'},
        //   { code: '169', name: '169 - BANCO OLE CONSIGNADO S.A.', value: 'BANCO OLE CONSIGNADO S.A.'},
        //   { code: '293', name: '293 - Lastro RDV Distribuidora de Titulos e Va', value: 'Lastro RDV Distribuidora de Titulos e Va'},
        //   { code: '285', name: '285 - Frente Corretora de Cambio Ltda.', value: 'Frente Corretora de Cambio Ltda.'},
        //   { code: '080', name: '080 - BT Corretora de Cambio Ltda.', value: 'BT Corretora de Cambio Ltda.'},
        //   { code: '753', name: '753 - NBC BANK BRASIL S.A.- BANCO MULTIPLO', value: 'NBC BANK BRASIL S.A.- BANCO MULTIPLO'},
        //   { code: '222', name: '222 - BANCO CREDIT AGRICOLE BRASIL', value: 'BANCO CREDIT AGRICOLE BRASIL'},
        //   { code: '281', name: '281 - Cooperativa de Credito Rural Coopavel', value: 'Cooperativa de Credito Rural Coopavel'},
        //   { code: '754', name: '754 - Sistema', value: 'Sistema'},
        //   { code: '098', name: '098 - CREDIALIANCA COOPERATIVA DE CREDITO RURA', value: 'CREDIALIANCA COOPERATIVA DE CREDITO RURA'},
        //   { code: '610', name: '610 - BANCO VR S.A.', value: 'BANCO VR S.A.'},
        //   { code: '712', name: '712 - BM OURINVEST', value: 'BM OURINVEST'},
        //   { code: '010', name: '010 - CC CREDICOAMO CREDITO RURAL COOPERATIVA', value: 'CC CREDICOAMO CREDITO RURAL COOPERATIVA'},
        //   { code: '283', name: '283 - RB Capital Investimentos Distribuidora d', value: 'RB Capital Investimentos Distribuidora d'},
        //   { code: '217', name: '217 - BANCO JOHN DEERE S.A.', value: 'BANCO JOHN DEERE S.A.'},
        //   { code: '041', name: '041 - BANCO DO ESTADO DO RIO GRANDE DO SUL S.A', value: 'BANCO DO ESTADO DO RIO GRANDE DO SUL S.A'},
        //   { code: '117', name: '117 - SC ADVANCED', value: 'SC ADVANCED'},
        //   { code: '654', name: '654 - BANCO DIGIMAIS S.A.', value: 'BANCO DIGIMAIS S.A.'},
        //   { code: '371', name: '371 - WARREN CORRETORA DE VALORES MOBILIARIOS', value: 'WARREN CORRETORA DE VALORES MOBILIARIOS'},
        //   { code: '289', name: '289 - Decyseo Corretora de Cambio Ltda.', value: 'Decyseo Corretora de Cambio Ltda.'}
        // ];
        this.listBanks = [
            {
                code: '001',
                name: '001 - BANCO DO BRASIL',
                value: 'BANCO DO BRASIL',
                ispb: '00000000',
            },
            {
                code: '002',
                name: '002 - BANCO CENTRAL DO BRASIL',
                value: 'BANCO CENTRAL DO BRASIL',
                ispb: null,
            },
            {
                code: '003',
                name: '003 - BANCO DA AMAZONIA S.A',
                value: 'BANCO DA AMAZONIA S.A',
                ispb: '04902979',
            },
            {
                code: '004',
                name: '004 - BANCO DO NORDESTE DO BRASIL S.A',
                value: 'BANCO DO NORDESTE DO BRASIL S.A',
                ispb: '07237373',
            },
            {
                code: '007',
                name: '007 - BANCO NACIONAL DE DESENVOLVIMENTO ECONÔMICO E SOCIAL BNDES',
                value: 'BANCO NACIONAL DE DESENVOLVIMENTO ECONÔMICO E SOCIAL BNDES',
                ispb: '33657248',
            },
            {
                code: '008',
                name: '008 - BANCO MERIDIONAL DO BRASIL',
                value: 'BANCO MERIDIONAL DO BRASIL',
                ispb: null,
            },
            {
                code: '010',
                name: '010 - CREDICOAMO CRÉDITO RURAL COOPERATIVA',
                value: 'CREDICOAMO CRÉDITO RURAL COOPERATIVA',
                ispb: '81723108',
            },
            {
                code: '011',
                name: '011 - CREDIT SUISSE HEDGING-GRIFFO CORRETORA DE VALORES S.A.',
                value: 'CREDIT SUISSE HEDGING-GRIFFO CORRETORA DE VALORES S.A.',
                ispb: '61809182',
            },
            {
                code: '012',
                name: '012 - BANCO INBURSA S.A.',
                value: 'BANCO INBURSA S.A.',
                ispb: '04866275',
            },
            {
                code: '014',
                name: '014 - NATIXIS BRASIL S.A. BANCO MÚLTIPLO',
                value: 'NATIXIS BRASIL S.A. BANCO MÚLTIPLO',
                ispb: '09274232',
            },
            {
                code: '015',
                name: '015 - UBS BRASIL CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS S.A.',
                value: 'UBS BRASIL CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS S.A.',
                ispb: '02819125',
            },
            {
                code: '016',
                name: '016 - COOP DE CRÉD. MÚTUO DOS DESPACHANTES DE TRÂNSITO DE SC E RIO GRANDE DO SUL',
                value: 'COOP DE CRÉD. MÚTUO DOS DESPACHANTES DE TRÂNSITO DE SC E RIO GRANDE DO SUL',
                ispb: '04715685',
            },
            {
                code: '017',
                name: '017 - BNY MELLON BANCO S.A.',
                value: 'BNY MELLON BANCO S.A.',
                ispb: '42272526',
            },
            {
                code: '018',
                name: '018 - BANCO TRICURY S.A.',
                value: 'BANCO TRICURY S.A.',
                ispb: '57839805',
            },
            {
                code: '020',
                name: '020 - BANCO DO ESTADO DE ALAGOAS S.A',
                value: 'BANCO DO ESTADO DE ALAGOAS S.A',
                ispb: null,
            },
            {
                code: '021',
                name: '021 - BANESTES S.A. BANCO DO ESTADO DO ESPÍRITO SANTO',
                value: 'BANESTES S.A. BANCO DO ESTADO DO ESPÍRITO SANTO',
                ispb: '28127603',
            },
            {
                code: '022',
                name: '022 - BANCO DE CREDITO REAL DE MINAS GERAIS SA',
                value: 'BANCO DE CREDITO REAL DE MINAS GERAIS SA',
                ispb: null,
            },
            {
                code: '024',
                name: '024 - BANCO BANDEPE S.A.',
                value: 'BANCO BANDEPE S.A.',
                ispb: '10866788',
            },
            {
                code: '025',
                name: '025 - BANCO ALFA S.A.',
                value: 'BANCO ALFA S.A.',
                ispb: '03323840',
            },
            {
                code: '026',
                name: '026 - BANCO DO ESTADO DO ACRE S.A',
                value: 'BANCO DO ESTADO DO ACRE S.A',
                ispb: null,
            },
            {
                code: '027',
                name: '027 - BANCO DO ESTADO DE SANTA CATARINA S.A',
                value: 'BANCO DO ESTADO DE SANTA CATARINA S.A',
                ispb: null,
            },
            {
                code: '028',
                name: '028 - BANCO DO ESTADO DA BAHIA S.A',
                value: 'BANCO DO ESTADO DA BAHIA S.A',
                ispb: null,
            },
            {
                code: '029',
                name: '029 - BANCO ITAÚ CONSIGNADO S.A.',
                value: 'BANCO ITAÚ CONSIGNADO S.A.',
                ispb: '33885724',
            },
            {
                code: '030',
                name: '030 - BANCO DO ESTADO DA PARAIBA S.A',
                value: 'BANCO DO ESTADO DA PARAIBA S.A',
                ispb: null,
            },
            {
                code: '031',
                name: '031 - BANCO DO ESTADO DE GOIAS S.A',
                value: 'BANCO DO ESTADO DE GOIAS S.A',
                ispb: null,
            },
            {
                code: '032',
                name: '032 - BANCO DO ESTADO DO MATO GROSSO S.A.',
                value: 'BANCO DO ESTADO DO MATO GROSSO S.A.',
                ispb: null,
            },
            {
                code: '033',
                name: '033 - BANCO SANTANDER (BRASIL) S. A.',
                value: 'BANCO SANTANDER (BRASIL) S. A.',
                ispb: '90400888',
            },
            {
                code: '034',
                name: '034 - BANCO DO ESADO DO AMAZONAS S.A',
                value: 'BANCO DO ESADO DO AMAZONAS S.A',
                ispb: null,
            },
            {
                code: '035',
                name: '035 - BANCO DO ESTADO DO CEARA S.A',
                value: 'BANCO DO ESTADO DO CEARA S.A',
                ispb: null,
            },
            {
                code: '036',
                name: '036 - BANCO BRADESCO BBI S.A.',
                value: 'BANCO BRADESCO BBI S.A.',
                ispb: '06271464',
            },
            {
                code: '037',
                name: '037 - BANCO DO ESTADO DO PARÁ S.A.',
                value: 'BANCO DO ESTADO DO PARÁ S.A.',
                ispb: '04913711',
            },
            {
                code: '038',
                name: '038 - BANCO DO ESTADO DO PARANA S.A',
                value: 'BANCO DO ESTADO DO PARANA S.A',
                ispb: null,
            },
            {
                code: '039',
                name: '039 - BANCO DO ESTADO DO PIAUI S.A',
                value: 'BANCO DO ESTADO DO PIAUI S.A',
                ispb: null,
            },
            {
                code: '040',
                name: '040 - BANCO CARGILL S.A.',
                value: 'BANCO CARGILL S.A.',
                ispb: '03609817',
            },
            {
                code: '041',
                name: '041 - BANCO DO ESTADO DO RIO GRANDE DO SUL S.A.',
                value: 'BANCO DO ESTADO DO RIO GRANDE DO SUL S.A.',
                ispb: '92702067',
            },
            {
                code: '047',
                name: '047 - BANCO DO ESTADO DE SERGIPE S.A.',
                value: 'BANCO DO ESTADO DE SERGIPE S.A.',
                ispb: '13009717',
            },
            {
                code: '048',
                name: '048 - BANCO DO ESTADO DE MINAS GERAIS S.A',
                value: 'BANCO DO ESTADO DE MINAS GERAIS S.A',
                ispb: null,
            },
            {
                code: '059',
                name: '059 - BANCO DO ESTADO DE RONDONIA S.A',
                value: 'BANCO DO ESTADO DE RONDONIA S.A',
                ispb: null,
            },
            {
                code: '060',
                name: '060 - CONFIDENCE CORRETORA DE CÂMBIO S.A.',
                value: 'CONFIDENCE CORRETORA DE CÂMBIO S.A.',
                ispb: '04913129',
            },
            {
                code: '062',
                name: '062 - HIPERCARD BANCO MÚLTIPLO S.A.',
                value: 'HIPERCARD BANCO MÚLTIPLO S.A.',
                ispb: '03012230',
            },
            {
                code: '063',
                name: '063 - BANCO BRADESCARD S.A.',
                value: 'BANCO BRADESCARD S.A.',
                ispb: '04184779',
            },
            {
                code: '064',
                name: '064 - GOLDMAN SACHS DO BRASIL  BANCO MÚLTIPLO S. A.',
                value: 'GOLDMAN SACHS DO BRASIL  BANCO MÚLTIPLO S. A.',
                ispb: '04332281',
            },
            {
                code: '065',
                name: '065 - BANCO ANDBANK (BRASIL) S.A.',
                value: 'BANCO ANDBANK (BRASIL) S.A.',
                ispb: '48795256',
            },
            {
                code: '066',
                name: '066 - BANCO MORGAN STANLEY S. A.',
                value: 'BANCO MORGAN STANLEY S. A.',
                ispb: '02801938',
            },
            {
                code: '069',
                name: '069 - BANCO CREFISA S.A.',
                value: 'BANCO CREFISA S.A.',
                ispb: '61033106',
            },
            {
                code: '070',
                name: '070 - BANCO DE BRASÍLIA S.A.',
                value: 'BANCO DE BRASÍLIA S.A.',
                ispb: '00000208',
            },
            {
                code: '074',
                name: '074 - BANCO J. SAFRA S.A.',
                value: 'BANCO J. SAFRA S.A.',
                ispb: '03017677',
            },
            {
                code: '075',
                name: '075 - BANCO ABN AMRO S.A.',
                value: 'BANCO ABN AMRO S.A.',
                ispb: '03532415',
            },
            {
                code: '076',
                name: '076 - BANCO KDB DO BRASIL S.A.',
                value: 'BANCO KDB DO BRASIL S.A.',
                ispb: '07656500',
            },
            {
                code: '077',
                name: '077 - BANCO INTER S.A.',
                value: 'BANCO INTER S.A.',
                ispb: '00416968',
            },
            {
                code: '078',
                name: '078 - HAITONG BANCO DE INVESTIMENTO DO BRASIL S.A.',
                value: 'HAITONG BANCO DE INVESTIMENTO DO BRASIL S.A.',
                ispb: '34111187',
            },
            {
                code: '079',
                name: '079 - BANCO ORIGINAL DO AGRONEGÓCIO S.A.',
                value: 'BANCO ORIGINAL DO AGRONEGÓCIO S.A.',
                ispb: '09516419',
            },
            {
                code: '080',
                name: '080 - BT CORRETORA DE CÂMBIO LTDA.',
                value: 'BT CORRETORA DE CÂMBIO LTDA.',
                ispb: '73622748',
            },
            {
                code: '081',
                name: '081 - BBN BANCO BRASILEIRO DE NEGOCIOS S.A.',
                value: 'BBN BANCO BRASILEIRO DE NEGOCIOS S.A.',
                ispb: '10264663',
            },
            {
                code: '082',
                name: '082 - BANCO TOPAZIO S.A.',
                value: 'BANCO TOPAZIO S.A.',
                ispb: '07679404',
            },
            {
                code: '083',
                name: '083 - BANCO DA CHINA BRASIL S.A.',
                value: 'BANCO DA CHINA BRASIL S.A.',
                ispb: '10690848',
            },
            {
                code: '084',
                name: '084 - UNIPRIME NORTE DO PARANÁ - COOPERATIVA DE CRÉDITO LTDA.',
                value: 'UNIPRIME NORTE DO PARANÁ - COOPERATIVA DE CRÉDITO LTDA.',
                ispb: '02398976',
            },
            {
                code: '085',
                name: '085 - COOPERATIVA CENTRAL DE CREDITO - AILOS',
                value: 'COOPERATIVA CENTRAL DE CREDITO - AILOS',
                ispb: '05463212',
            },
            {
                code: '089',
                name: '089 - COOPERATIVA DE CRÉDITO RURAL DA REGIÃO DA MOGIANA',
                value: 'COOPERATIVA DE CRÉDITO RURAL DA REGIÃO DA MOGIANA',
                ispb: '62109566',
            },
            {
                code: '091',
                name: '091 - CENTRAL DE COOPERATIVAS DE ECONOMIA E CRÉDITO MÚTUO DO EST RS - UNICRED',
                value: 'CENTRAL DE COOPERATIVAS DE ECONOMIA E CRÉDITO MÚTUO DO EST RS - UNICRED',
                ispb: '01634601',
            },
            {
                code: '092',
                name: '092 - BRK S.A. CRÉDITO, FINANCIAMENTO E INVESTIMENTO',
                value: 'BRK S.A. CRÉDITO, FINANCIAMENTO E INVESTIMENTO',
                ispb: '12865507',
            },
            {
                code: '093',
                name: '093 - PÓLOCRED SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE',
                value: 'PÓLOCRED SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE',
                ispb: '07945233',
            },
            {
                code: '094',
                name: '094 - BANCO FINAXIS S.A.',
                value: 'BANCO FINAXIS S.A.',
                ispb: '11758741',
            },
            {
                code: '095',
                name: '095 - BANCO CONFIDENCE DE CÂMBIO S.A.',
                value: 'BANCO CONFIDENCE DE CÂMBIO S.A.',
                ispb: '11703662',
            },
            {
                code: '096',
                name: '096 - BANCO BMFBOVESPA DE SERVIÇOS DE LIQUIDAÇÃO E CUSTÓDIA S/A',
                value: 'BANCO BMFBOVESPA DE SERVIÇOS DE LIQUIDAÇÃO E CUSTÓDIA S/A',
                ispb: '00997185',
            },
            {
                code: '097',
                name: '097 - COOPERATIVA CENTRAL DE CRÉDITO NOROESTE BRASILEIRO LTDA - CENTRALCREDI',
                value: 'COOPERATIVA CENTRAL DE CRÉDITO NOROESTE BRASILEIRO LTDA - CENTRALCREDI',
                ispb: '04632856',
            },
            {
                code: '098',
                name: '098 - CREDIALIANÇA COOPERATIVA DE CRÉDITO RURAL',
                value: 'CREDIALIANÇA COOPERATIVA DE CRÉDITO RURAL',
                ispb: '78157146',
            },
            {
                code: '099',
                name: '099 - UNIPRIME CENTRAL – CENTRAL INTERESTADUAL DE COOPERATIVAS DE CRÉDITO LTDA.',
                value: 'UNIPRIME CENTRAL – CENTRAL INTERESTADUAL DE COOPERATIVAS DE CRÉDITO LTDA.',
                ispb: '03046391',
            },
            {
                code: '100',
                name: '100 - PLANNER CORRETORA DE VALORES S.A.',
                value: 'PLANNER CORRETORA DE VALORES S.A.',
                ispb: '00806535',
            },
            {
                code: '101',
                name: '101 - RENASCENÇA DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA.',
                value: 'RENASCENÇA DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA.',
                ispb: '62287735',
            },
            {
                code: '102',
                name: '102 - XP INVESTIMENTOS CORRETORA DE CÂMBIO TÍTULOS E VALORES MOBILIÁRIOS S.A.',
                value: 'XP INVESTIMENTOS CORRETORA DE CÂMBIO TÍTULOS E VALORES MOBILIÁRIOS S.A.',
                ispb: '02332886',
            },
            {
                code: '348',
                name: '348 - BANCO XP S.A.',
                value: 'BANCO XP S.A.',
                ispb: '33264668',
            },
            {
                code: '104',
                name: '104 - CAIXA ECONÔMICA FEDERAL',
                value: 'CAIXA ECONÔMICA FEDERAL',
                ispb: '00360305',
            },
            {
                code: '105',
                name: '105 - LECCA CRÉDITO, FINANCIAMENTO E INVESTIMENTO S/A',
                value: 'LECCA CRÉDITO, FINANCIAMENTO E INVESTIMENTO S/A',
                ispb: '07652226',
            },
            {
                code: '106',
                name: '106 - BANCO ITABANCO S.A.',
                value: 'BANCO ITABANCO S.A.',
                ispb: null,
            },
            {
                code: '107',
                name: '107 - BANCO BOCOM BBM S.A.',
                value: 'BANCO BOCOM BBM S.A.',
                ispb: '15114366',
            },
            {
                code: '108',
                name: '108 - PORTOCRED S.A. CRÉDITO, FINANCIAMENTO E INVESTIMENTO',
                value: 'PORTOCRED S.A. CRÉDITO, FINANCIAMENTO E INVESTIMENTO',
                ispb: '01800019',
            },
            {
                code: '109',
                name: '109 - BANCO CREDIBANCO S.A',
                value: 'BANCO CREDIBANCO S.A',
                ispb: null,
            },
            {
                code: '111',
                name: '111 - OLIVEIRA TRUST DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.',
                value: 'OLIVEIRA TRUST DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.',
                ispb: '36113876',
            },
            {
                code: '113',
                name: '113 - MAGLIANO S.A. CORRETORA DE CAMBIO E VALORES MOBILIARIOS',
                value: 'MAGLIANO S.A. CORRETORA DE CAMBIO E VALORES MOBILIARIOS',
                ispb: '61723847',
            },
            {
                code: '114',
                name: '114 - CENTRAL COOPERATIVA DE CRÉDITO NO ESTADO DO ESPÍRITO SANTO - CECOOP',
                value: 'CENTRAL COOPERATIVA DE CRÉDITO NO ESTADO DO ESPÍRITO SANTO - CECOOP',
                ispb: '05790149',
            },
            {
                code: '116',
                name: '116 - BANCO B.N.L DO BRASIL S.A',
                value: 'BANCO B.N.L DO BRASIL S.A',
                ispb: null,
            },
            {
                code: '117',
                name: '117 - ADVANCED CORRETORA DE CÂMBIO LTDA.',
                value: 'ADVANCED CORRETORA DE CÂMBIO LTDA.',
                ispb: '92856905',
            },
            {
                code: '118',
                name: '118 - STANDARD CHARTERED BANK (BRASIL) S.A. BANCO DE INVESTIMENTO',
                value: 'STANDARD CHARTERED BANK (BRASIL) S.A. BANCO DE INVESTIMENTO',
                ispb: null,
            },
            {
                code: '119',
                name: '119 - BANCO WESTERN UNION DO BRASIL S.A.',
                value: 'BANCO WESTERN UNION DO BRASIL S.A.',
                ispb: '13720915',
            },
            {
                code: '120',
                name: '120 - BANCO RODOBENS SA',
                value: 'BANCO RODOBENS SA',
                ispb: '33603457',
            },
            {
                code: '121',
                name: '121 - BANCO AGIBANK S.A.',
                value: 'BANCO AGIBANK S.A.',
                ispb: '10664513',
            },
            {
                code: '122',
                name: '122 - BANCO BRADESCO BERJ S.A.',
                value: 'BANCO BRADESCO BERJ S.A.',
                ispb: '33147315',
            },
            {
                code: '124',
                name: '124 - BANCO WOORI BANK DO BRASIL S.A.',
                value: 'BANCO WOORI BANK DO BRASIL S.A.',
                ispb: '15357060',
            },
            {
                code: '125',
                name: '125 - PLURAL S.A. BANCO MULTIPLO',
                value: 'PLURAL S.A. BANCO MULTIPLO',
                ispb: '45246410',
            },
            {
                code: '126',
                name: '126 - BR PARTNERS BANCO DE INVESTIMENTO S.A.',
                value: 'BR PARTNERS BANCO DE INVESTIMENTO S.A.',
                ispb: '13220493',
            },
            {
                code: '127',
                name: '127 - CODEPE CORRETORA DE VALORES E CÂMBIO S.A.',
                value: 'CODEPE CORRETORA DE VALORES E CÂMBIO S.A.',
                ispb: '09512542',
            },
            {
                code: '128',
                name: '128 - MS BANK S.A. BANCO DE CÂMBIO',
                value: 'MS BANK S.A. BANCO DE CÂMBIO',
                ispb: '19307785',
            },
            {
                code: '129',
                name: '129 - UBS BRASIL BANCO DE INVESTIMENTO S.A.',
                value: 'UBS BRASIL BANCO DE INVESTIMENTO S.A.',
                ispb: '18520834',
            },
            {
                code: '130',
                name: '130 - CARUANA S.A. SOCIEDADE DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO',
                value: 'CARUANA S.A. SOCIEDADE DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO',
                ispb: '09313766',
            },
            {
                code: '131',
                name: '131 - TULLETT PREBON BRASIL CORRETORA DE VALORES E CÂMBIO LTDA.',
                value: 'TULLETT PREBON BRASIL CORRETORA DE VALORES E CÂMBIO LTDA.',
                ispb: '61747085',
            },
            {
                code: '132',
                name: '132 - ICBC DO BRASIL BANCO MÚLTIPLO S.A.',
                value: 'ICBC DO BRASIL BANCO MÚLTIPLO S.A.',
                ispb: '17453575',
            },
            {
                code: '133',
                name: '133 - CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS DE CRÉDITO E ECONOMIA FAMILIAR E',
                value: 'CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS DE CRÉDITO E ECONOMIA FAMILIAR E',
                ispb: '10398952',
            },
            {
                code: '134',
                name: '134 - BGC LIQUIDEZ DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA.',
                value: 'BGC LIQUIDEZ DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA.',
                ispb: '33862244',
            },
            {
                code: '135',
                name: '135 - GRADUAL CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS S.A.',
                value: 'GRADUAL CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS S.A.',
                ispb: null,
            },
            {
                code: '136',
                name: '136 - CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS UNICRED LTDA – UNICRED DO BRASIL',
                value: 'CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS UNICRED LTDA – UNICRED DO BRASIL',
                ispb: '00315557',
            },
            {
                code: '137',
                name: '137 - MULTIMONEY CORRETORA DE CÂMBIO LTDA',
                value: 'MULTIMONEY CORRETORA DE CÂMBIO LTDA',
                ispb: null,
            },
            {
                code: '138',
                name: '138 - GET MONEY CORRETORA DE CÂMBIO S.A.',
                value: 'GET MONEY CORRETORA DE CÂMBIO S.A.',
                ispb: '10853017',
            },
            {
                code: '139',
                name: '139 - INTESA SANPAOLO BRASIL S.A. - BANCO MÚLTIPLO',
                value: 'INTESA SANPAOLO BRASIL S.A. - BANCO MÚLTIPLO',
                ispb: '55230916',
            },
            {
                code: '140',
                name: '140 - EASYNVEST - TÍTULO CORRETORA DE VALORES SA',
                value: 'EASYNVEST - TÍTULO CORRETORA DE VALORES SA',
                ispb: '62169875',
            },
            {
                code: '142',
                name: '142 - BROKER BRASIL CORRETORA DE CÂMBIO LTDA.',
                value: 'BROKER BRASIL CORRETORA DE CÂMBIO LTDA.',
                ispb: '16944141',
            },
            {
                code: '143',
                name: '143 - TREVISO CORRETORA DE CÂMBIO S.A.',
                value: 'TREVISO CORRETORA DE CÂMBIO S.A.',
                ispb: '02992317',
            },
            {
                code: '144',
                name: '144 - BEXS BANCO DE CÂMBIO S.A.',
                value: 'BEXS BANCO DE CÂMBIO S.A.',
                ispb: '13059145',
            },
            {
                code: '145',
                name: '145 - LEVYCAM - CORRETORA DE CÂMBIO E VALORES LTDA.',
                value: 'LEVYCAM - CORRETORA DE CÂMBIO E VALORES LTDA.',
                ispb: '50579044',
            },
            {
                code: '146',
                name: '146 - GUITTA CORRETORA DE CÂMBIO LTDA.',
                value: 'GUITTA CORRETORA DE CÂMBIO LTDA.',
                ispb: '24074692',
            },
            {
                code: '148',
                name: '148 - MULTI BANCO S.A',
                value: 'MULTI BANCO S.A',
                ispb: null,
            },
            {
                code: '149',
                name: '149 - FACTA FINANCEIRA S.A. - CRÉDITO FINANCIAMENTO E INVESTIMENTO',
                value: 'FACTA FINANCEIRA S.A. - CRÉDITO FINANCIAMENTO E INVESTIMENTO',
                ispb: '15581638',
            },
            {
                code: '151',
                name: '151 - CAIXA ECONOMICA DO ESTADO DE SAO PAULO',
                value: 'CAIXA ECONOMICA DO ESTADO DE SAO PAULO',
                ispb: null,
            },
            {
                code: '153',
                name: '153 - CAIXA ECONOMICA DO ESTADO DO R.G.SUL',
                value: 'CAIXA ECONOMICA DO ESTADO DO R.G.SUL',
                ispb: null,
            },
            {
                code: '157',
                name: '157 - ICAP DO BRASIL CORRETORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA.',
                value: 'ICAP DO BRASIL CORRETORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA.',
                ispb: '09105360',
            },
            {
                code: '159',
                name: '159 - CASA DO CRÉDITO S.A. SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR',
                value: 'CASA DO CRÉDITO S.A. SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR',
                ispb: '05442029',
            },
            {
                code: '163',
                name: '163 - COMMERZBANK BRASIL S.A. - BANCO MÚLTIPLO',
                value: 'COMMERZBANK BRASIL S.A. - BANCO MÚLTIPLO',
                ispb: '23522214',
            },
            {
                code: '165',
                name: '165 - BANCO NORCHEM S.A',
                value: 'BANCO NORCHEM S.A',
                ispb: null,
            },
            {
                code: '166',
                name: '166 - BANCO INTER-ATLANTICO S.A',
                value: 'BANCO INTER-ATLANTICO S.A',
                ispb: null,
            },
            {
                code: '168',
                name: '168 - BANCO C.C.F. BRASIL S.A',
                value: 'BANCO C.C.F. BRASIL S.A',
                ispb: null,
            },
            {
                code: '169',
                name: '169 - BANCO OLÉ BONSUCESSO CONSIGNADO S.A.',
                value: 'BANCO OLÉ BONSUCESSO CONSIGNADO S.A.',
                ispb: '71371686',
            },
            {
                code: '172',
                name: '172 - ALBATROSS CORRETORA DE CÂMBIO E VALORES S.A',
                value: 'ALBATROSS CORRETORA DE CÂMBIO E VALORES S.A',
                ispb: null,
            },
            {
                code: '173',
                name: '173 - BRL TRUST DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.',
                value: 'BRL TRUST DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.',
                ispb: '13486793',
            },
            {
                code: '174',
                name: '174 - PERNAMBUCANAS FINANCIADORA S.A. CRÉDITO, FINANCIAMENTO E INVESTIMENTO',
                value: 'PERNAMBUCANAS FINANCIADORA S.A. CRÉDITO, FINANCIAMENTO E INVESTIMENTO',
                ispb: '43180355',
            },
            {
                code: '175',
                name: '175 - CONTINENTAL BANCO S.A',
                value: 'CONTINENTAL BANCO S.A',
                ispb: null,
            },
            {
                code: '177',
                name: '177 - GUIDE INVESTIMENTOS S.A. CORRETORA DE VALORES',
                value: 'GUIDE INVESTIMENTOS S.A. CORRETORA DE VALORES',
                ispb: '65913436',
            },
            {
                code: '180',
                name: '180 - CM CAPITAL MARKETS CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS LTDA.',
                value: 'CM CAPITAL MARKETS CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS LTDA.',
                ispb: '02685483',
            },
            {
                code: '182',
                name: '182 - DACASA FINANCEIRA S/A - SOCIEDADE DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO',
                value: 'DACASA FINANCEIRA S/A - SOCIEDADE DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO',
                ispb: null,
            },
            {
                code: '183',
                name: '183 - SOCRED S.A. - SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR',
                value: 'SOCRED S.A. - SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR',
                ispb: '09210106',
            },
            {
                code: '184',
                name: '184 - BANCO ITAÚ BBA S.A.',
                value: 'BANCO ITAÚ BBA S.A.',
                ispb: '17298092',
            },
            {
                code: '188',
                name: '188 - ATIVA INVESTIMENTOS S.A. CORRETORA DE TÍTULOS CÂMBIO E VALORES',
                value: 'ATIVA INVESTIMENTOS S.A. CORRETORA DE TÍTULOS CÂMBIO E VALORES',
                ispb: '33775974',
            },
            {
                code: '189',
                name: '189 - HS FINANCEIRA S/A CRÉDITO, FINANCIAMENTO E INVESTIMENTOS',
                value: 'HS FINANCEIRA S/A CRÉDITO, FINANCIAMENTO E INVESTIMENTOS',
                ispb: '07512441',
            },
            {
                code: '190',
                name: '190 - COOPERATIVA DE ECONOMIA E CRÉDITO MÚTUO DOS SERVIDORES PÚBLICOS ESTADUAIS DO RIO',
                value: 'COOPERATIVA DE ECONOMIA E CRÉDITO MÚTUO DOS SERVIDORES PÚBLICOS ESTADUAIS DO RIO',
                ispb: '03973814',
            },
            {
                code: '191',
                name: '191 - NOVA FUTURA CORRETORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA.',
                value: 'NOVA FUTURA CORRETORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA.',
                ispb: '04257795',
            },
            {
                code: '194',
                name: '194 - PARMETAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA.',
                value: 'PARMETAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA.',
                ispb: '20155248',
            },
            {
                code: '196',
                name: '196 - FAIR CORRETORA DE CÂMBIO S.A.',
                value: 'FAIR CORRETORA DE CÂMBIO S.A.',
                ispb: '32648370',
            },
            {
                code: '197',
                name: '197 - STONE PAGAMENTOS S.A.',
                value: 'STONE PAGAMENTOS S.A.',
                ispb: '16501555',
            },
            {
                code: '199',
                name: '199 - BANCO FINANCIAL PORTUGUES',
                value: 'BANCO FINANCIAL PORTUGUES',
                ispb: null,
            },
            {
                code: '200',
                name: '200 - BANCO FRICRISA AXELRUD S.A',
                value: 'BANCO FRICRISA AXELRUD S.A',
                ispb: null,
            },
            {
                code: '201',
                name: '201 - BANCO AUGUSTA INDUSTRIA E COMERCIAL S.A',
                value: 'BANCO AUGUSTA INDUSTRIA E COMERCIAL S.A',
                ispb: null,
            },
            {
                code: '204',
                name: '204 - BANCO BRADESCO CARTÕES S.A.',
                value: 'BANCO BRADESCO CARTÕES S.A.',
                ispb: null,
            },
            {
                code: '205',
                name: '205 - BANCO SUL AMERICA S.A',
                value: 'BANCO SUL AMERICA S.A',
                ispb: null,
            },
            {
                code: '206',
                name: '206 - BANCO MARTINELLI S.A',
                value: 'BANCO MARTINELLI S.A',
                ispb: null,
            },
            {
                code: '208',
                name: '208 - BANCO BTG PACTUAL S.A.',
                value: 'BANCO BTG PACTUAL S.A.',
                ispb: '30306294',
            },
            {
                code: '210',
                name: '210 - DEUTSCH SUDAMERIKANICHE BANK AG',
                value: 'DEUTSCH SUDAMERIKANICHE BANK AG',
                ispb: null,
            },
            {
                code: '211',
                name: '211 - BANCO SISTEMA S.A',
                value: 'BANCO SISTEMA S.A',
                ispb: null,
            },
            {
                code: '212',
                name: '212 - BANCO ORIGINAL S.A.',
                value: 'BANCO ORIGINAL S.A.',
                ispb: '92894922',
            },
            {
                code: '213',
                name: '213 - BANCO ARBI S.A',
                value: 'BANCO ARBI S.A',
                ispb: '54403563',
            },
            {
                code: '214',
                name: '214 - BANCO DIBENS S.A',
                value: 'BANCO DIBENS S.A',
                ispb: null,
            },
            {
                code: '215',
                name: '215 - BANCO AMERICA DO SUL S.A',
                value: 'BANCO AMERICA DO SUL S.A',
                ispb: null,
            },
            {
                code: '216',
                name: '216 - BANCO REGIONAL MALCON S.A',
                value: 'BANCO REGIONAL MALCON S.A',
                ispb: null,
            },
            {
                code: '217',
                name: '217 - BANCO JOHN DEERE S.A.',
                value: 'BANCO JOHN DEERE S.A.',
                ispb: '91884981',
            },
            {
                code: '218',
                name: '218 - BANCO BS2 S.A.',
                value: 'BANCO BS2 S.A.',
                ispb: '71027866',
            },
            {
                code: '219',
                name: '219 - BANCO DE CREDITO DE SAO PAULO S.A',
                value: 'BANCO DE CREDITO DE SAO PAULO S.A',
                ispb: null,
            },
            {
                code: '220',
                name: '220 - BANCO CREFISUL',
                value: 'BANCO CREFISUL',
                ispb: null,
            },
            {
                code: '221',
                name: '221 - BANCO GRAPHUS S.A',
                value: 'BANCO GRAPHUS S.A',
                ispb: null,
            },
            {
                code: '222',
                name: '222 - BANCO CREDIT AGRÍCOLE BRASIL S.A.',
                value: 'BANCO CREDIT AGRÍCOLE BRASIL S.A.',
                ispb: '75647891',
            },
            {
                code: '223',
                name: '223 - BANCO INTERUNION S.A',
                value: 'BANCO INTERUNION S.A',
                ispb: null,
            },
            {
                code: '224',
                name: '224 - BANCO FIBRA S.A.',
                value: 'BANCO FIBRA S.A.',
                ispb: '58616418',
            },
            {
                code: '225',
                name: '225 - BANCO BRASCAN S.A',
                value: 'BANCO BRASCAN S.A',
                ispb: null,
            },
            {
                code: '228',
                name: '228 - BANCO ICATU S.A',
                value: 'BANCO ICATU S.A',
                ispb: null,
            },
            {
                code: '229',
                name: '229 - BANCO CRUZEIRO S.A',
                value: 'BANCO CRUZEIRO S.A',
                ispb: null,
            },
            {
                code: '230',
                name: '230 - BANCO BANDEIRANTES S.A',
                value: 'BANCO BANDEIRANTES S.A',
                ispb: null,
            },
            {
                code: '231',
                name: '231 - BANCO BOAVISTA S.A',
                value: 'BANCO BOAVISTA S.A',
                ispb: null,
            },
            {
                code: '232',
                name: '232 - BANCO INTERPART S.A',
                value: 'BANCO INTERPART S.A',
                ispb: null,
            },
            {
                code: '233',
                name: '233 - BANCO CIFRA S.A.',
                value: 'BANCO CIFRA S.A.',
                ispb: '62421979',
            },
            {
                code: '234',
                name: '234 - BANCO LAVRA S.A.',
                value: 'BANCO LAVRA S.A.',
                ispb: null,
            },
            {
                code: '235',
                name: '235 - BANCO LIBERAL S.A',
                value: 'BANCO LIBERAL S.A',
                ispb: null,
            },
            {
                code: '236',
                name: '236 - BANCO CAMBIAL S.A',
                value: 'BANCO CAMBIAL S.A',
                ispb: null,
            },
            {
                code: '237',
                name: '237 - BANCO BRADESCO S.A.',
                value: 'BANCO BRADESCO S.A.',
                ispb: '60746948',
            },
            {
                code: '239',
                name: '239 - BANCO BANCRED S.A',
                value: 'BANCO BANCRED S.A',
                ispb: null,
            },
            {
                code: '240',
                name: '240 - BANCO DE CREDITO REAL DE MINAS GERAIS S.',
                value: 'BANCO DE CREDITO REAL DE MINAS GERAIS S.',
                ispb: null,
            },
            {
                code: '241',
                name: '241 - BANCO CLÁSSICO S.A.',
                value: 'BANCO CLÁSSICO S.A.',
                ispb: '31597552',
            },
            {
                code: '242',
                name: '242 - BANCO EUROINVEST S.A',
                value: 'BANCO EUROINVEST S.A',
                ispb: null,
            },
            {
                code: '243',
                name: '243 - BANCO MÁXIMA S.A.',
                value: 'BANCO MÁXIMA S.A.',
                ispb: '33923798',
            },
            {
                code: '244',
                name: '244 - BANCO CIDADE S.A',
                value: 'BANCO CIDADE S.A',
                ispb: null,
            },
            {
                code: '245',
                name: '245 - BANCO EMPRESARIAL S.A',
                value: 'BANCO EMPRESARIAL S.A',
                ispb: null,
            },
            {
                code: '246',
                name: '246 - BANCO ABC BRASIL S.A.',
                value: 'BANCO ABC BRASIL S.A.',
                ispb: '28195667',
            },
            {
                code: '247',
                name: '247 - BANCO OMEGA S.A',
                value: 'BANCO OMEGA S.A',
                ispb: null,
            },
            {
                code: '249',
                name: '249 - BANCO INVESTCRED UNIBANCO S.A.',
                value: 'BANCO INVESTCRED UNIBANCO S.A.',
                ispb: '61182408',
            },
            {
                code: '250',
                name: '250 - BCV - BANCO DE CRÉDITO E VAREJO S/A',
                value: 'BCV - BANCO DE CRÉDITO E VAREJO S/A',
                ispb: '50585090',
            },
            {
                code: '251',
                name: '251 - BANCO SAO JORGE S.A.',
                value: 'BANCO SAO JORGE S.A.',
                ispb: null,
            },
            {
                code: '252',
                name: '252 - BANCO FININVEST S.A',
                value: 'BANCO FININVEST S.A',
                ispb: null,
            },
            {
                code: '253',
                name: '253 - BEXS CORRETORA DE CÂMBIO S/A',
                value: 'BEXS CORRETORA DE CÂMBIO S/A',
                ispb: '52937216',
            },
            {
                code: '254',
                name: '254 - PARANA BANCO S. A.',
                value: 'PARANA BANCO S. A.',
                ispb: '14388334',
            },
            {
                code: '255',
                name: '255 - MILBANCO S.A.',
                value: 'MILBANCO S.A.',
                ispb: null,
            },
            {
                code: '256',
                name: '256 - BANCO GULVINVEST S.A',
                value: 'BANCO GULVINVEST S.A',
                ispb: null,
            },
            {
                code: '258',
                name: '258 - BANCO INDUSCRED S.A',
                value: 'BANCO INDUSCRED S.A',
                ispb: null,
            },
            {
                code: '260',
                name: '260 - NU PAGAMENTOS S.A.',
                value: 'NU PAGAMENTOS S.A.',
                ispb: '18236120',
            },
            {
                code: '261',
                name: '261 - BANCO VARIG S.A',
                value: 'BANCO VARIG S.A',
                ispb: null,
            },
            {
                code: '262',
                name: '262 - BANCO BOREAL S.A',
                value: 'BANCO BOREAL S.A',
                ispb: null,
            },
            {
                code: '263',
                name: '263 - BANCO CACIQUE',
                value: 'BANCO CACIQUE',
                ispb: null,
            },
            {
                code: '264',
                name: '264 - BANCO PERFORMANCE S.A',
                value: 'BANCO PERFORMANCE S.A',
                ispb: null,
            },
            {
                code: '265',
                name: '265 - BANCO FATOR S.A',
                value: 'BANCO FATOR S.A',
                ispb: '33644196',
            },
            {
                code: '266',
                name: '266 - BANCO CEDULA S.A',
                value: 'BANCO CEDULA S.A',
                ispb: '33132044',
            },
            {
                code: '267',
                name: '267 - BANCO BBM-COM.C.IMOB.CFI S.A.',
                value: 'BANCO BBM-COM.C.IMOB.CFI S.A.',
                ispb: null,
            },
            {
                code: '268',
                name: '268 - BARIGUI COMPANHIA HIPOTECÁRIA',
                value: 'BARIGUI COMPANHIA HIPOTECÁRIA',
                ispb: '14511781',
            },
            {
                code: '269',
                name: '269 - HSBC BRASIL S.A. BANCO DE INVESTIMENTO',
                value: 'HSBC BRASIL S.A. BANCO DE INVESTIMENTO',
                ispb: '53518684',
            },
            {
                code: '271',
                name: '271 - NOVA IB CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS LTDA.',
                value: 'IB CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS LTDA.',
                ispb: '27842177',
            },
            {
                code: '274',
                name: '274 - MONEY PLUS SOCIEDADE DE CREDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORTE',
                value: 'Money Plus Sociedade de Credito ao Microempreendedor e a Empresa de Pequeno Porte',
                ispb: '11581339',
            },
            {
                code: '275',
                name: '275 - BANCO REAL S.A',
                value: 'BANCO REAL S.A',
                ispb: null,
            },
            {
                code: '277',
                name: '277 - BANCO PLANIBANC S.A',
                value: 'BANCO PLANIBANC S.A',
                ispb: null,
            },
            {
                code: '280',
                name: '280 - WILL FINANCEIRA S.A.CFI',
                value: 'WILL FINANCEIRA S.A.CFI',
                ispb: '23862762'
            },
            {
                code: '282',
                name: '282 - BANCO BRASILEIRO COMERCIAL',
                value: 'BANCO BRASILEIRO COMERCIAL',
                ispb: null,
            },
            {
                code: '290',
                name: '290 - PAGSEGURO INTERNET S.A.',
                value: 'PAGSEGURO INTERNET S.A.',
                ispb: '08561701',
            },
            {
                code: '291',
                name: '291 - BANCO DE CREDITO NACIONAL S.A',
                value: 'BANCO DE CREDITO NACIONAL S.A',
                ispb: null,
            },
            {
                code: '294',
                name: '294 - BCR - BANCO DE CREDITO REAL S.A',
                value: 'BCR - BANCO DE CREDITO REAL S.A',
                ispb: null,
            },
            {
                code: '295',
                name: '295 - BANCO CREDIPLAN S.A',
                value: 'BANCO CREDIPLAN S.A',
                ispb: null,
            },
            {
                code: '300',
                name: '300 - BANCO DE LA NACION ARGENTINA S.A',
                value: 'BANCO DE LA NACION ARGENTINA S.A',
                ispb: '33042151',
            },
            {
                code: '302',
                name: '302 - BANCO DO PROGRESSO S.A',
                value: 'BANCO DO PROGRESSO S.A',
                ispb: null,
            },
            {
                code: '303',
                name: '303 - BANCO HNF S.A.',
                value: 'BANCO HNF S.A.',
                ispb: null,
            },
            {
                code: '304',
                name: '304 - BANCO PONTUAL S.A',
                value: 'BANCO PONTUAL S.A',
                ispb: null,
            },
            {
                code: '308',
                name: '308 - BANCO COMERCIAL BANCESA S.A.',
                value: 'BANCO COMERCIAL BANCESA S.A.',
                ispb: null,
            },
            {
                code: '318',
                name: '318 - BANCO BMG S.A.',
                value: 'BANCO BMG S.A.',
                ispb: '61186680',
            },
            {
                code: '320',
                name: '320 - CHINA CONSTRUCTION BANK (BRASIL) BANCO MÚLTIPLO S/A',
                value: 'CHINA CONSTRUCTION BANK (BRASIL) BANCO MÚLTIPLO S/A',
                ispb: '07450604',
            },
            {
                code: '323',
                name: '323 - MERCADOPAGO.COM REPRESENTAÇÕES LTDA.',
                value: 'MERCADOPAGO.COM REPRESENTAÇÕES LTDA.',
                ispb: '10573521',
            },
            {
                code: '324',
                name: 'CARTOS SCD S.A.',
                value: '324 - CARTOS SCD S.A.',
                ispb: '21332862',
            },
            {
                code: '325',
                name: '325 - ÓRAMA DTVM S.A.',
                value: 'ÓRAMA DTVM S.A.',
                ispb: '13293225',
            },
            {
                code: '329',
                name: '329 - QI Sociedade de Crédito Direto S.A. ',
                value: 'QI Sociedade de Crédito Direto S.A. ',
                ispb: '32402502',
            },
            {
                code: '330',
                name: '330 - BANCO BARI DE INVESTIMENTOS E FINANCIAMENTOS S.A.',
                value: 'BANCO BARI DE INVESTIMENTOS E FINANCIAMENTOS S.A.',
                ispb: '00556603',
            },
            {
                code: '331',
                name: '331 - FRAM CAPITAL DTVM S.A',
                value: 'FRAM CAPITAL DTVM S.A',
                ispb: '13673855',
            },
            {
                code: '332',
                name: '332 - ACESSO SOLUÇÕES DE PAGAMENTOS S.A.',
                value: 'ACESSO SOLUÇÕES DE PAGAMENTOS S.A.',
                ispb: '13140088',
            },
            {
                code: '336',
                name: '336 - BANCO C6 S.A.',
                value: 'BANCO C6 S.A.',
                ispb: '31872495',
            },
            {
                code: '341',
                name: '341 - ITAÚ UNIBANCO  S.A.',
                value: 'ITAÚ UNIBANCO  S.A.',
                ispb: '60701190',
            },
            {
                code: '346',
                name: '346 - BANCO FRANCES E BRASILEIRO S.A',
                value: 'BANCO FRANCES E BRASILEIRO S.A',
                ispb: null,
            },
            {
                code: '347',
                name: '347 - BANCO SUDAMERIS BRASIL S.A',
                value: 'BANCO SUDAMERIS BRASIL S.A',
                ispb: null,
            },
            {
                code: '348',
                name: '348 - BANCO XP S.A.',
                value: 'BANCO XP S.A.',
                ispb: '33264668',
            },
            {
                code: '351',
                name: '351 - BANCO BOZANO SIMONSEN S.A',
                value: 'BANCO BOZANO SIMONSEN S.A',
                ispb: null,
            },
            {
                code: '353',
                name: '353 - BANCO GERAL DO COMERCIO S.A',
                value: 'BANCO GERAL DO COMERCIO S.A',
                ispb: null,
            },
            {
                code: '356',
                name: '356 - ABN AMRO S.A',
                value: 'ABN AMRO S.A',
                ispb: null,
            },
            {
                code: '363',
                name: '363 - SINGULARE CORRETORA DE TITULOS E VALORES',
                value: 'SINGULARE CORRETORA DE TITULOS E VALORES',
                ispb: '62285390',
            },
            {
                code: '366',
                name: '366 - BANCO SOCIÉTÉ GÉNÉRALE BRASIL S.A.',
                value: 'BANCO SOCIÉTÉ GÉNÉRALE BRASIL S.A.',
                ispb: '61533584',
            },
            {
                code: '367',
                name: '367 - VITREO DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A',
                value: 'VITREO DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A',
                ispb: '34711571'
            },
            {
                code: '369',
                name: '369 - PONTUAL',
                value: 'PONTUAL',
                ispb: null,
            },
            {
                code: '370',
                name: '370 - BANCO MIZUHO DO BRASIL S.A.',
                value: 'BANCO MIZUHO DO BRASIL S.A.',
                ispb: '61088183',
            },
            {
                code: '372',
                name: '372 - BANCO ITAMARATI S.A',
                value: 'BANCO ITAMARATI S.A',
                ispb: null,
            },
            {
                code: '375',
                name: '375 - BANCO FENICIA S.A',
                value: 'BANCO FENICIA S.A',
                ispb: null,
            },
            {
                code: '376',
                name: '376 - BANCO J. P. MORGAN S. A.',
                value: 'BANCO J. P. MORGAN S. A.',
                ispb: '33172537',
            },
            {
                code: '380',
                name: '380 - PICPAY',
                value: 'PICPAY SERVICOS S.A',
                ispb: '22896431'
            },
            {
                code: '388',
                name: '388 - BANCO MERCANTIL DE DESCONTOS S/A',
                value: 'BANCO MERCANTIL DE DESCONTOS S/A',
                ispb: null,
            },
            {
                code: '389',
                name: '389 - BANCO MERCANTIL DO BRASIL S.A.',
                value: 'BANCO MERCANTIL DO BRASIL S.A.',
                ispb: '17184037',
            },
            {
                code: '392',
                name: '392 - BANCO MERCANTIL DE SAO PAULO S.A',
                value: 'BANCO MERCANTIL DE SAO PAULO S.A',
                ispb: null,
            },
            {
                code: '394',
                name: '394 - BANCO BRADESCO FINANCIAMENTOS S.A.',
                value: 'BANCO BRADESCO FINANCIAMENTOS S.A.',
                ispb: '07207996',
            },
            {
                code: '399',
                name: '399 - KIRTON BANK S.A. - BANCO MÚLTIPLO',
                value: 'KIRTON BANK S.A. - BANCO MÚLTIPLO',
                ispb: '01701201',
            },
            {
                code: '403',
                name: '403 - CORA SOCIEDADE DE CRÉDITO DIRETO S.A.',
                value: 'CORA SOCIEDADE DE CRÉDITO DIRETO S.A.',
                ispb: '37880206',
            },
            {
                code: '409',
                name: '409 - UNIBANCO - UNIAO DOS BANCOS BRASILEIROS',
                value: 'UNIBANCO - UNIAO DOS BANCOS BRASILEIROS',
                ispb: null,
            },
            {
                code: '412',
                name: '412 - BANCO CAPITAL S. A.',
                value: 'BANCO CAPITAL S. A.',
                ispb: '15173776',
            },
            {
                code: '415',
                name: '415 - BANCO NACIONAL S.A',
                value: 'BANCO NACIONAL S.A',
                ispb: null,
            },
            {
                code: '420',
                name: '420 - BANCO NACIONAL DO NORTE S.A',
                value: 'BANCO NACIONAL DO NORTE S.A',
                ispb: null,
            },
            {
                code: '422',
                name: '422 - BANCO SAFRA S.A.',
                value: 'BANCO SAFRA S.A.',
                ispb: '58160789',
            },
            {
                code: '424',
                name: '424 - BANCO NOROESTE S.A',
                value: 'BANCO NOROESTE S.A',
                ispb: null,
            },
            {
                code: '434',
                name: '434 - BANCO FORTALEZA S.A',
                value: 'BANCO FORTALEZA S.A',
                ispb: null,
            },
            {
                code: ' ',
                name: 'LOGBANK SOLUÇÕES EM PAGAMENTOS S.A',
                value: 'LOGBANK SOLUÇÕES EM PAGAMENTOS S.A',
                ispb: '28505126',
            },
            {
                code: '453',
                name: '453 - BANCO RURAL S.A',
                value: 'BANCO RURAL S.A',
                ispb: null,
            },
            {
                code: '456',
                name: '456 - BANCO MUFG BRASIL S.A.',
                value: 'BANCO MUFG BRASIL S.A.',
                ispb: '60498557',
            },
            {
                code: '464',
                name: '464 - BANCO SUMITOMO MITSUI BRASILEIRO S.A.',
                value: 'BANCO SUMITOMO MITSUI BRASILEIRO S.A.',
                ispb: '60518222',
            },
            {
                code: '466',
                name: '466 - BANCO MITSUBISHI BRASILEIRO S.A',
                value: 'BANCO MITSUBISHI BRASILEIRO S.A',
                ispb: null,
            },
            {
                code: '472',
                name: '472 - LLOYDS BANK PLC',
                value: 'LLOYDS BANK PLC',
                ispb: null,
            },
            {
                code: '473',
                name: '473 - BANCO CAIXA GERAL - BRASIL S.A.',
                value: 'BANCO CAIXA GERAL - BRASIL S.A.',
                ispb: '33466988',
            },
            {
                code: '477',
                name: '477 - CITIBANK N.A.',
                value: 'CITIBANK N.A.',
                ispb: '33042953',
            },
            {
                code: '479',
                name: '479 - BANCO ITAUBANK S.A.',
                value: 'BANCO ITAUBANK S.A.',
                ispb: '60394079',
            },
            {
                code: '480',
                name: '480 - BANCO PORTUGUES DO ATLANTICO-BRASIL S.A',
                value: 'BANCO PORTUGUES DO ATLANTICO-BRASIL S.A',
                ispb: null,
            },
            {
                code: '483',
                name: '483 - BANCO AGRIMISA S.A.',
                value: 'BANCO AGRIMISA S.A.',
                ispb: null,
            },
            {
                code: '487',
                name: '487 - DEUTSCHE BANK S.A. - BANCO ALEMÃO',
                value: 'DEUTSCHE BANK S.A. - BANCO ALEMÃO',
                ispb: '62331228',
            },
            {
                code: '488',
                name: '488 - JPMORGAN CHASE BANK',
                value: 'JPMORGAN CHASE BANK',
                ispb: '46518205',
            },
            {
                code: '489',
                name: '489 - BANESTO BANCO URUGAUAY S.A',
                value: 'BANESTO BANCO URUGAUAY S.A',
                ispb: null,
            },
            {
                code: '492',
                name: '492 - ING BANK N.V.',
                value: 'ING BANK N.V.',
                ispb: '49336860',
            },
            {
                code: '493',
                name: '493 - BANCO UNION S.A.C.A',
                value: 'BANCO UNION S.A.C.A',
                ispb: null,
            },
            {
                code: '494',
                name: '494 - BANCO DE LA REPUBLICA ORIENTAL DEL URUGUAY',
                value: 'BANCO DE LA REPUBLICA ORIENTAL DEL URUGUAY',
                ispb: null,
            },
            {
                code: '495',
                name: '495 - BANCO DE LA PROVINCIA DE BUENOS AIRES',
                value: 'BANCO DE LA PROVINCIA DE BUENOS AIRES',
                ispb: '44189447',
            },
            {
                code: '496',
                name: '496 - BANCO EXTERIOR DE ESPANA S.A',
                value: 'BANCO EXTERIOR DE ESPANA S.A',
                ispb: null,
            },
            {
                code: '498',
                name: '498 - CENTRO HISPANO BANCO',
                value: 'CENTRO HISPANO BANCO',
                ispb: null,
            },
            {
                code: '499',
                name: '499 - BANCO IOCHPE S.A',
                value: 'BANCO IOCHPE S.A',
                ispb: null,
            },
            {
                code: '501',
                name: '501 - BANCO BRASILEIRO IRAQUIANO S.A.',
                value: 'BANCO BRASILEIRO IRAQUIANO S.A.',
                ispb: null,
            },
            {
                code: '502',
                name: '502 - BANCO SANTANDER DE NEGOCIOS S.A',
                value: 'BANCO SANTANDER DE NEGOCIOS S.A',
                ispb: null,
            },
            {
                code: '504',
                name: '504 - BANCO MULTIPLIC S.A',
                value: 'BANCO MULTIPLIC S.A',
                ispb: null,
            },
            {
                code: '505',
                name: '505 - BANCO CREDIT SUISSE (BRASIL) S.A.',
                value: 'BANCO CREDIT SUISSE (BRASIL) S.A.',
                ispb: '32062580',
            },
            {
                code: '509',
                name: '509 - CELCOIN INSTITUICAO DE PAGAMENTO S.A',
                value: 'CELCOIN INSTITUICAO DE PAGAMENTO S.A',
                ispb: '13935893',
            },
            {
                code: '526',
                name: '526 - MONETARIE SCD',
                value: 'MONETARIE SOCIEDADE DE CRÉDITO DIRETO S.A',
                ispb: '46026562',
            },
            {
                code: '545',
                name: '545 - SENSO CORRETORA DE CÂMBIO E VALORES MOBILIÁRIOS S.A.',
                value: 'SENSO CORRETORA DE CÂMBIO E VALORES MOBILIÁRIOS S.A.',
                ispb: '17352220',
            },
            {
                code: '600',
                name: '600 - BANCO LUSO BRASILEIRO S.A.',
                value: 'BANCO LUSO BRASILEIRO S.A.',
                ispb: '59118133',
            },
            {
                code: '601',
                name: '601 - BFC BANCO S.A.',
                value: 'BFC BANCO S.A.',
                ispb: null,
            },
            {
                code: '602',
                name: '602 - BANCO PATENTE S.A',
                value: 'BANCO PATENTE S.A',
                ispb: null,
            },
            {
                code: '604',
                name: '604 - BANCO INDUSTRIAL DO BRASIL S.A.',
                value: 'BANCO INDUSTRIAL DO BRASIL S.A.',
                ispb: '31895683',
            },
            {
                code: '607',
                name: '607 - BANCO SANTOS NEVES S.A',
                value: 'BANCO SANTOS NEVES S.A',
                ispb: null,
            },
            {
                code: '608',
                name: '608 - BANCO OPEN S.A',
                value: 'BANCO OPEN S.A',
                ispb: null,
            },
            {
                code: '610',
                name: '610 - BANCO VR S.A.',
                value: 'BANCO VR S.A.',
                ispb: '78626983',
            },
            {
                code: '611',
                name: '611 - BANCO PAULISTA S.A.',
                value: 'BANCO PAULISTA S.A.',
                ispb: '61820817',
            },
            {
                code: '612',
                name: '612 - BANCO GUANABARA S.A.',
                value: 'BANCO GUANABARA S.A.',
                ispb: '31880826',
            },
            {
                code: '613',
                name: '613 - OMNI BANCO S.A.',
                value: 'OMNI BANCO S.A.',
                ispb: '60850229',
            },
            {
                code: '616',
                name: '616 - BANCO INTERPACIFICO S.A',
                value: 'BANCO INTERPACIFICO S.A',
                ispb: null,
            },
            {
                code: '617',
                name: '617 - BANCO INVESTOR S.A.',
                value: 'BANCO INVESTOR S.A.',
                ispb: null,
            },
            {
                code: '618',
                name: '618 - BANCO TENDENCIA S.A',
                value: 'BANCO TENDENCIA S.A',
                ispb: null,
            },
            {
                code: '621',
                name: '621 - BANCO APLICAP S.A.',
                value: 'BANCO APLICAP S.A.',
                ispb: null,
            },
            {
                code: '622',
                name: '622 - BANCO DRACMA S.A',
                value: 'BANCO DRACMA S.A',
                ispb: null,
            },
            {
                code: '623',
                name: '623 - BANCO PAN S.A.',
                value: 'BANCO PAN S.A.',
                ispb: '59285411',
            },
            {
                code: '624',
                name: '624 - BANCO GENERAL MOTORS S.A',
                value: 'BANCO GENERAL MOTORS S.A',
                ispb: null,
            },
            {
                code: '625',
                name: '625 - BANCO ARAUCARIA S.A',
                value: 'BANCO ARAUCARIA S.A',
                ispb: null,
            },
            {
                code: '626',
                name: '626 - BANCO FICSA S. A.',
                value: 'BANCO FICSA S. A.',
                ispb: '61348538',
            },
            {
                code: '627',
                name: '627 - BANCO DESTAK S.A',
                value: 'BANCO DESTAK S.A',
                ispb: null,
            },
            {
                code: '628',
                name: '628 - BANCO CRITERIUM S.A',
                value: 'BANCO CRITERIUM S.A',
                ispb: null,
            },
            {
                code: '629',
                name: '629 - BANCORP BANCO COML. E. DE INVESTMENTO',
                value: 'BANCORP BANCO COML. E. DE INVESTMENTO',
                ispb: null,
            },
            {
                code: '630',
                name: '630 - BANCO INTERCAP S.A.',
                value: 'BANCO INTERCAP S.A.',
                ispb: '58497702',
            },
            {
                code: '633',
                name: '633 - BANCO RENDIMENTO S.A.',
                value: 'BANCO RENDIMENTO S.A.',
                ispb: '68900810',
            },
            {
                code: '634',
                name: '634 - BANCO TRIÂNGULO S.A.',
                value: 'BANCO TRIÂNGULO S.A.',
                ispb: '17351180',
            },
            {
                code: '635',
                name: '635 - BANCO DO ESTADO DO AMAPA S.A',
                value: 'BANCO DO ESTADO DO AMAPA S.A',
                ispb: null,
            },
            {
                code: '637',
                name: '637 - BANCO SOFISA S. A.',
                value: 'BANCO SOFISA S. A.',
                ispb: '60889128',
            },
            {
                code: '638',
                name: '638 - BANCO PROSPER S.A',
                value: 'BANCO PROSPER S.A',
                ispb: null,
            },
            {
                code: '639',
                name: '639 - BIG S.A. - BANCO IRMAOS GUIMARAES',
                value: 'BIG S.A. - BANCO IRMAOS GUIMARAES',
                ispb: null,
            },
            {
                code: '640',
                name: '640 - BANCO DE CREDITO METROPOLITANO S.A',
                value: 'BANCO DE CREDITO METROPOLITANO S.A',
                ispb: null,
            },
            {
                code: '641',
                name: '641 - BANCO ALVORADA S.A.',
                value: 'BANCO ALVORADA S.A.',
                ispb: null,
            },
            {
                code: '643',
                name: '643 - BANCO PINE S.A.',
                value: 'BANCO PINE S.A.',
                ispb: '62144175',
            },
            {
                code: '645',
                name: '645 - BANCO DO ESTADO DE RORAIMA S.A',
                value: 'BANCO DO ESTADO DE RORAIMA S.A',
                ispb: null,
            },
            {
                code: '647',
                name: '647 - BANCO MARKA S.A',
                value: 'BANCO MARKA S.A',
                ispb: null,
            },
            {
                code: '648',
                name: '648 - BANCO ATLANTIS S.A',
                value: 'BANCO ATLANTIS S.A',
                ispb: null,
            },
            {
                code: '649',
                name: '649 - BANCO DIMENSAO S.A',
                value: 'BANCO DIMENSAO S.A',
                ispb: null,
            },
            {
                code: '650',
                name: '650 - BANCO PEBB S.A',
                value: 'BANCO PEBB S.A',
                ispb: null,
            },
            {
                code: '652',
                name: '652 - ITAÚ UNIBANCO HOLDING S.A.',
                value: 'ITAÚ UNIBANCO HOLDING S.A.',
                ispb: '60872504',
            },
            {
                code: '653',
                name: '653 - BANCO INDUSVAL S. A.',
                value: 'BANCO INDUSVAL S. A.',
                ispb: '61024352',
            },
            {
                code: '654',
                name: '654 - BANCO A. J. RENNER S.A.',
                value: 'BANCO A. J. RENNER S.A.',
                ispb: '92874270',
            },
            {
                code: '655',
                name: '655 - BANCO VOTORANTIM S.A.',
                value: 'BANCO VOTORANTIM S.A.',
                ispb: '59588111',
            },
            {
                code: '656',
                name: '656 - BANCO MATRIX S.A',
                value: 'BANCO MATRIX S.A',
                ispb: null,
            },
            {
                code: '657',
                name: '657 - BANCO TECNICORP S.A',
                value: 'BANCO TECNICORP S.A',
                ispb: null,
            },
            {
                code: '658',
                name: '658 - BANCO PORTO REAL S.A',
                value: 'BANCO PORTO REAL S.A',
                ispb: null,
            },
            {
                code: '702',
                name: '702 - BANCO SANTOS S.A',
                value: 'BANCO SANTOS S.A',
                ispb: null,
            },
            {
                code: '705',
                name: '705 - BANCO INVESTCORP S.A.',
                value: 'BANCO INVESTCORP S.A.',
                ispb: null,
            },
            {
                code: '707',
                name: '707 - BANCO DAYCOVAL S.A.',
                value: 'BANCO DAYCOVAL S.A.',
                ispb: '62232889',
            },
            {
                code: '711',
                name: '711 - BANCO VETOR S.A.',
                value: 'BANCO VETOR S.A.',
                ispb: null,
            },
            {
                code: '712',
                name: '712 - BANCO OURINVEST S.A.',
                value: 'BANCO OURINVEST S.A.',
                ispb: '78632767',
            },
            {
                code: '713',
                name: '713 - BANCO CINDAM S.A',
                value: 'BANCO CINDAM S.A',
                ispb: null,
            },
            {
                code: '715',
                name: '715 - BANCO VEGA S.A',
                value: 'BANCO VEGA S.A',
                ispb: null,
            },
            {
                code: '718',
                name: '718 - BANCO OPERADOR S.A',
                value: 'BANCO OPERADOR S.A',
                ispb: null,
            },
            {
                code: '719',
                name: '719 - BANIF - BCO INTERNACIONAL DO FUNCHAL (BRASIL) S.A.',
                value: 'BANIF - BCO INTERNACIONAL DO FUNCHAL (BRASIL) S.A.',
                ispb: null,
            },
            {
                code: '720',
                name: '720 - BANCO MAXINVEST S.A',
                value: 'BANCO MAXINVEST S.A',
                ispb: null,
            },
            {
                code: '721',
                name: '721 - BANCO CREDIBEL S.A',
                value: 'BANCO CREDIBEL S.A',
                ispb: null,
            },
            {
                code: '722',
                name: '722 - BANCO INTERIOR DE SAO PAULO S.A',
                value: 'BANCO INTERIOR DE SAO PAULO S.A',
                ispb: null,
            },
            {
                code: '724',
                name: '724 - BANCO PORTO SEGURO S.A',
                value: 'BANCO PORTO SEGURO S.A',
                ispb: null,
            },
            {
                code: '725',
                name: '725 - BANCO FINABANCO S.A',
                value: 'BANCO FINABANCO S.A',
                ispb: null,
            },
            {
                code: '726',
                name: '726 - BANCO UNIVERSAL S.A',
                value: 'BANCO UNIVERSAL S.A',
                ispb: null,
            },
            {
                code: '728',
                name: '728 - BANCO FITAL S.A',
                value: 'BANCO FITAL S.A',
                ispb: null,
            },
            {
                code: '729',
                name: '729 - BANCO FONTE S.A',
                value: 'BANCO FONTE S.A',
                ispb: null,
            },
            {
                code: '730',
                name: '730 - BANCO COMERCIAL PARAGUAYO S.A',
                value: 'BANCO COMERCIAL PARAGUAYO S.A',
                ispb: null,
            },
            {
                code: '731',
                name: '731 - BANCO GNPP S.A.',
                value: 'BANCO GNPP S.A.',
                ispb: null,
            },
            {
                code: '732',
                name: '732 - BANCO PREMIER S.A.',
                value: 'BANCO PREMIER S.A.',
                ispb: null,
            },
            {
                code: '733',
                name: '733 - BANCO NACOES S.A.',
                value: 'BANCO NACOES S.A.',
                ispb: null,
            },
            {
                code: '734',
                name: '734 - BANCO GERDAU S.A',
                value: 'BANCO GERDAU S.A',
                ispb: null,
            },
            {
                code: '735',
                name: '735 - BANCO NEON S.A.',
                value: 'BANCO NEON S.A.',
                ispb: null,
            },
            {
                code: '736',
                name: '736 - BANCO UNITED S.A',
                value: 'BANCO UNITED S.A',
                ispb: null,
            },
            {
                code: '737',
                name: '737 - THECA',
                value: 'THECA',
                ispb: null,
            },
            {
                code: '738',
                name: '738 - MARADA',
                value: 'MARADA',
                ispb: null,
            },
            {
                code: '739',
                name: '739 - BANCO CETELEM S.A.',
                value: 'BANCO CETELEM S.A.',
                ispb: '00558456',
            },
            {
                code: '740',
                name: '740 - BCN BARCLAYS',
                value: 'BCN BARCLAYS',
                ispb: null,
            },
            {
                code: '741',
                name: '741 - BANCO RIBEIRÃO PRETO S.A.',
                value: 'BANCO RIBEIRÃO PRETO S.A.',
                ispb: '00517645',
            },
            {
                code: '742',
                name: '742 - EQUATORIAL',
                value: 'EQUATORIAL',
                ispb: null,
            },
            {
                code: '743',
                name: '743 - BANCO SEMEAR S.A.',
                value: 'BANCO SEMEAR S.A.',
                ispb: '00795423',
            },
            {
                code: '744',
                name: '744 - THE FIRST NATIONAL BANK OF BOSTON',
                value: 'THE FIRST NATIONAL BANK OF BOSTON',
                ispb: null,
            },
            {
                code: '745',
                name: '745 - BANCO CITIBANK S.A.',
                value: 'BANCO CITIBANK S.A.',
                ispb: '33479023',
            },
            {
                code: '746',
                name: '746 - BANCO MODAL S.A.',
                value: 'BANCO MODAL S.A.',
                ispb: '30723886',
            },
            {
                code: '747',
                name: '747 - BANCO RABOBANK INTERNATIONAL BRASIL S.A.',
                value: 'BANCO RABOBANK INTERNATIONAL BRASIL S.A.',
                ispb: '01023570',
            },
            {
                code: '748',
                name: '748 - BANCO COOPERATIVO SICREDI S. A.',
                value: 'BANCO COOPERATIVO SICREDI S. A.',
                ispb: '01181521',
            },
            {
                code: '749',
                name: '749 - BRMSANTIL SA',
                value: 'BRMSANTIL SA',
                ispb: null,
            },
            {
                code: '750',
                name: '750 - BANCO REPUBLIC NATIONAL OF NEW YORK (BRA',
                value: 'BANCO REPUBLIC NATIONAL OF NEW YORK (BRA',
                ispb: null,
            },
            {
                code: '751',
                name: '751 - SCOTIABANK BRASIL S.A. BANCO MÚLTIPLO',
                value: 'SCOTIABANK BRASIL S.A. BANCO MÚLTIPLO',
                ispb: '29030467',
            },
            {
                code: '752',
                name: '752 - BANCO BNP PARIBAS BRASIL S.A.',
                value: 'BANCO BNP PARIBAS BRASIL S.A.',
                ispb: '01522368',
            },
            {
                code: '753',
                name: '753 - NOVO BANCO CONTINENTAL S.A. - BANCO MÚLTIPLO',
                value: 'NOVO BANCO CONTINENTAL S.A. - BANCO MÚLTIPLO',
                ispb: '74828799',
            },
            {
                code: '754',
                name: '754 - BANCO SISTEMA S.A.',
                value: 'BANCO SISTEMA S.A.',
                ispb: '76543115',
            },
            {
                code: '755',
                name: '755 - BANK OF AMERICA MERRILL LYNCH BANCO MÚLTIPLO S.A.',
                value: 'BANK OF AMERICA MERRILL LYNCH BANCO MÚLTIPLO S.A.',
                ispb: '62073200',
            },
            {
                code: '756',
                name: '756 - BANCO COOPERATIVO DO BRASIL S/A - BANCOOB',
                value: 'BANCO COOPERATIVO DO BRASIL S/A - BANCOOB',
                ispb: '02038232',
            },
            {
                code: '757',
                name: '757 - BANCO KEB HANA DO BRASIL S. A.',
                value: 'BANCO KEB HANA DO BRASIL S. A.',
                ispb: '02318507',
            },
            {
                code: '301',
                name: '301 - DOCK IP S.A.',
                value: 'DOCK IP S.A.',
                ispb: '13370835',
            },
            {
                code: '439',
                name: '439 - ID BANCO DIGITAL',
                value: 'ID BANCO DIGITAL',
                ispb: '16695922',
            },
            {
                code: '439',
                name: '439 - ID BANCO DIGITAL',
                value: 'ID BANCO DIGITAL',
                ispb: '16695922'
            },
            {
                code: '301',
                name: '301 - BPP Instituicao de Pagamento S.A.',
                value: 'BPP Instituicao de Pagamento S.A.',
                ispb: '13370835'
            },
            {
                code: '509',
                name: '509 - CELCOIN PAGAMENTOS',
                value: 'CELCOIN PAGAMENTOS',
                ispb: '13935893'
            },
            {
                code: '324',
                name: '324 - CARTOS SCD S.A.',
                value: 'CARTOS SCD S.A.',
                ispb: '21332862'
            }
        ];
    }
    /**
     * @description Método retorna a lista de bancos
     */
    getBankList() {
        return this.listBanks;
    }
    /**
     * @description Método retorna a lista de bancos que tenha ispb
     */
    getBankListWithIspb() {
        return this.listBanks.filter((bank) => bank.ispb !== null);
    }
    /**
     * @description Método retorna o nome do banco pelo código
     */
    filterListBank(value) {
        const result = this.listBanks.filter((item) => {
            return item.code === value;
        });
        return result[0].name;
    }
};
BanksService = __decorate([
    Injectable()
], BanksService);

let Base64Service = class Base64Service {
    convertFileToBase64(file) {
        return new Promise(resolve => {
            const reader = new FileReader();
            // Read file content on file loaded event
            reader.onload = function (event) {
                resolve(event.target.result);
            };
            // Convert data to base64
            reader.readAsDataURL(file);
        });
    }
    b64toBlob(base64) {
        let block = base64.split(";");
        let contentType = block[0].split(":")[1];
        let b64Data = block[1].split(",")[1];
        contentType = contentType || '';
        let sliceSize = 512;
        let byteCharacters = atob(b64Data);
        let byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);
            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        let blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
};
Base64Service = __decorate([
    Injectable()
], Base64Service);

let CertifiedService = class CertifiedService {
    constructor() {
        this.listCertified = [
            { 'name': 'AMB', 'value': 'AMB' },
            { 'name': 'CAU', 'value': 'CAU' },
            { 'name': 'CBOO', 'value': 'CBOO' },
            { 'name': 'CFA', 'value': 'CFA' },
            { 'name': 'CFB', 'value': 'CFB' },
            { 'name': 'CFBIO', 'value': 'CFBIO' },
            { 'name': 'CFBM', 'value': 'CFBM' },
            { 'name': 'CFC', 'value': 'CFC' },
            { 'name': 'CFE', 'value': 'CFE' },
            { 'name': 'CFESS', 'value': 'CFESS' },
            { 'name': 'CFF', 'value': 'CFF' },
            { 'name': 'CFM', 'value': 'CFM' },
            { 'name': 'CFMV', 'value': 'CFMV' },
            { 'name': 'CFO', 'value': 'CFO' },
            { 'name': 'CFP', 'value': 'CFP' },
            { 'name': 'CFQ', 'value': 'CFQ' },
            { 'name': 'COFECI', 'value': 'COFECI' },
            { 'name': 'COFEM', 'value': 'COFEM' },
            { 'name': 'COFEN', 'value': 'COFEN' },
            { 'name': 'COFFITO', 'value': 'COFFITO' },
            { 'name': 'CONFEA', 'value': 'CONFEA' },
            { 'name': 'CONFEF', 'value': 'CONFEF' },
            { 'name': 'CONFERE', 'value': 'CONFERE' },
            { 'name': 'CONFERP', 'value': 'CONFERP' },
            { 'name': 'CORE', 'value': 'CORE' },
            { 'name': 'COREM', 'value': 'COREM' },
            { 'name': 'COREN', 'value': 'COREN' },
            { 'name': 'CRA', 'value': 'CRA' },
            { 'name': 'CRB', 'value': 'CRB' },
            { 'name': 'CRBIO', 'value': 'CRBIO' },
            { 'name': 'CRC', 'value': 'CRC' },
            { 'name': 'CRE', 'value': 'CRE' },
            { 'name': 'CREA', 'value': 'CREA' },
            { 'name': 'CRECI', 'value': 'CRECI' },
            { 'name': 'CREF', 'value': 'CREF' },
            { 'name': 'CREFITO', 'value': 'CREFITO' },
            { 'name': 'CREFONO', 'value': 'CREFONO' },
            { 'name': 'CRESS', 'value': 'CRESS' },
            { 'name': 'CRF', 'value': 'CRF' },
            { 'name': 'CRFA', 'value': 'CRFA' },
            { 'name': 'CRFM', 'value': 'CRFM' },
            { 'name': 'CRM', 'value': 'CRM' },
            { 'name': 'CRMV', 'value': 'CRMV' },
            { 'name': 'CRO', 'value': 'CRO' },
            { 'name': 'CRP', 'value': 'CRP' },
            { 'name': 'CRQ', 'value': 'CRQ' },
            { 'name': 'CRRP', 'value': 'CRRP' },
            { 'name': 'OAB', 'value': 'OAB' },
            { 'name': 'OMB', 'value': 'OMB' },
            { 'name': 'SBF', 'value': 'SBF' }
        ];
    }
    getListCertified() {
        return this.listCertified;
    }
};
CertifiedService = __decorate([
    Injectable()
], CertifiedService);

// import { Injectable } from "@angular/core";
let CreditCardFlagService = class CreditCardFlagService {
    constructor() {
        this.pathImage = 'assets/images/cards/';
    }
    getImageFlag(numberCard) {
        // Visa
        if (numberCard.startsWith('4')) {
            return this.pathImage + 'VisaLogo.png';
        }
        // MasterCard
        if (numberCard.startsWith('5')) {
            return this.pathImage + 'MastercardLogo.png';
        }
        // Dinners Club
        if (numberCard.startsWith('36') || numberCard.startsWith('38')) {
            return this.pathImage + 'DinersLogo.png';
        }
        // Discover
        if (numberCard.startsWith('6')) {
            return this.pathImage + 'DiscoverLogo.png';
        }
        // JCB
        if (numberCard.startsWith('35')) {
            return this.pathImage + 'JCBLogo.png';
        }
        // American Express
        if (numberCard.startsWith('34') || numberCard.startsWith('37')) {
            return this.pathImage + 'AmericanLogo.png';
        }
        return '';
    }
    getImageFlagForName(nameCard) {
        // Visa
        if (nameCard.toLowerCase().includes('visa')) {
            return this.pathImage + 'VisaLogo.png';
        }
        // MasterCard
        if (nameCard.toLowerCase().includes('master')) {
            return this.pathImage + 'MastercardLogo.png';
        }
        // Dinners Club
        if (nameCard.toLowerCase().includes('diner')) {
            return this.pathImage + 'DinersLogo.png';
        }
        // Discover
        if (nameCard.toLowerCase().includes('discover')) {
            return this.pathImage + 'DiscoverLogo.png';
        }
        // JCB
        if (nameCard.toLowerCase().includes('jcb')) {
            return this.pathImage + 'JCBLogo.png';
        }
        // American Express
        if (nameCard.toLowerCase().includes('american')) {
            return this.pathImage + 'AmericanLogo.png';
        }
        return '';
    }
    getNameFlag(numberCard) {
        // Visa
        if (numberCard.startsWith('4')) {
            return 'visa';
        }
        // MasterCard
        if (numberCard.startsWith('5')) {
            return 'mastercard';
        }
        // Dinners Club
        if (numberCard.startsWith('36') || numberCard.startsWith('38')) {
            return 'dinersLogo';
        }
        // Discover
        if (numberCard.startsWith('6')) {
            return 'discover';
        }
        // JCB
        if (numberCard.startsWith('35')) {
            return 'jcb';
        }
        // American Express
        if (numberCard.startsWith('34') || numberCard.startsWith('37')) {
            return 'american';
        }
        return '';
    }
};
CreditCardFlagService = __decorate([
    Injectable()
], CreditCardFlagService);
//   getName(idFlagCard: any): string {
//     let name: string = '';
//     switch (idFlagCard) {
//       case '09d6f305-a199-44ee-a50a-a1b636862b7a-1558656086000':
//       case 1: name = 'Amex';
//         break;
//       case '35d28aad-13eb-4c38-aa38-6fca442e058b-1558656086000':
//       case 2: name = 'Aura';
//         break;
//       case '4f297b30-7a77-4f2b-9afc-83d683bc0729-1558656086000':
//       case 3: name = 'Diners';
//         break;
//       case '9898e57f-b1b8-4c80-bc86-701dd746e40c-1558656086000':
//       case 4: name = 'Discover';
//         break;
//       case 'ee6bfbf4-2088-4aeb-81d2-78e8050fae90-1558656086000':
//       case 5: name = 'Elo';
//         break;
//       case '59a8b499-7a08-4445-bb97-e87a5dd11ba4-1558656086000':
//       case 6: name = 'Hipercard';
//         break;
//       case '70c4e0e6-1236-4b84-9c68-b78441d922b3-1558656086000':
//       case 7: name = 'Master';
//         break;
//       case 'e7f41faf-e68a-421a-b62a-0f1f239b84ab-1558656086000':
//       case 8: name = 'JCB';
//         break;
//       case '2c8a50b0-0dd4-4530-9543-43645453db74-1558656086000':
//       case 9: name = 'Visa';
//         break;
//     }
//     return name;
//   }
//   getImageFlag(idFlagCard: any): string {
//     let image: string = '';
//     switch (idFlagCard) {
//       case '09d6f305-a199-44ee-a50a-a1b636862b7a-1558656086000':
//       case 1: image = this.pathImage + 'AmericanLogo.png';
//         break;
//       case '35d28aad-13eb-4c38-aa38-6fca442e058b-1558656086000':
//       case 2: image = this.pathImage + 'AuraLogo.png';
//         break;
//       case '4f297b30-7a77-4f2b-9afc-83d683bc0729-1558656086000':
//       case 3: image = this.pathImage + 'DinersLogo.png';
//         break;
//       case '9898e57f-b1b8-4c80-bc86-701dd746e40c-1558656086000':
//       case 4: image = this.pathImage + 'DiscoverLogo.png';
//         break;
//       case 'ee6bfbf4-2088-4aeb-81d2-78e8050fae90-1558656086000':
//       case 5: image = this.pathImage + 'EloLogo.png';
//         break;
//       case '59a8b499-7a08-4445-bb97-e87a5dd11ba4-1558656086000':
//       case 6: image = this.pathImage + 'HipercardLogo.png';
//         break;
//       case '70c4e0e6-1236-4b84-9c68-b78441d922b3-1558656086000':
//       case 7: image = this.pathImage + 'MastercardLogo.png';
//         break;
//       case 'e7f41faf-e68a-421a-b62a-0f1f239b84ab-1558656086000':
//       case 8: image = this.pathImage + 'JCBLogo.png';
//         break;
//       case '2c8a50b0-0dd4-4530-9543-43645453db74-1558656086000':
//       case 9: image = this.pathImage + 'VisaLogo.png';
//         break;
//       default: image = this.pathImage + 'Card.png';
//     }
//     return image;
//   }
//   getImageFlagRectangular(idFlagCard: any): string {
//     let image: string = '';
//     switch (idFlagCard) {
//       case '09d6f305-a199-44ee-a50a-a1b636862b7a-1558656086000':
//       case 1: image = this.pathImage + 'AmericanLogof.png';
//         break;
//       case '35d28aad-13eb-4c38-aa38-6fca442e058b-1558656086000':
//       case 2: image = this.pathImage + 'AuraLogof.png';
//         break;
//       case '4f297b30-7a77-4f2b-9afc-83d683bc0729-1558656086000':
//       case 3: image = this.pathImage + 'DinersLogof.png';
//         break;
//       case '9898e57f-b1b8-4c80-bc86-701dd746e40c-1558656086000':
//       case 4: image = this.pathImage + 'DiscoverLogof.png';
//         break;
//       case 'ee6bfbf4-2088-4aeb-81d2-78e8050fae90-1558656086000':
//       case 5: image = this.pathImage + 'EloLogof.png';
//         break;
//       case '59a8b499-7a08-4445-bb97-e87a5dd11ba4-1558656086000':
//       case 6: image = this.pathImage + 'HipercardLogof.png';
//         break;
//       case '70c4e0e6-1236-4b84-9c68-b78441d922b3-1558656086000':
//       case 7: image = this.pathImage + 'MastercardLogof.png';
//         break;
//       case 'e7f41faf-e68a-421a-b62a-0f1f239b84ab-1558656086000':
//       case 8: image = this.pathImage + 'JCBLogof.png';
//         break;
//       case '2c8a50b0-0dd4-4530-9543-43645453db74-1558656086000':
//       case 9: image = this.pathImage + 'VisaLogof.png';
//         break;
//       default: image = this.pathImage + 'Card.png';
//     }
//     return image;
//   }
// }

let ErrorMessageService = class ErrorMessageService {
    constructor() {
    }
    getError(error) {
        console.error('WLP001', error);
        console.error('WLP001:', !!error.message ? error.message : '', 'NAME:', !!error.name ? error.name : '', 'CODE:', !!error.status ? error.status : '', 'STATUS_TEXT:', !!error.statusText ? error.statusText : '');
    }
};
ErrorMessageService = __decorate([
    Injectable()
], ErrorMessageService);

const API_LINK = 'https://api.ipify.org/?format=json';
let IpService = class IpService {
    constructor(http) {
        this.http = http;
    }
    getIPAddress() {
        return this.http.get(API_LINK);
    }
};
IpService.ctorParameters = () => [
    { type: HttpClient }
];
IpService.ngInjectableDef = ɵɵdefineInjectable({ factory: function IpService_Factory() { return new IpService(ɵɵinject(HttpClient)); }, token: IpService, providedIn: "root" });
IpService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], IpService);

let MaskService = class MaskService {
    constructor(currencyPipe) {
        this.currencyPipe = currencyPipe;
    }
    currency(controlName, form, decimalCount = 2, decimal = ',', thousands = '.') {
        try {
            let amount = form.controls[controlName].value;
            if (amount) {
                amount = amount.replace('.', '');
                amount = amount.replace('R', '');
                amount = amount.replace('$', '');
                amount = amount.replace(',', '.');
                amount = amount.replace(/^0+/, '');
            }
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
            const negativeSign = Number(amount) < 0 ? '-' : '';
            const i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
            const j = i.length > 3 ? i.length % 3 : 0;
            const iptFormat = negativeSign +
                (j ? i.substr(0, j) + thousands : '') +
                i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
                (decimalCount
                    ? decimal +
                        Math.abs(Number(amount) - Number(i))
                            .toFixed(decimalCount)
                            .slice(2)
                    : '');
            form.patchValue({ [controlName]: iptFormat });
            form.controls[controlName].setErrors(null);
        }
        catch (e) {
            // console.log(e);
        }
    }
    currency3(controlName, form, typeCurrency, display = true) {
        let ipt = form.controls[controlName].value;
        if (ipt) {
            ipt = ipt.replace('.', '');
            ipt = ipt.replace('R', '');
            ipt = ipt.replace('$', '');
            ipt = ipt.replace(',', '.');
            ipt = ipt.replace(/^0+/, '');
        }
        const currencyPipe = new CurrencyPipe('pt');
        const iptFormat = currencyPipe.transform(ipt, typeCurrency.toString(), display);
        // iptFormat = iptFormat.split(' ')[1].replace(/^0+/, ''); // remove zero left
        form.patchValue({ [controlName]: iptFormat });
        form.controls[controlName].setErrors(null);
    }
    currency2(controlName, form) {
        let ipt = form.controls[controlName].value;
        ipt = ipt.replace('.', '');
        ipt = ipt.replace(/\D+/g, '');
        ipt = ipt.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        ipt = `R$ ${ipt}`;
        form.patchValue({ [controlName]: ipt });
        form.controls[controlName].setErrors(null);
    }
    /**
     * Mascara para remover o '0' a esquerda e retorna uma string formatada
     */
    formatValueMoney(value) {
        let newValue = value.replace('.', '').replace(/^0+/, '');
        newValue = newValue.replace('.', '').replace(',', '.');
        // @ts-ignore
        newValue = Number(newValue).toLocaleString('pt-br', { minimumFractionDigits: 2 });
        return String(newValue);
    }
    /**
     * Máscara para retornar uma string no formato de CPF ou CNPJ
     */
    formatCnpjCpf(value) {
        const cnpjCpf = value.replace(/\D/g, '');
        if (cnpjCpf.length === 11) {
            return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
        }
        return cnpjCpf.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
    }
    /**
     * Máscara retorna uma string em formato Conta com digito
     */
    formatAccountBank(digit) {
        let account = '';
        const count = digit.length;
        const penultimate = count - 2;
        for (let i = 0; i < count; i++) {
            account += digit[i];
            if (i == penultimate) {
                account += '-';
            }
        }
        return account;
    }
    /**
     * Mascara recebe um float e retorna uma string com o valor em Real BRL
     */
    formatValueBRL(totalPay) {
        const value = parseFloat(String(totalPay));
        try {
            return this.currencyPipe.transform(value, 'BRL').replace('R$', '');
        }
        catch (err) {
            console.warn('It was not possible to treat the values. Data does not exist!');
            return '';
        }
    }
};
MaskService.ctorParameters = () => [
    { type: CurrencyPipe }
];
MaskService = __decorate([
    Injectable()
], MaskService);

let PartnerIndustriesService = class PartnerIndustriesService {
    constructor() {
        this.listIndustries = [
            { 'name': 'Alimentos e Bebidas', 'value': 'Alimentos e Bebidas' },
            { 'name': 'Arte e Antiguidades', 'value': 'Arte e Antiguidades' },
            { 'name': 'Artigos Religiosos', 'value': 'Artigos Religiosos' },
            { 'name': 'Assinaturas e Revistas', 'value': 'Assinaturas e Revistas' },
            { 'name': 'Automóveis e Veículos', 'value': 'Automóveis e Veículos' },
            { 'name': 'Bebês e Cia', 'value': 'Bebês e Cia' },
            { 'name': 'Blu-Ray', 'value': 'Blu-Ray' },
            { 'name': 'Brindes / Materiais Promocionais', 'value': 'Brindes / Materiais Promocionais' },
            { 'name': 'Brinquedos e Games', 'value': 'Brinquedos e Games' },
            { 'name': 'Casa e Decoração', 'value': 'Casa e Decoração' },
            { 'name': 'CDs', 'value': 'CDs' },
            { 'name': 'Colecionáveis', 'value': 'Colecionáveis' },
            { 'name': 'Compras Coletivas', 'value': 'Compras Coletivas' },
            { 'name': 'Construção e Ferramentas', 'value': 'Construção e Ferramentas' },
            { 'name': 'Cosméticos e Perfumaria', 'value': 'Cosméticos e Perfumaria' },
            { 'name': 'Cursos e Educação', 'value': 'Cursos e Educação' },
            { 'name': 'Discos de Vinil', 'value': 'Discos de Vinil' },
            { 'name': 'DVDs', 'value': 'DVDs' },
            { 'name': 'Eletrodomésticos', 'value': 'Eletrodomésticos' },
            { 'name': 'Eletrônicos', 'value': 'Eletrônicos' },
            { 'name': 'Emissoras de Rádio', 'value': 'Emissoras de Rádio' },
            { 'name': 'Emissoras de Televisão', 'value': 'Emissoras de Televisão' },
            { 'name': 'Empregos', 'value': 'Empregos' },
            { 'name': 'Empresas de Telemarketing', 'value': 'Empresas de Telemarketing' },
            { 'name': 'Esporte e Lazer', 'value': 'Esporte e Lazer' },
            { 'name': 'Fitas K7 Gravadas', 'value': 'Fitas K7 Gravadas' },
            { 'name': 'Flores, Cestas e Presentes', 'value': 'Flores, Cestas e Presentes' },
            { 'name': 'Fotografia', 'value': 'Fotografia' },
            { 'name': 'HD-DVD', 'value': 'HD-DVD' },
            { 'name': 'Igrejas / Templos / Instituições Religiosas', 'value': 'Igrejas / Templos / Instituições Religiosas' },
            { 'name': 'Indústria, Comércio e Negócios', 'value': 'Indústria, Comércio e Negócios' },
            { 'name': 'Infláveis Promocionais', 'value': 'Infláveis Promocionais' },
            { 'name': 'Informática', 'value': 'Informática' },
            { 'name': 'Ingressos', 'value': 'Ingressos' },
            { 'name': 'Instrumentos Musicais', 'value': 'Instrumentos Musicais' },
            { 'name': 'Joalheria', 'value': 'Joalheria' },
            { 'name': 'Lazer', 'value': 'Lazer' },
            { 'name': 'LD', 'value': 'LD' },
            { 'name': 'Livros', 'value': 'Livros' },
            { 'name': 'MD', 'value': 'MD' },
            { 'name': 'Moda e Acessórios', 'value': 'Moda e Acessórios' },
            { 'name': 'Motéis', 'value': 'Motéis' },
            { 'name': 'Música Digital', 'value': 'Música Digital' },
            { 'name': 'Natal', 'value': 'Natal' },
            { 'name': 'Negócios e Oportunidades', 'value': 'Negócios e Oportunidades' },
            { 'name': 'Outros Serviços', 'value': 'Outros Serviços' },
            { 'name': 'Outros Serviços de Avaliação', 'value': 'Outros Serviços de Avaliação' },
            { 'name': 'Papelaria e Escritório', 'value': 'Papelaria e Escritório' },
            { 'name': 'Páscoa', 'value': 'Páscoa' },
            { 'name': 'Pet Shop', 'value': 'Pet Shop' },
            { 'name': 'Saúde', 'value': 'Saúde' }
        ];
    }
    getListIndustries() {
        return this.listIndustries;
    }
};
PartnerIndustriesService = __decorate([
    Injectable()
], PartnerIndustriesService);

let PrintService = class PrintService {
    constructor() { }
    print(html, css) {
        let printContents;
        let popupWin;
        printContents = document.getElementById('print-section').innerHTML;
        popupWin = window.open('', '_blank', 'top=10,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          ${css}
          <meta name="viewport" content="width=device-width, initial-scale=1">
        </head>
        <body onload="window.print();window.close()">
          <div class="container">
            ${printContents}
          </div>
	      </body>
      </html>`);
        popupWin.document.close();
    }
};
PrintService = __decorate([
    Injectable()
], PrintService);

const LIST_CITIES = [{
        uf: "AC",
        state: "Acre",
        city: [
            "Acrelândia",
            "Assis Brasil",
            "Brasiléia",
            "Bujari",
            "Capixaba",
            "Cruzeiro do Sul",
            "Epitaciolândia",
            "Feijó",
            "Jordão",
            "Mâncio Lima",
            "Manoel Urbano",
            "Marechal Thaumaturgo",
            "Plácido de Castro",
            "Porto Acre",
            "Porto Walter",
            "Rio Branco",
            "Rodrigues Alves",
            "Santa Rosa do Purus",
            "Sena Madureira",
            "Senador Guiomard",
            "Tarauacá",
            "Xapuri"
        ]
    },
    {
        uf: "AL",
        state: "Alagoas",
        city: [
            "Água Branca",
            "Anadia",
            "Arapiraca",
            "Atalaia",
            "Barra de Santo Antônio",
            "Barra de São Miguel",
            "Batalha",
            "Belém",
            "Belo Monte",
            "Boca da Mata",
            "Branquinha",
            "Cacimbinhas",
            "Cajueiro",
            "Campestre",
            "Campo Alegre",
            "Campo Grande",
            "Canapi",
            "Capela",
            "Carneiros",
            "Chã Preta",
            "Coité do Nóia",
            "Colônia Leopoldina",
            "Coqueiro Seco",
            "Coruripe",
            "Craíbas",
            "Delmiro Gouveia",
            "Dois Riachos",
            "Estrela de Alagoas",
            "Feira Grande",
            "Feliz Deserto",
            "Flexeiras",
            "Girau do Ponciano",
            "Ibateguara",
            "Igaci",
            "Igreja Nova",
            "Inhapi",
            "Jacaré dos Homens",
            "Jacuípe",
            "Japaratinga",
            "Jaramataia",
            "Jequiá da Praia",
            "Joaquim Gomes",
            "Jundiá",
            "Junqueiro",
            "Lagoa da Canoa",
            "Limoeiro de Anadia",
            "Maceió",
            "Major Isidoro",
            "Mar Vermelho",
            "Maragogi",
            "Maravilha",
            "Marechal Deodoro",
            "Maribondo",
            "Mata Grande",
            "Matriz de Camaragibe",
            "Messias",
            "Minador do Negrão",
            "Monteirópolis",
            "Murici",
            "Novo Lino",
            "Olho d'Água das Flores",
            "Olho d'Água do Casado",
            "Olho d'Água Grande",
            "Olivença",
            "Ouro Branco",
            "Palestina",
            "Palmeira dos Índios",
            "Pão de Açúcar",
            "Pariconha",
            "Paripueira",
            "Passo de Camaragibe",
            "Paulo Jacinto",
            "Penedo",
            "Piaçabuçu",
            "Pilar",
            "Pindoba",
            "Piranhas",
            "Poço das Trincheiras",
            "Porto Calvo",
            "Porto de Pedras",
            "Porto Real do Colégio",
            "Quebrangulo",
            "Rio Largo",
            "Roteiro",
            "Santa Luzia do Norte",
            "Santana do Ipanema",
            "Santana do Mundaú",
            "São Brás",
            "São José da Laje",
            "São José da Tapera",
            "São Luís do Quitunde",
            "São Miguel dos Campos",
            "São Miguel dos Milagres",
            "São Sebastião",
            "Satuba",
            "Senador Rui Palmeira",
            "Tanque d'Arca",
            "Taquarana",
            "Teotônio Vilela",
            "Traipu",
            "União dos Palmares",
            "Viçosa"
        ]
    },
    {
        uf: "AM",
        state: "Amazonas",
        city: [
            "Alvarães",
            "Amaturá",
            "Anamã",
            "Anori",
            "Apuí",
            "Atalaia do Norte",
            "Autazes",
            "Barcelos",
            "Barreirinha",
            "Benjamin Constant",
            "Beruri",
            "Boa Vista do Ramos",
            "Boca do Acre",
            "Borba",
            "Caapiranga",
            "Canutama",
            "Carauari",
            "Careiro",
            "Careiro da Várzea",
            "Coari",
            "Codajás",
            "Eirunepé",
            "Envira",
            "Fonte Boa",
            "Guajará",
            "Humaitá",
            "Ipixuna",
            "Iranduba",
            "Itacoatiara",
            "Itamarati",
            "Itapiranga",
            "Japurá",
            "Juruá",
            "Jutaí",
            "Lábrea",
            "Manacapuru",
            "Manaquiri",
            "Manaus",
            "Manicoré",
            "Maraã",
            "Maués",
            "Nhamundá",
            "Nova Olinda do Norte",
            "Novo Airão",
            "Novo Aripuanã",
            "Parintins",
            "Pauini",
            "Presidente Figueiredo",
            "Rio Preto da Eva",
            "Santa Isabel do Rio Negro",
            "Santo Antônio do Içá",
            "São Gabriel da Cachoeira",
            "São Paulo de Olivença",
            "São Sebastião do Uatumã",
            "Silves",
            "Tabatinga",
            "Tapauá",
            "Tefé",
            "Tonantins",
            "Uarini",
            "Urucará",
            "Urucurituba"
        ]
    },
    {
        uf: "AP",
        state: "Amapá",
        city: [
            "Amapá",
            "Calçoene",
            "Cutias",
            "Ferreira Gomes",
            "Itaubal",
            "Laranjal do Jari",
            "Macapá",
            "Mazagão",
            "Oiapoque",
            "Pedra Branca do Amapari",
            "Porto Grande",
            "Pracuúba",
            "Santana",
            "Serra do Navio",
            "Tartarugalzinho",
            "Vitória do Jari"
        ]
    },
    {
        uf: "BA",
        state: "Bahia",
        city: [
            "Abaíra",
            "Abaré",
            "Acajutiba",
            "Adustina",
            "Água Fria",
            "Aiquara",
            "Alagoinhas",
            "Alcobaça",
            "Almadina",
            "Amargosa",
            "Amélia Rodrigues",
            "América Dourada",
            "Anagé",
            "Andaraí",
            "Andorinha",
            "Angical",
            "Anguera",
            "Antas",
            "Antônio Cardoso",
            "Antônio Gonçalves",
            "Aporá",
            "Apuarema",
            "Araças",
            "Aracatu",
            "Araci",
            "Aramari",
            "Arataca",
            "Aratuípe",
            "Aurelino Leal",
            "Baianópolis",
            "Baixa Grande",
            "Banzaê",
            "Barra",
            "Barra da Estiva",
            "Barra do Choça",
            "Barra do Mendes",
            "Barra do Rocha",
            "Barreiras",
            "Barro Alto",
            "Barrocas",
            "Barro Preto",
            "Belmonte",
            "Belo Campo",
            "Biritinga",
            "Boa Nova",
            "Boa Vista do Tupim",
            "Bom Jesus da Lapa",
            "Bom Jesus da Serra",
            "Boninal",
            "Bonito",
            "Boquira",
            "Botuporã",
            "Brejões",
            "Brejolândia",
            "Brotas de Macaúbas",
            "Brumado",
            "Buerarema",
            "Buritirama",
            "Caatiba",
            "Cabaceiras do Paraguaçu",
            "Cachoeira",
            "Caculé",
            "Caém",
            "Caetanos",
            "Caetité",
            "Cafarnaum",
            "Cairu",
            "Caldeirão Grande",
            "Camacan",
            "Camaçari",
            "Camamu",
            "Campo Alegre de Lourdes",
            "Campo Formoso",
            "Canápolis",
            "Canarana",
            "Canavieiras",
            "Candeal",
            "Candeias",
            "Candiba",
            "Cândido Sales",
            "Cansanção",
            "Canudos",
            "Capela do Alto Alegre",
            "Capim Grosso",
            "Caraíbas",
            "Caravelas",
            "Cardeal da Silva",
            "Carinhanha",
            "Casa Nova",
            "Castro Alves",
            "Catolândia",
            "Catu",
            "Caturama",
            "Central",
            "Chorrochó",
            "Cícero Dantas",
            "Cipó",
            "Coaraci",
            "Cocos",
            "Conceição da Feira",
            "Conceição do Almeida",
            "Conceição do Coité",
            "Conceição do Jacuípe",
            "Conde",
            "Condeúba",
            "Contendas do Sincorá",
            "Coração de Maria",
            "Cordeiros",
            "Coribe",
            "Coronel João Sá",
            "Correntina",
            "Cotegipe",
            "Cravolândia",
            "Crisópolis",
            "Cristópolis",
            "Cruz das Almas",
            "Curaçá",
            "Dário Meira",
            "Dias d'Ávila",
            "Dom Basílio",
            "Dom Macedo Costa",
            "Elísio Medrado",
            "Encruzilhada",
            "Entre Rios",
            "Érico Cardoso",
            "Esplanada",
            "Euclides da Cunha",
            "Eunápolis",
            "Fátima",
            "Feira da Mata",
            "Feira de Santana",
            "Filadélfia",
            "Firmino Alves",
            "Floresta Azul",
            "Formosa do Rio Preto",
            "Gandu",
            "Gavião",
            "Gentio do Ouro",
            "Glória",
            "Gongogi",
            "Governador Mangabeira",
            "Guajeru",
            "Guanambi",
            "Guaratinga",
            "Heliópolis",
            "Iaçu",
            "Ibiassucê",
            "Ibicaraí",
            "Ibicoara",
            "Ibicuí",
            "Ibipeba",
            "Ibipitanga",
            "Ibiquera",
            "Ibirapitanga",
            "Ibirapuã",
            "Ibirataia",
            "Ibitiara",
            "Ibititá",
            "Ibotirama",
            "Ichu",
            "Igaporã",
            "Igrapiúna",
            "Iguaí",
            "Ilhéus",
            "Inhambupe",
            "Ipecaetá",
            "Ipiaú",
            "Ipirá",
            "Ipupiara",
            "Irajuba",
            "Iramaia",
            "Iraquara",
            "Irará",
            "Irecê",
            "Itabela",
            "Itaberaba",
            "Itabuna",
            "Itacaré",
            "Itaeté",
            "Itagi",
            "Itagibá",
            "Itagimirim",
            "Itaguaçu da Bahia",
            "Itaju do Colônia",
            "Itajuípe",
            "Itamaraju",
            "Itamari",
            "Itambé",
            "Itanagra",
            "Itanhém",
            "Itaparica",
            "Itapé",
            "Itapebi",
            "Itapetinga",
            "Itapicuru",
            "Itapitanga",
            "Itaquara",
            "Itarantim",
            "Itatim",
            "Itiruçu",
            "Itiúba",
            "Itororó",
            "Ituaçu",
            "Ituberá",
            "Iuiú",
            "Jaborandi",
            "Jacaraci",
            "Jacobina",
            "Jaguaquara",
            "Jaguarari",
            "Jaguaripe",
            "Jandaíra",
            "Jequié",
            "Jeremoabo",
            "Jiquiriçá",
            "Jitaúna",
            "João Dourado",
            "Juazeiro",
            "Jucuruçu",
            "Jussara",
            "Jussari",
            "Jussiape",
            "Lafaiete Coutinho",
            "Lagoa Real",
            "Laje",
            "Lajedão",
            "Lajedinho",
            "Lajedo do Tabocal",
            "Lamarão",
            "Lapão",
            "Lauro de Freitas",
            "Lençóis",
            "Licínio de Almeida",
            "Livramento de Nossa Senhora",
            "Luís Eduardo Magalhães",
            "Macajuba",
            "Macarani",
            "Macaúbas",
            "Macururé",
            "Madre de Deus",
            "Maetinga",
            "Maiquinique",
            "Mairi",
            "Malhada",
            "Malhada de Pedras",
            "Manoel Vitorino",
            "Mansidão",
            "Maracás",
            "Maragogipe",
            "Maraú",
            "Marcionílio Souza",
            "Mascote",
            "Mata de São João",
            "Matina",
            "Medeiros Neto",
            "Miguel Calmon",
            "Milagres",
            "Mirangaba",
            "Mirante",
            "Monte Santo",
            "Morpará",
            "Morro do Chapéu",
            "Mortugaba",
            "Mucugê",
            "Mucuri",
            "Mulungu do Morro",
            "Mundo Novo",
            "Muniz Ferreira",
            "Muquém de São Francisco",
            "Muritiba",
            "Mutuípe",
            "Nazaré",
            "Nilo Peçanha",
            "Nordestina",
            "Nova Canaã",
            "Nova Fátima",
            "Nova Ibiá",
            "Nova Itarana",
            "Nova Redenção",
            "Nova Soure",
            "Nova Viçosa",
            "Novo Horizonte",
            "Novo Triunfo",
            "Olindina",
            "Oliveira dos Brejinhos",
            "Ouriçangas",
            "Ourolândia",
            "Palmas de Monte Alto",
            "Palmeiras",
            "Paramirim",
            "Paratinga",
            "Paripiranga",
            "Pau Brasil",
            "Paulo Afonso",
            "Pé de Serra",
            "Pedrão",
            "Pedro Alexandre",
            "Piatã",
            "Pilão Arcado",
            "Pindaí",
            "Pindobaçu",
            "Pintadas",
            "Piraí do Norte",
            "Piripá",
            "Piritiba",
            "Planaltino",
            "Planalto",
            "Poções",
            "Pojuca",
            "Ponto Novo",
            "Porto Seguro",
            "Potiraguá",
            "Prado",
            "Presidente Dutra",
            "Presidente Jânio Quadros",
            "Presidente Tancredo Neves",
            "Queimadas",
            "Quijingue",
            "Quixabeira",
            "Rafael Jambeiro",
            "Remanso",
            "Retirolândia",
            "Riachão das Neves",
            "Riachão do Jacuípe",
            "Riacho de Santana",
            "Ribeira do Amparo",
            "Ribeira do Pombal",
            "Ribeirão do Largo",
            "Rio de Contas",
            "Rio do Antônio",
            "Rio do Pires",
            "Rio Real",
            "Rodelas",
            "Ruy Barbosa",
            "Salinas da Margarida",
            "Salvador",
            "Santa Bárbara",
            "Santa Brígida",
            "Santa Cruz Cabrália",
            "Santa Cruz da Vitória",
            "Santa Inês",
            "Santa Luzia",
            "Santa Maria da Vitória",
            "Santa Rita de Cássia",
            "Santa Teresinha",
            "Santaluz",
            "Santana",
            "Santanópolis",
            "Santo Amaro",
            "Santo Antônio de Jesus",
            "Santo Estêvão",
            "São Desidério",
            "São Domingos",
            "São Felipe",
            "São Félix",
            "São Félix do Coribe",
            "São Francisco do Conde",
            "São Gabriel",
            "São Gonçalo dos Campos",
            "São José da Vitória",
            "São José do Jacuípe",
            "São Miguel das Matas",
            "São Sebastião do Passé",
            "Sapeaçu",
            "Sátiro Dias",
            "Saubara",
            "Saúde",
            "Seabra",
            "Sebastião Laranjeiras",
            "Senhor do Bonfim",
            "Sento Sé",
            "Serra do Ramalho",
            "Serra Dourada",
            "Serra Preta",
            "Serrinha",
            "Serrolândia",
            "Simões Filho",
            "Sítio do Mato",
            "Sítio do Quinto",
            "Sobradinho",
            "Souto Soares",
            "Tabocas do Brejo Velho",
            "Tanhaçu",
            "Tanque Novo",
            "Tanquinho",
            "Taperoá",
            "Tapiramutá",
            "Teixeira de Freitas",
            "Teodoro Sampaio",
            "Teofilândia",
            "Teolândia",
            "Terra Nova",
            "Tremedal",
            "Tucano",
            "Uauá",
            "Ubaíra",
            "Ubaitaba",
            "Ubatã",
            "Uibaí",
            "Umburanas",
            "Una",
            "Urandi",
            "Uruçuca",
            "Utinga",
            "Valença",
            "Valente",
            "Várzea da Roça",
            "Várzea do Poço",
            "Várzea Nova",
            "Varzedo",
            "Vera Cruz",
            "Vereda",
            "Vitória da Conquista",
            "Wagner",
            "Wanderley",
            "Wenceslau Guimarães",
            "Xique-Xique"
        ]
    },
    {
        uf: "CE",
        state: "Ceará",
        city: [
            "Abaiara",
            "Acarapé",
            "Acaraú",
            "Acopiara",
            "Aiuaba",
            "Alcântaras",
            "Altaneira",
            "Alto Santo",
            "Amontada",
            "Antonina do Norte",
            "Apuiarés",
            "Aquiraz",
            "Aracati",
            "Aracoiaba",
            "Ararendá",
            "Araripe",
            "Aratuba",
            "Arneiroz",
            "Assaré",
            "Aurora",
            "Baixio",
            "Banabuiú",
            "Barbalha",
            "Barreira",
            "Barro",
            "Barroquinha",
            "Baturité",
            "Beberibe",
            "Bela Cruz",
            "Boa Viagem",
            "Brejo Santo",
            "Camocim",
            "Campos Sales",
            "Canindé",
            "Capistrano",
            "Caridade",
            "Cariré",
            "Caririaçu",
            "Cariús",
            "Carnaubal",
            "Cascavel",
            "Catarina",
            "Catunda",
            "Caucaia",
            "Cedro",
            "Chaval",
            "Choró",
            "Chorozinho",
            "Coreaú",
            "Crateús",
            "Crato",
            "Croatá",
            "Cruz",
            "Deputado Irapuan Pinheiro",
            "Ererê",
            "Eusébio",
            "Farias Brito",
            "Forquilha",
            "Fortaleza",
            "Fortim",
            "Frecheirinha",
            "General Sampaio",
            "Graça",
            "Granja",
            "Granjeiro",
            "Groaíras",
            "Guaiúba",
            "Guaraciaba do Norte",
            "Guaramiranga",
            "Hidrolândia",
            "Horizonte",
            "Ibaretama",
            "Ibiapina",
            "Ibicuitinga",
            "Icapuí",
            "Icó",
            "Iguatu",
            "Independência",
            "Ipaporanga",
            "Ipaumirim",
            "Ipu",
            "Ipueiras",
            "Iracema",
            "Irauçuba",
            "Itaiçaba",
            "Itaitinga",
            "Itapagé",
            "Itapipoca",
            "Itapiúna",
            "Itarema",
            "Itatira",
            "Jaguaretama",
            "Jaguaribara",
            "Jaguaribe",
            "Jaguaruana",
            "Jardim",
            "Jati",
            "Jijoca de Jericoaroara",
            "Juazeiro do Norte",
            "Jucás",
            "Lavras da Mangabeira",
            "Limoeiro do Norte",
            "Madalena",
            "Maracanaú",
            "Maranguape",
            "Marco",
            "Martinópole",
            "Massapê",
            "Mauriti",
            "Meruoca",
            "Milagres",
            "Milhã",
            "Miraíma",
            "Missão Velha",
            "Mombaça",
            "Monsenhor Tabosa",
            "Morada Nova",
            "Moraújo",
            "Morrinhos",
            "Mucambo",
            "Mulungu",
            "Nova Olinda",
            "Nova Russas",
            "Novo Oriente",
            "Ocara",
            "Orós",
            "Pacajus",
            "Pacatuba",
            "Pacoti",
            "Pacujá",
            "Palhano",
            "Palmácia",
            "Paracuru",
            "Paraipaba",
            "Parambu",
            "Paramoti",
            "Pedra Branca",
            "Penaforte",
            "Pentecoste",
            "Pereiro",
            "Pindoretama",
            "Piquet Carneiro",
            "Pires Ferreira",
            "Poranga",
            "Porteiras",
            "Potengi",
            "Potiretama",
            "Quiterianópolis",
            "Quixadá",
            "Quixelô",
            "Quixeramobim",
            "Quixeré",
            "Redenção",
            "Reriutaba",
            "Russas",
            "Saboeiro",
            "Salitre",
            "Santa Quitéria",
            "Santana do Acaraú",
            "Santana do Cariri",
            "São Benedito",
            "São Gonçalo do Amarante",
            "São João do Jaguaribe",
            "São Luís do Curu",
            "Senador Pompeu",
            "Senador Sá",
            "Sobral",
            "Solonópole",
            "Tabuleiro do Norte",
            "Tamboril",
            "Tarrafas",
            "Tauá",
            "Tejuçuoca",
            "Tianguá",
            "Trairi",
            "Tururu",
            "Ubajara",
            "Umari",
            "Umirim",
            "Uruburetama",
            "Uruoca",
            "Varjota",
            "Várzea Alegre",
            "Viçosa do Ceará"
        ]
    },
    {
        uf: "DF",
        state: "Distrito Federal",
        city: [
            "Águas Claras",
            "Brasília",
            "Ceilândia",
            "Gama",
            "Guará",
            "Planaltina",
            "Plano Piloto",
            "Recanto das Emas",
            "Samambaia",
            "Santa Maria",
            "Taguatinga"
        ]
    },
    {
        uf: "ES",
        state: "Espírito Santo",
        city: [
            "Afonso Cláudio",
            "Água Doce do Norte",
            "Águia Branca",
            "Alegre",
            "Alfredo Chaves",
            "Alto Rio Novo",
            "Anchieta",
            "Apiacá",
            "Aracruz",
            "Atilio Vivacqua",
            "Baixo Guandu",
            "Barra de São Francisco",
            "Boa Esperança",
            "Bom Jesus do Norte",
            "Brejetuba",
            "Cachoeiro de Itapemirim",
            "Cariacica",
            "Castelo",
            "Colatina",
            "Conceição da Barra",
            "Conceição do Castelo",
            "Divino de São Lourenço",
            "Domingos Martins",
            "Dores do Rio Preto",
            "Ecoporanga",
            "Fundão",
            "Governador Lindenberg",
            "Guaçuí",
            "Guarapari",
            "Ibatiba",
            "Ibiraçu",
            "Ibitirama",
            "Iconha",
            "Irupi",
            "Itaguaçu",
            "Itapemirim",
            "Itarana",
            "Iúna",
            "Jaguaré",
            "Jerônimo Monteiro",
            "João Neiva",
            "Laranja da Terra",
            "Linhares",
            "Mantenópolis",
            "Marataizes",
            "Marechal Floriano",
            "Marilândia",
            "Mimoso do Sul",
            "Montanha",
            "Mucurici",
            "Muniz Freire",
            "Muqui",
            "Nova Venécia",
            "Pancas",
            "Pedro Canário",
            "Pinheiros",
            "Piúma",
            "Ponto Belo",
            "Presidente Kennedy",
            "Rio Bananal",
            "Rio Novo do Sul",
            "Santa Leopoldina",
            "Santa Maria de Jetibá",
            "Santa Teresa",
            "São Domingos do Norte",
            "São Gabriel da Palha",
            "São José do Calçado",
            "São Mateus",
            "São Roque do Canaã",
            "Serra",
            "Sooretama",
            "Vargem Alta",
            "Venda Nova do Imigrante",
            "Viana",
            "Vila Pavão",
            "Vila Valério",
            "Vila Velha",
            "Vitória"
        ]
    },
    {
        uf: "GO",
        state: "Goiás",
        city: [
            "Abadia de Goiás",
            "Abadiânia",
            "Acreúna",
            "Adelândia",
            "Água Fria de Goiás",
            "Água Limpa",
            "Águas Lindas de Goiás",
            "Alexânia",
            "Aloândia",
            "Alto Horizonte",
            "Alto Paraíso de Goiás",
            "Alvorada do Norte",
            "Amaralina",
            "Americano do Brasil",
            "Amorinópolis",
            "Anápolis",
            "Anhanguera",
            "Anicuns",
            "Aparecida de Goiânia",
            "Aparecida do Rio Doce",
            "Aporé",
            "Araçu",
            "Aragarças",
            "Aragoiânia",
            "Araguapaz",
            "Arenópolis",
            "Aruanã",
            "Aurilândia",
            "Avelinópolis",
            "Baliza",
            "Barro Alto",
            "Bela Vista de Goiás",
            "Bom Jardim de Goiás",
            "Bom Jesus de Goiás",
            "Bonfinópolis",
            "Bonópolis",
            "Brazabrantes",
            "Britânia",
            "Buriti Alegre",
            "Buriti de Goiás",
            "Buritinópolis",
            "Cabeceiras",
            "Cachoeira Alta",
            "Cachoeira de Goiás",
            "Cachoeira Dourada",
            "Caçu",
            "Caiapônia",
            "Caldas Novas",
            "Caldazinha",
            "Campestre de Goiás",
            "Campinaçu",
            "Campinorte",
            "Campo Alegre de Goiás",
            "Campos Limpo de Goiás",
            "Campos Belos",
            "Campos Verdes",
            "Carmo do Rio Verde",
            "Castelândia",
            "Catalão",
            "Caturaí",
            "Cavalcante",
            "Ceres",
            "Cezarina",
            "Chapadão do Céu",
            "Cidade Ocidental",
            "Cocalzinho de Goiás",
            "Colinas do Sul",
            "Córrego do Ouro",
            "Corumbá de Goiás",
            "Corumbaíba",
            "Cristalina",
            "Cristianópolis",
            "Crixás",
            "Cromínia",
            "Cumari",
            "Damianópolis",
            "Damolândia",
            "Davinópolis",
            "Diorama",
            "Divinópolis de Goiás",
            "Doverlândia",
            "Edealina",
            "Edéia",
            "Estrela do Norte",
            "Faina",
            "Fazenda Nova",
            "Firminópolis",
            "Flores de Goiás",
            "Formosa",
            "Formoso",
            "Gameleira de Goiás",
            "Goianápolis",
            "Goiandira",
            "Goianésia",
            "Goiânia",
            "Goianira",
            "Goiás",
            "Goiatuba",
            "Gouvelândia",
            "Guapó",
            "Guaraíta",
            "Guarani de Goiás",
            "Guarinos",
            "Heitoraí",
            "Hidrolândia",
            "Hidrolina",
            "Iaciara",
            "Inaciolândia",
            "Indiara",
            "Inhumas",
            "Ipameri",
            "Ipiranga de Goiás",
            "Iporá",
            "Israelândia",
            "Itaberaí",
            "Itaguari",
            "Itaguaru",
            "Itajá",
            "Itapaci",
            "Itapirapuã",
            "Itapuranga",
            "Itarumã",
            "Itauçu",
            "Itumbiara",
            "Ivolândia",
            "Jandaia",
            "Jaraguá",
            "Jataí",
            "Jaupaci",
            "Jesúpolis",
            "Joviânia",
            "Jussara",
            "Lagoa Santa",
            "Leopoldo de Bulhões",
            "Luziânia",
            "Mairipotaba",
            "Mambaí",
            "Mara Rosa",
            "Marzagão",
            "Matrinchã",
            "Maurilândia",
            "Mimoso de Goiás",
            "Minaçu",
            "Mineiros",
            "Moiporá",
            "Monte Alegre de Goiás",
            "Montes Claros de Goiás",
            "Montividiu",
            "Montividiu do Norte",
            "Morrinhos",
            "Morro Agudo de Goiás",
            "Mossâmedes",
            "Mozarlândia",
            "Mundo Novo",
            "Mutunópolis",
            "Nazário",
            "Nerópolis",
            "Niquelândia",
            "Nova América",
            "Nova Aurora",
            "Nova Crixás",
            "Nova Glória",
            "Nova Iguaçu de Goiás",
            "Nova Roma",
            "Nova Veneza",
            "Novo Brasil",
            "Novo Gama",
            "Novo Planalto",
            "Orizona",
            "Ouro Verde de Goiás",
            "Ouvidor",
            "Padre Bernardo",
            "Palestina de Goiás",
            "Palmeiras de Goiás",
            "Palmelo",
            "Palminópolis",
            "Panamá",
            "Paranaiguara",
            "Paraúna",
            "Perolândia",
            "Petrolina de Goiás",
            "Pilar de Goiás",
            "Piracanjuba",
            "Piranhas",
            "Pirenópolis",
            "Pires do Rio",
            "Planaltina",
            "Pontalina",
            "Porangatu",
            "Porteirão",
            "Portelândia",
            "Posse",
            "Professor Jamil",
            "Quirinópolis",
            "Rialma",
            "Rianápolis",
            "Rio Quente",
            "Rio Verde",
            "Rubiataba",
            "Sanclerlândia",
            "Santa Bárbara de Goiás",
            "Santa Cruz de Goiás",
            "Santa Fé de Goiás",
            "Santa Helena de Goiás",
            "Santa Isabel",
            "Santa Rita do Araguaia",
            "Santa Rita do Novo Destino",
            "Santa Rosa de Goiás",
            "Santa Tereza de Goiás",
            "Santa Terezinha de Goiás",
            "Santo Antônio da Barra",
            "Santo Antônio de Goiás",
            "Santo Antônio do Descoberto",
            "São Domingos",
            "São Francisco de Goiás",
            "São João d'Aliança",
            "São João da Paraúna",
            "São Luís de Montes Belos",
            "São Luíz do Norte",
            "São Miguel do Araguaia",
            "São Miguel do Passa Quatro",
            "São Patrício",
            "São Simão",
            "Senador Canedo",
            "Serranópolis",
            "Silvânia",
            "Simolândia",
            "Sítio d'Abadia",
            "Taquaral de Goiás",
            "Teresina de Goiás",
            "Terezópolis de Goiás",
            "Três Ranchos",
            "Trindade",
            "Trombas",
            "Turvânia",
            "Turvelândia",
            "Uirapuru",
            "Uruaçu",
            "Uruana",
            "Urutaí",
            "Valparaíso de Goiás",
            "Varjão",
            "Vianópolis",
            "Vicentinópolis",
            "Vila Boa",
            "Vila Propício"
        ]
    },
    {
        uf: "MA",
        state: "Maranhão",
        city: [
            "Açailândia",
            "Afonso Cunha",
            "Água Doce do Maranhão",
            "Alcântara",
            "Aldeias Altas",
            "Altamira do Maranhão",
            "Alto Alegre do Maranhão",
            "Alto Alegre do Pindaré",
            "Alto Parnaíba",
            "Amapá do Maranhão",
            "Amarante do Maranhão",
            "Anajatuba",
            "Anapurus",
            "Apicum-Açu",
            "Araguanã",
            "Araioses",
            "Arame",
            "Arari",
            "Axixá",
            "Bacabal",
            "Bacabeira",
            "Bacuri",
            "Bacurituba",
            "Balsas",
            "Barão de Grajaú",
            "Barra do Corda",
            "Barreirinhas",
            "Bela Vista do Maranhão",
            "Belágua",
            "Benedito Leite",
            "Bequimão",
            "Bernardo do Mearim",
            "Boa Vista do Gurupi",
            "Bom Jardim",
            "Bom Jesus das Selvas",
            "Bom Lugar",
            "Brejo",
            "Brejo de Areia",
            "Buriti",
            "Buriti Bravo",
            "Buriticupu",
            "Buritirana",
            "Cachoeira Grande",
            "Cajapió",
            "Cajari",
            "Campestre do Maranhão",
            "Cândido Mendes",
            "Cantanhede",
            "Capinzal do Norte",
            "Carolina",
            "Carutapera",
            "Caxias",
            "Cedral",
            "Central do Maranhão",
            "Centro do Guilherme",
            "Centro Novo do Maranhão",
            "Chapadinha",
            "Cidelândia",
            "Codó",
            "Coelho Neto",
            "Colinas",
            "Conceição do Lago-Açu",
            "Coroatá",
            "Cururupu",
            "Davinópolis",
            "Dom Pedro",
            "Duque Bacelar",
            "Esperantinópolis",
            "Estreito",
            "Feira Nova do Maranhão",
            "Fernando Falcão",
            "Formosa da Serra Negra",
            "Fortaleza dos Nogueiras",
            "Fortuna",
            "Godofredo Viana",
            "Gonçalves Dias",
            "Governador Archer",
            "Governador Edison Lobão",
            "Governador Eugênio Barros",
            "Governador Luiz Rocha",
            "Governador Newton Bello",
            "Governador Nunes Freire",
            "Graça Aranha",
            "Grajaú",
            "Guimarães",
            "Humberto de Campos",
            "Icatu",
            "Igarapé do Meio",
            "Igarapé Grande",
            "Imperatriz",
            "Itaipava do Grajaú",
            "Itapecuru Mirim",
            "Itinga do Maranhão",
            "Jatobá",
            "Jenipapo dos Vieiras",
            "João Lisboa",
            "Joselândia",
            "Junco do Maranhão",
            "Lago da Pedra",
            "Lago do Junco",
            "Lago dos Rodrigues",
            "Lago Verde",
            "Lagoa do Mato",
            "Lagoa Grande do Maranhão",
            "Lajeado Novo",
            "Lima Campos",
            "Loreto",
            "Luís Domingues",
            "Magalhães de Almeida",
            "Maracaçumé",
            "Marajá do Sena",
            "Maranhãozinho",
            "Mata Roma",
            "Matinha",
            "Matões",
            "Matões do Norte",
            "Milagres do Maranhão",
            "Mirador",
            "Miranda do Norte",
            "Mirinzal",
            "Monção",
            "Montes Altos",
            "Morros",
            "Nina Rodrigues",
            "Nova Colinas",
            "Nova Iorque",
            "Nova Olinda do Maranhão",
            "Olho d'Água das Cunhãs",
            "Olinda Nova do Maranhão",
            "Paço do Lumiar",
            "Palmeirândia",
            "Paraibano",
            "Parnarama",
            "Passagem Franca",
            "Pastos Bons",
            "Paulino Neves",
            "Paulo Ramos",
            "Pedreiras",
            "Pedro do Rosário",
            "Penalva",
            "Peri Mirim",
            "Peritoró",
            "Pindaré Mirim",
            "Pinheiro",
            "Pio XII",
            "Pirapemas",
            "Poção de Pedras",
            "Porto Franco",
            "Porto Rico do Maranhão",
            "Presidente Dutra",
            "Presidente Juscelino",
            "Presidente Médici",
            "Presidente Sarney",
            "Presidente Vargas",
            "Primeira Cruz",
            "Raposa",
            "Riachão",
            "Ribamar Fiquene",
            "Rosário",
            "Sambaíba",
            "Santa Filomena do Maranhão",
            "Santa Helena",
            "Santa Inês",
            "Santa Luzia",
            "Santa Luzia do Paruá",
            "Santa Quitéria do Maranhão",
            "Santa Rita",
            "Santana do Maranhão",
            "Santo Amaro do Maranhão",
            "Santo Antônio dos Lopes",
            "São Benedito do Rio Preto",
            "São Bento",
            "São Bernardo",
            "São Domingos do Azeitão",
            "São Domingos do Maranhão",
            "São Félix de Balsas",
            "São Francisco do Brejão",
            "São Francisco do Maranhão",
            "São João Batista",
            "São João do Carú",
            "São João do Paraíso",
            "São João do Soter",
            "São João dos Patos",
            "São José de Ribamar",
            "São José dos Basílios",
            "São Luís",
            "São Luís Gonzaga do Maranhão",
            "São Mateus do Maranhão",
            "São Pedro da Água Branca",
            "São Pedro dos Crentes",
            "São Raimundo das Mangabeiras",
            "São Raimundo do Doca Bezerra",
            "São Roberto",
            "São Vicente Ferrer",
            "Satubinha",
            "Senador Alexandre Costa",
            "Senador La Rocque",
            "Serrano do Maranhão",
            "Sítio Novo",
            "Sucupira do Norte",
            "Sucupira do Riachão",
            "Tasso Fragoso",
            "Timbiras",
            "Timon",
            "Trizidela do Vale",
            "Tufilândia",
            "Tuntum",
            "Turiaçu",
            "Turilândia",
            "Tutóia",
            "Urbano Santos",
            "Vargem Grande",
            "Viana",
            "Vila Nova dos Martírios",
            "Vitória do Mearim",
            "Vitorino Freire",
            "Zé Doca"
        ]
    },
    {
        uf: "MG",
        state: "Minas Gerais",
        city: [
            "Abadia dos Dourados",
            "Abaeté",
            "Abre Campo",
            "Acaiaca",
            "Açucena",
            "Água Boa",
            "Água Comprida",
            "Aguanil",
            "Águas Formosas",
            "Águas Vermelhas",
            "Aimorés",
            "Aiuruoca",
            "Alagoa",
            "Albertina",
            "Além Paraíba",
            "Alfenas",
            "Alfredo Vasconcelos",
            "Almenara",
            "Alpercata",
            "Alpinópolis",
            "Alterosa",
            "Alto Caparaó",
            "Alto Jequitibá",
            "Alto Rio Doce",
            "Alvarenga",
            "Alvinópolis",
            "Alvorada de Minas",
            "Amparo do Serra",
            "Andradas",
            "Andrelândia",
            "Angelândia",
            "Antônio Carlos",
            "Antônio Dias",
            "Antônio Prado de Minas",
            "Araçaí",
            "Aracitaba",
            "Araçuaí",
            "Araguari",
            "Arantina",
            "Araponga",
            "Araporã",
            "Arapuá",
            "Araújos",
            "Araxá",
            "Arceburgo",
            "Arcos",
            "Areado",
            "Argirita",
            "Aricanduva",
            "Arinos",
            "Astolfo Dutra",
            "Ataléia",
            "Augusto de Lima",
            "Baependi",
            "Baldim",
            "Bambuí",
            "Bandeira",
            "Bandeira do Sul",
            "Barão de Cocais",
            "Barão de Monte Alto",
            "Barbacena",
            "Barra Longa",
            "Barroso",
            "Bela Vista de Minas",
            "Belmiro Braga",
            "Belo Horizonte",
            "Belo Oriente",
            "Belo Vale",
            "Berilo",
            "Berizal",
            "Bertópolis",
            "Betim",
            "Bias Fortes",
            "Bicas",
            "Biquinhas",
            "Boa Esperança",
            "Bocaina de Minas",
            "Bocaiúva",
            "Bom Despacho",
            "Bom Jardim de Minas",
            "Bom Jesus da Penha",
            "Bom Jesus do Amparo",
            "Bom Jesus do Galho",
            "Bom Repouso",
            "Bom Sucesso",
            "Bonfim",
            "Bonfinópolis de Minas",
            "Bonito de Minas",
            "Borda da Mata",
            "Botelhos",
            "Botumirim",
            "Brás Pires",
            "Brasilândia de Minas",
            "Brasília de Minas",
            "Brasópolis",
            "Braúnas",
            "Brumadinho",
            "Bueno Brandão",
            "Buenópolis",
            "Bugre",
            "Buritis",
            "Buritizeiro",
            "Cabeceira Grande",
            "Cabo Verde",
            "Cachoeira da Prata",
            "Cachoeira de Minas",
            "Cachoeira de Pajeú",
            "Cachoeira Dourada",
            "Caetanópolis",
            "Caeté",
            "Caiana",
            "Cajuri",
            "Caldas",
            "Camacho",
            "Camanducaia",
            "Cambuí",
            "Cambuquira",
            "Campanário",
            "Campanha",
            "Campestre",
            "Campina Verde",
            "Campo Azul",
            "Campo Belo",
            "Campo do Meio",
            "Campo Florido",
            "Campos Altos",
            "Campos Gerais",
            "Cana Verde",
            "Canaã",
            "Canápolis",
            "Candeias",
            "Cantagalo",
            "Caparaó",
            "Capela Nova",
            "Capelinha",
            "Capetinga",
            "Capim Branco",
            "Capinópolis",
            "Capitão Andrade",
            "Capitão Enéas",
            "Capitólio",
            "Caputira",
            "Caraí",
            "Caranaíba",
            "Carandaí",
            "Carangola",
            "Caratinga",
            "Carbonita",
            "Careaçu",
            "Carlos Chagas",
            "Carmésia",
            "Carmo da Cachoeira",
            "Carmo da Mata",
            "Carmo de Minas",
            "Carmo do Cajuru",
            "Carmo do Paranaíba",
            "Carmo do Rio Claro",
            "Carmópolis de Minas",
            "Carneirinho",
            "Carrancas",
            "Carvalhópolis",
            "Carvalhos",
            "Casa Grande",
            "Cascalho Rico",
            "Cássia",
            "Cataguases",
            "Catas Altas",
            "Catas Altas da Noruega",
            "Catuji",
            "Catuti",
            "Caxambu",
            "Cedro do Abaeté",
            "Central de Minas",
            "Centralina",
            "Chácara",
            "Chalé",
            "Chapada do Norte",
            "Chapada Gaúcha",
            "Chiador",
            "Cipotânea",
            "Claraval",
            "Claro dos Poções",
            "Cláudio",
            "Coimbra",
            "Coluna",
            "Comendador Gomes",
            "Comercinho",
            "Conceição da Aparecida",
            "Conceição da Barra de Minas",
            "Conceição das Alagoas",
            "Conceição das Pedras",
            "Conceição de Ipanema",
            "Conceição do Mato Dentro",
            "Conceição do Pará",
            "Conceição do Rio Verde",
            "Conceição dos Ouros",
            "Cônego Marinho",
            "Confins",
            "Congonhal",
            "Congonhas",
            "Congonhas do Norte",
            "Conquista",
            "Conselheiro Lafaiete",
            "Conselheiro Pena",
            "Consolação",
            "Contagem",
            "Coqueiral",
            "Coração de Jesus",
            "Cordisburgo",
            "Cordislândia",
            "Corinto",
            "Coroaci",
            "Coromandel",
            "Coronel Fabriciano",
            "Coronel Murta",
            "Coronel Pacheco",
            "Coronel Xavier Chaves",
            "Córrego Danta",
            "Córrego do Bom Jesus",
            "Córrego Fundo",
            "Córrego Novo",
            "Couto de Magalhães de Minas",
            "Crisólita",
            "Cristais",
            "Cristália",
            "Cristiano Otoni",
            "Cristina",
            "Crucilândia",
            "Cruzeiro da Fortaleza",
            "Cruzília",
            "Cuparaque",
            "Curral de Dentro",
            "Curvelo",
            "Datas",
            "Delfim Moreira",
            "Delfinópolis",
            "Delta",
            "Descoberto",
            "Desterro de Entre Rios",
            "Desterro do Melo",
            "Diamantina",
            "Diogo de Vasconcelos",
            "Dionísio",
            "Divinésia",
            "Divino",
            "Divino das Laranjeiras",
            "Divinolândia de Minas",
            "Divinópolis",
            "Divisa Alegre",
            "Divisa Nova",
            "Divisópolis",
            "Dom Bosco",
            "Dom Cavati",
            "Dom Joaquim",
            "Dom Silvério",
            "Dom Viçoso",
            "Dona Euzébia",
            "Dores de Campos",
            "Dores de Guanhães",
            "Dores do Indaiá",
            "Dores do Turvo",
            "Doresópolis",
            "Douradoquara",
            "Durandé",
            "Elói Mendes",
            "Engenheiro Caldas",
            "Engenheiro Navarro",
            "Entre Folhas",
            "Entre Rios de Minas",
            "Ervália",
            "Esmeraldas",
            "Espera Feliz",
            "Espinosa",
            "Espírito Santo do Dourado",
            "Estiva",
            "Estrela Dalva",
            "Estrela do Indaiá",
            "Estrela do Sul",
            "Eugenópolis",
            "Ewbank da Câmara",
            "Extrema",
            "Fama",
            "Faria Lemos",
            "Felício dos Santos",
            "Felisburgo",
            "Felixlândia",
            "Fernandes Tourinho",
            "Ferros",
            "Fervedouro",
            "Florestal",
            "Formiga",
            "Formoso",
            "Fortaleza de Minas",
            "Fortuna de Minas",
            "Francisco Badaró",
            "Francisco Dumont",
            "Francisco Sá",
            "Franciscópolis",
            "Frei Gaspar",
            "Frei Inocêncio",
            "Frei Lagonegro",
            "Fronteira",
            "Fronteira dos Vales",
            "Fruta de Leite",
            "Frutal",
            "Funilândia",
            "Galiléia",
            "Gameleiras",
            "Glaucilândia",
            "Goiabeira",
            "Goianá",
            "Gonçalves",
            "Gonzaga",
            "Gouveia",
            "Governador Valadares",
            "Grão Mogol",
            "Grupiara",
            "Guanhães",
            "Guapé",
            "Guaraciaba",
            "Guaraciama",
            "Guaranésia",
            "Guarani",
            "Guarará",
            "Guarda-Mor",
            "Guaxupé",
            "Guidoval",
            "Guimarânia",
            "Guiricema",
            "Gurinhatã",
            "Heliodora",
            "Iapu",
            "Ibertioga",
            "Ibiá",
            "Ibiaí",
            "Ibiracatu",
            "Ibiraci",
            "Ibirité",
            "Ibitiúra de Minas",
            "Ibituruna",
            "Icaraí de Minas",
            "Igarapé",
            "Igaratinga",
            "Iguatama",
            "Ijaci",
            "Ilicínea",
            "Imbé de Minas",
            "Inconfidentes",
            "Indaiabira",
            "Indianópolis",
            "Ingaí",
            "Inhapim",
            "Inhaúma",
            "Inimutaba",
            "Ipaba",
            "Ipanema",
            "Ipatinga",
            "Ipiaçu",
            "Ipuiúna",
            "Iraí de Minas",
            "Itabira",
            "Itabirinha de Mantena",
            "Itabirito",
            "Itacambira",
            "Itacarambi",
            "Itaguara",
            "Itaipé",
            "Itajubá",
            "Itamarandiba",
            "Itamarati de Minas",
            "Itambacuri",
            "Itambé do Mato Dentro",
            "Itamogi",
            "Itamonte",
            "Itanhandu",
            "Itanhomi",
            "Itaobim",
            "Itapagipe",
            "Itapecerica",
            "Itapeva",
            "Itatiaiuçu",
            "Itaú de Minas",
            "Itaúna",
            "Itaverava",
            "Itinga",
            "Itueta",
            "Ituiutaba",
            "Itumirim",
            "Iturama",
            "Itutinga",
            "Jaboticatubas",
            "Jacinto",
            "Jacuí",
            "Jacutinga",
            "Jaguaraçu",
            "Jaíba",
            "Jampruca",
            "Janaúba",
            "Januária",
            "Japaraíba",
            "Japonvar",
            "Jeceaba",
            "Jenipapo de Minas",
            "Jequeri",
            "Jequitaí",
            "Jequitibá",
            "Jequitinhonha",
            "Jesuânia",
            "Joaíma",
            "Joanésia",
            "João Monlevade",
            "João Pinheiro",
            "Joaquim Felício",
            "Jordânia",
            "José Gonçalves de Minas",
            "José Raydan",
            "Josenópolis",
            "Juatuba",
            "Juiz de Fora",
            "Juramento",
            "Juruaia",
            "Juvenília",
            "Ladainha",
            "Lagamar",
            "Lagoa da Prata",
            "Lagoa dos Patos",
            "Lagoa Dourada",
            "Lagoa Formosa",
            "Lagoa Grande",
            "Lagoa Santa",
            "Lajinha",
            "Lambari",
            "Lamim",
            "Laranjal",
            "Lassance",
            "Lavras",
            "Leandro Ferreira",
            "Leme do Prado",
            "Leopoldina",
            "Liberdade",
            "Lima Duarte",
            "Limeira do Oeste",
            "Lontra",
            "Luisburgo",
            "Luislândia",
            "Luminárias",
            "Luz",
            "Machacalis",
            "Machado",
            "Madre de Deus de Minas",
            "Malacacheta",
            "Mamonas",
            "Manga",
            "Manhuaçu",
            "Manhumirim",
            "Mantena",
            "Mar de Espanha",
            "Maravilhas",
            "Maria da Fé",
            "Mariana",
            "Marilac",
            "Mário Campos",
            "Maripá de Minas",
            "Marliéria",
            "Marmelópolis",
            "Martinho Campos",
            "Martins Soares",
            "Mata Verde",
            "Materlândia",
            "Mateus Leme",
            "Mathias Lobato",
            "Matias Barbosa",
            "Matias Cardoso",
            "Matipó",
            "Mato Verde",
            "Matozinhos",
            "Matutina",
            "Medeiros",
            "Medina",
            "Mendes Pimentel",
            "Mercês",
            "Mesquita",
            "Minas Novas",
            "Minduri",
            "Mirabela",
            "Miradouro",
            "Miraí",
            "Miravânia",
            "Moeda",
            "Moema",
            "Monjolos",
            "Monsenhor Paulo",
            "Montalvânia",
            "Monte Alegre de Minas",
            "Monte Azul",
            "Monte Belo",
            "Monte Carmelo",
            "Monte Formoso",
            "Monte Santo de Minas",
            "Monte Sião",
            "Montes Claros",
            "Montezuma",
            "Morada Nova de Minas",
            "Morro da Garça",
            "Morro do Pilar",
            "Munhoz",
            "Muriaé",
            "Mutum",
            "Muzambinho",
            "Nacip Raydan",
            "Nanuque",
            "Naque",
            "Natalândia",
            "Natércia",
            "Nazareno",
            "Nepomuceno",
            "Ninheira",
            "Nova Belém",
            "Nova Era",
            "Nova Lima",
            "Nova Módica",
            "Nova Ponte",
            "Nova Porteirinha",
            "Nova Resende",
            "Nova Serrana",
            "Nova União",
            "Novo Cruzeiro",
            "Novo Oriente de Minas",
            "Novorizonte",
            "Olaria",
            "Olhos-d'Água",
            "Olímpio Noronha",
            "Oliveira",
            "Oliveira Fortes",
            "Onça de Pitangui",
            "Oratórios",
            "Orizânia",
            "Ouro Branco",
            "Ouro Fino",
            "Ouro Preto",
            "Ouro Verde de Minas",
            "Padre Carvalho",
            "Padre Paraíso",
            "Pai Pedro",
            "Paineiras",
            "Pains",
            "Paiva",
            "Palma",
            "Palmópolis",
            "Papagaios",
            "Pará de Minas",
            "Paracatu",
            "Paraguaçu",
            "Paraisópolis",
            "Paraopeba",
            "Passa Quatro",
            "Passa Tempo",
            "Passa-Vinte",
            "Passabém",
            "Passos",
            "Patis",
            "Patos de Minas",
            "Patrocínio",
            "Patrocínio do Muriaé",
            "Paula Cândido",
            "Paulistas",
            "Pavão",
            "Peçanha",
            "Pedra Azul",
            "Pedra Bonita",
            "Pedra do Anta",
            "Pedra do Indaiá",
            "Pedra Dourada",
            "Pedralva",
            "Pedras de Maria da Cruz",
            "Pedrinópolis",
            "Pedro Leopoldo",
            "Pedro Teixeira",
            "Pequeri",
            "Pequi",
            "Perdigão",
            "Perdizes",
            "Perdões",
            "Periquito",
            "Pescador",
            "Piau",
            "Piedade de Caratinga",
            "Piedade de Ponte Nova",
            "Piedade do Rio Grande",
            "Piedade dos Gerais",
            "Pimenta",
            "Pingo-d'Água",
            "Pintópolis",
            "Piracema",
            "Pirajuba",
            "Piranga",
            "Piranguçu",
            "Piranguinho",
            "Pirapetinga",
            "Pirapora",
            "Piraúba",
            "Pitangui",
            "Piumhi",
            "Planura",
            "Poço Fundo",
            "Poços de Caldas",
            "Pocrane",
            "Pompéu",
            "Ponte Nova",
            "Ponto Chique",
            "Ponto dos Volantes",
            "Porteirinha",
            "Porto Firme",
            "Poté",
            "Pouso Alegre",
            "Pouso Alto",
            "Prados",
            "Prata",
            "Pratápolis",
            "Pratinha",
            "Presidente Bernardes",
            "Presidente Juscelino",
            "Presidente Kubitschek",
            "Presidente Olegário",
            "Prudente de Morais",
            "Quartel Geral",
            "Queluzito",
            "Raposos",
            "Raul Soares",
            "Recreio",
            "Reduto",
            "Resende Costa",
            "Resplendor",
            "Ressaquinha",
            "Riachinho",
            "Riacho dos Machados",
            "Ribeirão das Neves",
            "Ribeirão Vermelho",
            "Rio Acima",
            "Rio Casca",
            "Rio do Prado",
            "Rio Doce",
            "Rio Espera",
            "Rio Manso",
            "Rio Novo",
            "Rio Paranaíba",
            "Rio Pardo de Minas",
            "Rio Piracicaba",
            "Rio Pomba",
            "Rio Preto",
            "Rio Vermelho",
            "Ritápolis",
            "Rochedo de Minas",
            "Rodeiro",
            "Romaria",
            "Rosário da Limeira",
            "Rubelita",
            "Rubim",
            "Sabará",
            "Sabinópolis",
            "Sacramento",
            "Salinas",
            "Salto da Divisa",
            "Santa Bárbara",
            "Santa Bárbara do Leste",
            "Santa Bárbara do Monte Verde",
            "Santa Bárbara do Tugúrio",
            "Santa Cruz de Minas",
            "Santa Cruz de Salinas",
            "Santa Cruz do Escalvado",
            "Santa Efigênia de Minas",
            "Santa Fé de Minas",
            "Santa Helena de Minas",
            "Santa Juliana",
            "Santa Luzia",
            "Santa Margarida",
            "Santa Maria de Itabira",
            "Santa Maria do Salto",
            "Santa Maria do Suaçuí",
            "Santa Rita de Caldas",
            "Santa Rita de Ibitipoca",
            "Santa Rita de Jacutinga",
            "Santa Rita de Minas",
            "Santa Rita do Itueto",
            "Santa Rita do Sapucaí",
            "Santa Rosa da Serra",
            "Santa Vitória",
            "Santana da Vargem",
            "Santana de Cataguases",
            "Santana de Pirapama",
            "Santana do Deserto",
            "Santana do Garambéu",
            "Santana do Jacaré",
            "Santana do Manhuaçu",
            "Santana do Paraíso",
            "Santana do Riacho",
            "Santana dos Montes",
            "Santo Antônio do Amparo",
            "Santo Antônio do Aventureiro",
            "Santo Antônio do Grama",
            "Santo Antônio do Itambé",
            "Santo Antônio do Jacinto",
            "Santo Antônio do Monte",
            "Santo Antônio do Retiro",
            "Santo Antônio do Rio Abaixo",
            "Santo Hipólito",
            "Santos Dumont",
            "São Bento Abade",
            "São Brás do Suaçuí",
            "São Domingos das Dores",
            "São Domingos do Prata",
            "São Félix de Minas",
            "São Francisco",
            "São Francisco de Paula",
            "São Francisco de Sales",
            "São Francisco do Glória",
            "São Geraldo",
            "São Geraldo da Piedade",
            "São Geraldo do Baixio",
            "São Gonçalo do Abaeté",
            "São Gonçalo do Pará",
            "São Gonçalo do Rio Abaixo",
            "São Gonçalo do Rio Preto",
            "São Gonçalo do Sapucaí",
            "São Gotardo",
            "São João Batista do Glória",
            "São João da Lagoa",
            "São João da Mata",
            "São João da Ponte",
            "São João das Missões",
            "São João del Rei",
            "São João do Manhuaçu",
            "São João do Manteninha",
            "São João do Oriente",
            "São João do Pacuí",
            "São João do Paraíso",
            "São João Evangelista",
            "São João Nepomuceno",
            "São Joaquim de Bicas",
            "São José da Barra",
            "São José da Lapa",
            "São José da Safira",
            "São José da Varginha",
            "São José do Alegre",
            "São José do Divino",
            "São José do Goiabal",
            "São José do Jacuri",
            "São José do Mantimento",
            "São Lourenço",
            "São Miguel do Anta",
            "São Pedro da União",
            "São Pedro do Suaçuí",
            "São Pedro dos Ferros",
            "São Romão",
            "São Roque de Minas",
            "São Sebastião da Bela Vista",
            "São Sebastião da Vargem Alegre",
            "São Sebastião do Anta",
            "São Sebastião do Maranhão",
            "São Sebastião do Oeste",
            "São Sebastião do Paraíso",
            "São Sebastião do Rio Preto",
            "São Sebastião do Rio Verde",
            "São Thomé das Letras",
            "São Tiago",
            "São Tomás de Aquino",
            "São Vicente de Minas",
            "Sapucaí-Mirim",
            "Sardoá",
            "Sarzedo",
            "Sem-Peixe",
            "Senador Amaral",
            "Senador Cortes",
            "Senador Firmino",
            "Senador José Bento",
            "Senador Modestino Gonçalves",
            "Senhora de Oliveira",
            "Senhora do Porto",
            "Senhora dos Remédios",
            "Sericita",
            "Seritinga",
            "Serra Azul de Minas",
            "Serra da Saudade",
            "Serra do Salitre",
            "Serra dos Aimorés",
            "Serrania",
            "Serranópolis de Minas",
            "Serranos",
            "Serro",
            "Sete Lagoas",
            "Setubinha",
            "Silveirânia",
            "Silvianópolis",
            "Simão Pereira",
            "Simonésia",
            "Sobrália",
            "Soledade de Minas",
            "Tabuleiro",
            "Taiobeiras",
            "Taparuba",
            "Tapira",
            "Tapiraí",
            "Taquaraçu de Minas",
            "Tarumirim",
            "Teixeiras",
            "Teófilo Otoni",
            "Timóteo",
            "Tiradentes",
            "Tiros",
            "Tocantins",
            "Tocos do Moji",
            "Toledo",
            "Tombos",
            "Três Corações",
            "Três Marias",
            "Três Pontas",
            "Tumiritinga",
            "Tupaciguara",
            "Turmalina",
            "Turvolândia",
            "Ubá",
            "Ubaí",
            "Ubaporanga",
            "Uberaba",
            "Uberlândia",
            "Umburatiba",
            "Unaí",
            "União de Minas",
            "Uruana de Minas",
            "Urucânia",
            "Urucuia",
            "Vargem Alegre",
            "Vargem Bonita",
            "Vargem Grande do Rio Pardo",
            "Varginha",
            "Varjão de Minas",
            "Várzea da Palma",
            "Varzelândia",
            "Vazante",
            "Verdelândia",
            "Veredinha",
            "Veríssimo",
            "Vermelho Novo",
            "Vespasiano",
            "Viçosa",
            "Vieiras",
            "Virgem da Lapa",
            "Virgínia",
            "Virginópolis",
            "Virgolândia",
            "Visconde do Rio Branco",
            "Volta Grande",
            "Wenceslau Braz"
        ]
    },
    {
        uf: "MS",
        state: "Mato Grosso do Sul",
        city: [
            "Água Clara",
            "Alcinópolis",
            "Amambaí",
            "Anastácio",
            "Anaurilândia",
            "Angélica",
            "Antônio João",
            "Aparecida do Taboado",
            "Aquidauana",
            "Aral Moreira",
            "Bandeirantes",
            "Bataguassu",
            "Bataiporã",
            "Bela Vista",
            "Bodoquena",
            "Bonito",
            "Brasilândia",
            "Caarapó",
            "Camapuã",
            "Campo Grande",
            "Caracol",
            "Cassilândia",
            "Chapadão do Sul",
            "Corguinho",
            "Coronel Sapucaia",
            "Corumbá",
            "Costa Rica",
            "Coxim",
            "Deodápolis",
            "Dois Irmãos do Buriti",
            "Douradina",
            "Dourados",
            "Eldorado",
            "Fátima do Sul",
            "Glória de Dourados",
            "Guia Lopes da Laguna",
            "Iguatemi",
            "Inocência",
            "Itaporã",
            "Itaquiraí",
            "Ivinhema",
            "Japorã",
            "Jaraguari",
            "Jardim",
            "Jateí",
            "Juti",
            "Ladário",
            "Laguna Carapã",
            "Maracaju",
            "Miranda",
            "Mundo Novo",
            "Naviraí",
            "Nioaque",
            "Nova Alvorada do Sul",
            "Nova Andradina",
            "Novo Horizonte do Sul",
            "Paranaíba",
            "Paranhos",
            "Pedro Gomes",
            "Ponta Porã",
            "Porto Murtinho",
            "Ribas do Rio Pardo",
            "Rio Brilhante",
            "Rio Negro",
            "Rio Verde de Mato Grosso",
            "Rochedo",
            "Santa Rita do Pardo",
            "São Gabriel do Oeste",
            "Selvíria",
            "Sete Quedas",
            "Sidrolândia",
            "Sonora",
            "Tacuru",
            "Taquarussu",
            "Terenos",
            "Três Lagoas",
            "Vicentina"
        ]
    },
    {
        uf: "MT",
        state: "Mato Grosso",
        city: [
            "Acorizal",
            "Água Boa",
            "Alta Floresta",
            "Alto Araguaia",
            "Alto Boa Vista",
            "Alto Garças",
            "Alto Paraguai",
            "Alto Taquari",
            "Apiacás",
            "Araguaiana",
            "Araguainha",
            "Araputanga",
            "Arenápolis",
            "Aripuanã",
            "Barão de Melgaço",
            "Barra do Bugres",
            "Barra do Garças",
            "Bom Jesus do Araguaia",
            "Brasnorte",
            "Cáceres",
            "Campinápolis",
            "Campo Novo do Parecis",
            "Campo Verde",
            "Campos de Júlio",
            "Canabrava do Norte",
            "Canarana",
            "Carlinda",
            "Castanheira",
            "Chapada dos Guimarães",
            "Cláudia",
            "Cocalinho",
            "Colíder",
            "Colniza",
            "Comodoro",
            "Confresa",
            "Conquista d'Oeste",
            "Cotriguaçu",
            "Curvelândia",
            "Cuiabá",
            "Denise",
            "Diamantino",
            "Dom Aquino",
            "Feliz Natal",
            "Figueirópolis d'Oeste",
            "Gaúcha do Norte",
            "General Carneiro",
            "Glória d'Oeste",
            "Guarantã do Norte",
            "Guiratinga",
            "Indiavaí",
            "Itaúba",
            "Itiquira",
            "Jaciara",
            "Jangada",
            "Jauru",
            "Juara",
            "Juína",
            "Juruena",
            "Juscimeira",
            "Lambari d'Oeste",
            "Lucas do Rio Verde",
            "Luciára",
            "Marcelândia",
            "Matupá",
            "Mirassol d'Oeste",
            "Nobres",
            "Nortelândia",
            "Nossa Senhora do Livramento",
            "Nova Bandeirantes",
            "Nova Brasilândia",
            "Nova Canãa do Norte",
            "Nova Guarita",
            "Nova Lacerda",
            "Nova Marilândia",
            "Nova Maringá",
            "Nova Monte Verde",
            "Nova Mutum",
            "Nova Nazaré",
            "Nova Olímpia",
            "Nova Santa Helena",
            "Nova Ubiratã",
            "Nova Xavantina",
            "Novo Horizonte do Norte",
            "Novo Mundo",
            "Novo Santo Antônio",
            "Novo São Joaquim",
            "Paranaíta",
            "Paranatinga",
            "Pedra Preta",
            "Peixoto de Azevedo",
            "Planalto da Serra",
            "Poconé",
            "Pontal do Araguaia",
            "Ponte Branca",
            "Pontes e Lacerda",
            "Porto Alegre do Norte",
            "Porto dos Gaúchos",
            "Porto Esperidião",
            "Porto Estrela",
            "Poxoréo",
            "Primavera do Leste",
            "Querência",
            "Reserva do Cabaçal",
            "Ribeirão Cascalheira",
            "Ribeirãozinho",
            "Rio Branco",
            "Rondolândia",
            "Rondonópolis",
            "Rosário Oeste",
            "Salto do Céu",
            "Santa Carmem",
            "Santa Cruz do Xingu",
            "Santa Rita do Trivelato",
            "Santa Terezinha",
            "Santo Afonso",
            "Santo Antônio do Leste",
            "Santo Antônio do Leverger",
            "São Félix do Araguaia",
            "São José do Povo",
            "São José do Rio Claro",
            "São José do Xingu",
            "São José dos Quatro Marcos",
            "São Pedro da Cipa",
            "Sapezal",
            "Serra Nova Dourada",
            "Sinop",
            "Sorriso",
            "Tabaporã",
            "Tangará da Serra",
            "Tapurah",
            "Terra Nova do Norte",
            "Tesouro",
            "Torixoréu",
            "União do Sul",
            "Vale de São Domingos",
            "Várzea Grande",
            "Vera",
            "Vila Bela da Santíssima Trindade",
            "Vila Rica"
        ]
    },
    {
        uf: "PA",
        state: "Pará",
        city: [
            "Abaetetuba",
            "Abel Figueiredo",
            "Acará",
            "Afuá",
            "Água Azul do Norte",
            "Alenquer",
            "Almeirim",
            "Altamira",
            "Anajás",
            "Ananindeua",
            "Anapu",
            "Augusto Corrêa",
            "Aurora do Pará",
            "Aveiro",
            "Bagre",
            "Baião",
            "Bannach",
            "Barcarena",
            "Belém",
            "Belterra",
            "Benevides",
            "Bom Jesus do Tocantins",
            "Bonito",
            "Bragança",
            "Brasil Novo",
            "Brejo Grande do Araguaia",
            "Breu Branco",
            "Breves",
            "Bujaru",
            "Cachoeira do Arari",
            "Cachoeira do Piriá",
            "Cametá",
            "Canaã dos Carajás",
            "Capanema",
            "Capitão Poço",
            "Castanhal",
            "Chaves",
            "Colares",
            "Conceição do Araguaia",
            "Concórdia do Pará",
            "Cumaru do Norte",
            "Curionópolis",
            "Curralinho",
            "Curuá",
            "Curuçá",
            "Dom Eliseu",
            "Eldorado dos Carajás",
            "Faro",
            "Floresta do Araguaia",
            "Garrafão do Norte",
            "Goianésia do Pará",
            "Gurupá",
            "Igarapé-Açu",
            "Igarapé-Miri",
            "Inhangapi",
            "Ipixuna do Pará",
            "Irituia",
            "Itaituba",
            "Itupiranga",
            "Jacareacanga",
            "Jacundá",
            "Juruti",
            "Limoeiro do Ajuru",
            "Mãe do Rio",
            "Magalhães Barata",
            "Marabá",
            "Maracanã",
            "Marapanim",
            "Marituba",
            "Medicilândia",
            "Melgaço",
            "Mocajuba",
            "Moju",
            "Monte Alegre",
            "Muaná",
            "Nova Esperança do Piriá",
            "Nova Ipixuna",
            "Nova Timboteua",
            "Novo Progresso",
            "Novo Repartimento",
            "Óbidos",
            "Oeiras do Pará",
            "Oriximiná",
            "Ourém",
            "Ourilândia do Norte",
            "Pacajá",
            "Palestina do Pará",
            "Paragominas",
            "Parauapebas",
            "Pau d'Arco",
            "Peixe-Boi",
            "Piçarra",
            "Placas",
            "Ponta de Pedras",
            "Portel",
            "Porto de Moz",
            "Prainha",
            "Primavera",
            "Quatipuru",
            "Redenção",
            "Rio Maria",
            "Rondon do Pará",
            "Rurópolis",
            "Salinópolis",
            "Salvaterra",
            "Santa Bárbara do Pará",
            "Santa Cruz do Arari",
            "Santa Isabel do Pará",
            "Santa Luzia do Pará",
            "Santa Maria das Barreiras",
            "Santa Maria do Pará",
            "Santana do Araguaia",
            "Santarém",
            "Santarém Novo",
            "Santo Antônio do Tauá",
            "São Caetano de Odivela",
            "São Domingos do Araguaia",
            "São Domingos do Capim",
            "São Félix do Xingu",
            "São Francisco do Pará",
            "São Geraldo do Araguaia",
            "São João da Ponta",
            "São João de Pirabas",
            "São João do Araguaia",
            "São Miguel do Guamá",
            "São Sebastião da Boa Vista",
            "Sapucaia",
            "Senador José Porfírio",
            "Soure",
            "Tailândia",
            "Terra Alta",
            "Terra Santa",
            "Tomé-Açu",
            "Tracuateua",
            "Trairão",
            "Tucumã",
            "Tucuruí",
            "Ulianópolis",
            "Uruará",
            "Vigia",
            "Viseu",
            "Vitória do Xingu",
            "Xinguara"
        ]
    },
    {
        uf: "PB",
        state: "Paraíba",
        city: [
            "Água Branca",
            "Aguiar",
            "Alagoa Grande",
            "Alagoa Nova",
            "Alagoinha",
            "Alcantil",
            "Algodão de Jandaíra",
            "Alhandra",
            "Amparo",
            "Aparecida",
            "Araçagi",
            "Arara",
            "Araruna",
            "Areia",
            "Areia de Baraúnas",
            "Areial",
            "Aroeiras",
            "Assunção",
            "Baía da Traição",
            "Bananeiras",
            "Baraúna",
            "Barra de Santa Rosa",
            "Barra de Santana",
            "Barra de São Miguel",
            "Bayeux",
            "Belém",
            "Belém do Brejo do Cruz",
            "Bernardino Batista",
            "Boa Ventura",
            "Boa Vista",
            "Bom Jesus",
            "Bom Sucesso",
            "Bonito de Santa Fé",
            "Boqueirão",
            "Borborema",
            "Brejo do Cruz",
            "Brejo dos Santos",
            "Caaporã",
            "Cabaceiras",
            "Cabedelo",
            "Cachoeira dos Índios",
            "Cacimba de Areia",
            "Cacimba de Dentro",
            "Cacimbas",
            "Caiçara",
            "Cajazeiras",
            "Cajazeirinhas",
            "Caldas Brandão",
            "Camalaú",
            "Campina Grande",
            "Campo de Santana",
            "Capim",
            "Caraúbas",
            "Carrapateira",
            "Casserengue",
            "Catingueira",
            "Catolé do Rocha",
            "Caturité",
            "Conceição",
            "Condado",
            "Conde",
            "Congo",
            "Coremas",
            "Coxixola",
            "Cruz do Espírito Santo",
            "Cubati",
            "Cuité",
            "Cuité de Mamanguape",
            "Cuitegi",
            "Curral de Cima",
            "Curral Velho",
            "Damião",
            "Desterro",
            "Diamante",
            "Dona Inês",
            "Duas Estradas",
            "Emas",
            "Esperança",
            "Fagundes",
            "Frei Martinho",
            "Gado Bravo",
            "Guarabira",
            "Gurinhém",
            "Gurjão",
            "Ibiara",
            "Igaracy",
            "Imaculada",
            "Ingá",
            "Itabaiana",
            "Itaporanga",
            "Itapororoca",
            "Itatuba",
            "Jacaraú",
            "Jericó",
            "João Pessoa",
            "Juarez Távora",
            "Juazeirinho",
            "Junco do Seridó",
            "Juripiranga",
            "Juru",
            "Lagoa",
            "Lagoa de Dentro",
            "Lagoa Seca",
            "Lastro",
            "Livramento",
            "Logradouro",
            "Lucena",
            "Mãe d'Água",
            "Malta",
            "Mamanguape",
            "Manaíra",
            "Marcação",
            "Mari",
            "Marizópolis",
            "Massaranduba",
            "Mataraca",
            "Matinhas",
            "Mato Grosso",
            "Maturéia",
            "Mogeiro",
            "Montadas",
            "Monte Horebe",
            "Monteiro",
            "Mulungu",
            "Natuba",
            "Nazarezinho",
            "Nova Floresta",
            "Nova Olinda",
            "Nova Palmeira",
            "Olho d'Água",
            "Olivedos",
            "Ouro Velho",
            "Parari",
            "Passagem",
            "Patos",
            "Paulista",
            "Pedra Branca",
            "Pedra Lavrada",
            "Pedras de Fogo",
            "Pedro Régis",
            "Piancó",
            "Picuí",
            "Pilar",
            "Pilões",
            "Pilõezinhos",
            "Pirpirituba",
            "Pitimbu",
            "Pocinhos",
            "Poço Dantas",
            "Poço de José de Moura",
            "Pombal",
            "Prata",
            "Princesa Isabel",
            "Puxinanã",
            "Queimadas",
            "Quixabá",
            "Remígio",
            "Riachão",
            "Riachão do Bacamarte",
            "Riachão do Poço",
            "Riacho de Santo Antônio",
            "Riacho dos Cavalos",
            "Rio Tinto",
            "Salgadinho",
            "Salgado de São Félix",
            "Santa Cecília",
            "Santa Cruz",
            "Santa Helena",
            "Santa Inês",
            "Santa Luzia",
            "Santa Rita",
            "Santa Teresinha",
            "Santana de Mangueira",
            "Santana dos Garrotes",
            "Santarém",
            "Santo André",
            "São Bentinho",
            "São Bento",
            "São Domingos de Pombal",
            "São Domingos do Cariri",
            "São Francisco",
            "São João do Cariri",
            "São João do Rio do Peixe",
            "São João do Tigre",
            "São José da Lagoa Tapada",
            "São José de Caiana",
            "São José de Espinharas",
            "São José de Piranhas",
            "São José de Princesa",
            "São José do Bonfim",
            "São José do Brejo do Cruz",
            "São José do Sabugi",
            "São José dos Cordeiros",
            "São José dos Ramos",
            "São Mamede",
            "São Miguel de Taipu",
            "São Sebastião de Lagoa de Roça",
            "São Sebastião do Umbuzeiro",
            "Sapé",
            "Seridó",
            "Serra Branca",
            "Serra da Raiz",
            "Serra Grande",
            "Serra Redonda",
            "Serraria",
            "Sertãozinho",
            "Sobrado",
            "Solânea",
            "Soledade",
            "Sossêgo",
            "Sousa",
            "Sumé",
            "Taperoá",
            "Tavares",
            "Teixeira",
            "Tenório",
            "Triunfo",
            "Uiraúna",
            "Umbuzeiro",
            "Várzea",
            "Vieirópolis",
            "Vista Serrana",
            "Zabelê"
        ]
    },
    {
        uf: "PE",
        state: "Pernambuco",
        city: [
            "Abreu e Lima",
            "Afogados da Ingazeira",
            "Afrânio",
            "Agrestina",
            "Água Preta",
            "Águas Belas",
            "Alagoinha",
            "Aliança",
            "Altinho",
            "Amaraji",
            "Angelim",
            "Araçoiaba",
            "Araripina",
            "Arcoverde",
            "Barra de Guabiraba",
            "Barreiros",
            "Belém de Maria",
            "Belém de São Francisco",
            "Belo Jardim",
            "Betânia",
            "Bezerros",
            "Bodocó",
            "Bom Conselho",
            "Bom Jardim",
            "Bonito",
            "Brejão",
            "Brejinho",
            "Brejo da Madre de Deus",
            "Buenos Aires",
            "Buíque",
            "Cabo de Santo Agostinho",
            "Cabrobó",
            "Cachoeirinha",
            "Caetés",
            "Calçado",
            "Calumbi",
            "Camaragibe",
            "Camocim de São Félix",
            "Camutanga",
            "Canhotinho",
            "Capoeiras",
            "Carnaíba",
            "Carnaubeira da Penha",
            "Carpina",
            "Caruaru",
            "Casinhas",
            "Catende",
            "Cedro",
            "Chã de Alegria",
            "Chã Grande",
            "Condado",
            "Correntes",
            "Cortês",
            "Cumaru",
            "Cupira",
            "Custódia",
            "Dormentes",
            "Escada",
            "Exu",
            "Feira Nova",
            "Fernando de Noronha",
            "Ferreiros",
            "Flores",
            "Floresta",
            "Frei Miguelinho",
            "Gameleira",
            "Garanhuns",
            "Glória do Goitá",
            "Goiana",
            "Granito",
            "Gravatá",
            "Iati",
            "Ibimirim",
            "Ibirajuba",
            "Igarassu",
            "Iguaraci",
            "Inajá",
            "Ingazeira",
            "Ipojuca",
            "Ipubi",
            "Itacuruba",
            "Itaíba",
            "Itamaracá",
            "Itambé",
            "Itapetim",
            "Itapissuma",
            "Itaquitinga",
            "Jaboatão dos Guararapes",
            "Jaqueira",
            "Jataúba",
            "Jatobá",
            "João Alfredo",
            "Joaquim Nabuco",
            "Jucati",
            "Jupi",
            "Jurema",
            "Lagoa do Carro",
            "Lagoa do Itaenga",
            "Lagoa do Ouro",
            "Lagoa dos Gatos",
            "Lagoa Grande",
            "Lajedo",
            "Limoeiro",
            "Macaparana",
            "Machados",
            "Manari",
            "Maraial",
            "Mirandiba",
            "Moreilândia",
            "Moreno",
            "Nazaré da Mata",
            "Olinda",
            "Orobó",
            "Orocó",
            "Ouricuri",
            "Palmares",
            "Palmeirina",
            "Panelas",
            "Paranatama",
            "Parnamirim",
            "Passira",
            "Paudalho",
            "Paulista",
            "Pedra",
            "Pesqueira",
            "Petrolândia",
            "Petrolina",
            "Poção",
            "Pombos",
            "Primavera",
            "Quipapá",
            "Quixaba",
            "Recife",
            "Riacho das Almas",
            "Ribeirão",
            "Rio Formoso",
            "Sairé",
            "Salgadinho",
            "Salgueiro",
            "Saloá",
            "Sanharó",
            "Santa Cruz",
            "Santa Cruz da Baixa Verde",
            "Santa Cruz do Capibaribe",
            "Santa Filomena",
            "Santa Maria da Boa Vista",
            "Santa Maria do Cambucá",
            "Santa Terezinha",
            "São Benedito do Sul",
            "São Bento do Una",
            "São Caitano",
            "São João",
            "São Joaquim do Monte",
            "São José da Coroa Grande",
            "São José do Belmonte",
            "São José do Egito",
            "São Lourenço da Mata",
            "São Vicente Ferrer",
            "Serra Talhada",
            "Serrita",
            "Sertânia",
            "Sirinhaém",
            "Solidão",
            "Surubim",
            "Tabira",
            "Tacaimbó",
            "Tacaratu",
            "Tamandaré",
            "Taquaritinga do Norte",
            "Terezinha",
            "Terra Nova",
            "Timbaúba",
            "Toritama",
            "Tracunhaém",
            "Trindade",
            "Triunfo",
            "Tupanatinga",
            "Tuparetama",
            "Venturosa",
            "Verdejante",
            "Vertente do Lério",
            "Vertentes",
            "Vicência",
            "Vitória de Santo Antão",
            "Xexéu"
        ]
    },
    {
        uf: "PI",
        state: "Piauí",
        city: [
            "Acauã",
            "Agricolândia",
            "Água Branca",
            "Alagoinha do Piauí",
            "Alegrete do Piauí",
            "Alto Longá",
            "Altos",
            "Alvorada do Gurguéia",
            "Amarante",
            "Angical do Piauí",
            "Anísio de Abreu",
            "Antônio Almeida",
            "Aroazes",
            "Arraial",
            "Assunção do Piauí",
            "Avelino Lopes",
            "Baixa Grande do Ribeiro",
            "Barra d'Alcântara",
            "Barras",
            "Barreiras do Piauí",
            "Barro Duro",
            "Batalha",
            "Bela Vista do Piauí",
            "Belém do Piauí",
            "Beneditinos",
            "Bertolínia",
            "Betânia do Piauí",
            "Boa Hora",
            "Bocaina",
            "Bom Jesus",
            "Bom Princípio do Piauí",
            "Bonfim do Piauí",
            "Boqueirão do Piauí",
            "Brasileira",
            "Brejo do Piauí",
            "Buriti dos Lopes",
            "Buriti dos Montes",
            "Cabeceiras do Piauí",
            "Cajazeiras do Piauí",
            "Cajueiro da Praia",
            "Caldeirão Grande do Piauí",
            "Campinas do Piauí",
            "Campo Alegre do Fidalgo",
            "Campo Grande do Piauí",
            "Campo Largo do Piauí",
            "Campo Maior",
            "Canavieira",
            "Canto do Buriti",
            "Capitão de Campos",
            "Capitão Gervásio Oliveira",
            "Caracol",
            "Caraúbas do Piauí",
            "Caridade do Piauí",
            "Castelo do Piauí",
            "Caxingó",
            "Cocal",
            "Cocal de Telha",
            "Cocal dos Alves",
            "Coivaras",
            "Colônia do Gurguéia",
            "Colônia do Piauí",
            "Conceição do Canindé",
            "Coronel José Dias",
            "Corrente",
            "Cristalândia do Piauí",
            "Cristino Castro",
            "Curimatá",
            "Currais",
            "Curral Novo do Piauí",
            "Curralinhos",
            "Demerval Lobão",
            "Dirceu Arcoverde",
            "Dom Expedito Lopes",
            "Dom Inocêncio",
            "Domingos Mourão",
            "Elesbão Veloso",
            "Eliseu Martins",
            "Esperantina",
            "Fartura do Piauí",
            "Flores do Piauí",
            "Floresta do Piauí",
            "Floriano",
            "Francinópolis",
            "Francisco Ayres",
            "Francisco Macedo",
            "Francisco Santos",
            "Fronteiras",
            "Geminiano",
            "Gilbués",
            "Guadalupe",
            "Guaribas",
            "Hugo Napoleão",
            "Ilha Grande",
            "Inhuma",
            "Ipiranga do Piauí",
            "Isaías Coelho",
            "Itainópolis",
            "Itaueira",
            "Jacobina do Piauí",
            "Jaicós",
            "Jardim do Mulato",
            "Jatobá do Piauí",
            "Jerumenha",
            "João Costa",
            "Joaquim Pires",
            "Joca Marques",
            "José de Freitas",
            "Juazeiro do Piauí",
            "Júlio Borges",
            "Jurema",
            "Lagoa Alegre",
            "Lagoa de São Francisco",
            "Lagoa do Barro do Piauí",
            "Lagoa do Piauí",
            "Lagoa do Sítio",
            "Lagoinha do Piauí",
            "Landri Sales",
            "Luís Correia",
            "Luzilândia",
            "Madeiro",
            "Manoel Emídio",
            "Marcolândia",
            "Marcos Parente",
            "Massapê do Piauí",
            "Matias Olímpio",
            "Miguel Alves",
            "Miguel Leão",
            "Milton Brandão",
            "Monsenhor Gil",
            "Monsenhor Hipólito",
            "Monte Alegre do Piauí",
            "Morro Cabeça no Tempo",
            "Morro do Chapéu do Piauí",
            "Murici dos Portelas",
            "Nazaré do Piauí",
            "Nossa Senhora de Nazaré",
            "Nossa Senhora dos Remédios",
            "Nova Santa Rita",
            "Novo Oriente do Piauí",
            "Novo Santo Antônio",
            "Oeiras",
            "Olho d'Água do Piauí",
            "Padre Marcos",
            "Paes Landim",
            "Pajeú do Piauí",
            "Palmeira do Piauí",
            "Palmeirais",
            "Paquetá",
            "Parnaguá",
            "Parnaíba",
            "Passagem Franca do Piauí",
            "Patos do Piauí",
            "Pau d'Arco do Piauí",
            "Paulistana",
            "Pavussu",
            "Pedro II",
            "Pedro Laurentino",
            "Picos",
            "Pimenteiras",
            "Pio IX",
            "Piracuruca",
            "Piripiri",
            "Porto",
            "Porto Alegre do Piauí",
            "Prata do Piauí",
            "Queimada Nova",
            "Redenção do Gurguéia",
            "Regeneração",
            "Riacho Frio",
            "Ribeira do Piauí",
            "Ribeiro Gonçalves",
            "Rio Grande do Piauí",
            "Santa Cruz do Piauí",
            "Santa Cruz dos Milagres",
            "Santa Filomena",
            "Santa Luz",
            "Santa Rosa do Piauí",
            "Santana do Piauí",
            "Santo Antônio de Lisboa",
            "Santo Antônio dos Milagres",
            "Santo Inácio do Piauí",
            "São Braz do Piauí",
            "São Félix do Piauí",
            "São Francisco de Assis do Piauí",
            "São Francisco do Piauí",
            "São Gonçalo do Gurguéia",
            "São Gonçalo do Piauí",
            "São João da Canabrava",
            "São João da Fronteira",
            "São João da Serra",
            "São João da Varjota",
            "São João do Arraial",
            "São João do Piauí",
            "São José do Divino",
            "São José do Peixe",
            "São José do Piauí",
            "São Julião",
            "São Lourenço do Piauí",
            "São Luis do Piauí",
            "São Miguel da Baixa Grande",
            "São Miguel do Fidalgo",
            "São Miguel do Tapuio",
            "São Pedro do Piauí",
            "São Raimundo Nonato",
            "Sebastião Barros",
            "Sebastião Leal",
            "Sigefredo Pacheco",
            "Simões",
            "Simplício Mendes",
            "Socorro do Piauí",
            "Sussuapara",
            "Tamboril do Piauí",
            "Tanque do Piauí",
            "Teresina",
            "União",
            "Uruçuí",
            "Valença do Piauí",
            "Várzea Branca",
            "Várzea Grande",
            "Vera Mendes",
            "Vila Nova do Piauí",
            "Wall Ferraz"
        ]
    },
    {
        uf: "PR",
        state: "Paraná",
        city: [
            "Abatiá",
            "Adrianópolis",
            "Agudos do Sul",
            "Almirante Tamandaré",
            "Altamira do Paraná",
            "Alto Paraná",
            "Alto Piquiri",
            "Altônia",
            "Alvorada do Sul",
            "Amaporã",
            "Ampére",
            "Anahy",
            "Andirá",
            "Ângulo",
            "Antonina",
            "Antônio Olinto",
            "Apucarana",
            "Arapongas",
            "Arapoti",
            "Arapuã",
            "Araruna",
            "Araucária",
            "Ariranha do Ivaí",
            "Assaí",
            "Assis Chateaubriand",
            "Astorga",
            "Atalaia",
            "Balsa Nova",
            "Bandeirantes",
            "Barbosa Ferraz",
            "Barra do Jacaré",
            "Barracão",
            "Bela Vista da Caroba",
            "Bela Vista do Paraíso",
            "Bituruna",
            "Boa Esperança",
            "Boa Esperança do Iguaçu",
            "Boa Ventura de São Roque",
            "Boa Vista da Aparecida",
            "Bocaiúva do Sul",
            "Bom Jesus do Sul",
            "Bom Sucesso",
            "Bom Sucesso do Sul",
            "Borrazópolis",
            "Braganey",
            "Brasilândia do Sul",
            "Cafeara",
            "Cafelândia",
            "Cafezal do Sul",
            "Califórnia",
            "Cambará",
            "Cambé",
            "Cambira",
            "Campina da Lagoa",
            "Campina do Simão",
            "Campina Grande do Sul",
            "Campo Bonito",
            "Campo do Tenente",
            "Campo Largo",
            "Campo Magro",
            "Campo Mourão",
            "Cândido de Abreu",
            "Candói",
            "Cantagalo",
            "Capanema",
            "Capitão Leônidas Marques",
            "Carambeí",
            "Carlópolis",
            "Cascavel",
            "Castro",
            "Catanduvas",
            "Centenário do Sul",
            "Cerro Azul",
            "Céu Azul",
            "Chopinzinho",
            "Cianorte",
            "Cidade Gaúcha",
            "Clevelândia",
            "Colombo",
            "Colorado",
            "Congonhinhas",
            "Conselheiro Mairinck",
            "Contenda",
            "Corbélia",
            "Cornélio Procópio",
            "Coronel Domingos Soares",
            "Coronel Vivida",
            "Corumbataí do Sul",
            "Cruz Machado",
            "Cruzeiro do Iguaçu",
            "Cruzeiro do Oeste",
            "Cruzeiro do Sul",
            "Cruzmaltina",
            "Curitiba",
            "Curiúva",
            "Diamante d'Oeste",
            "Diamante do Norte",
            "Diamante do Sul",
            "Dois Vizinhos",
            "Douradina",
            "Doutor Camargo",
            "Doutor Ulysses",
            "Enéas Marques",
            "Engenheiro Beltrão",
            "Entre Rios do Oeste",
            "Esperança Nova",
            "Espigão Alto do Iguaçu",
            "Farol",
            "Faxinal",
            "Fazenda Rio Grande",
            "Fênix",
            "Fernandes Pinheiro",
            "Figueira",
            "Flor da Serra do Sul",
            "Floraí",
            "Floresta",
            "Florestópolis",
            "Flórida",
            "Formosa do Oeste",
            "Foz do Iguaçu",
            "Foz do Jordão",
            "Francisco Alves",
            "Francisco Beltrão",
            "General Carneiro",
            "Godoy Moreira",
            "Goioerê",
            "Goioxim",
            "Grandes Rios",
            "Guaíra",
            "Guairaçá",
            "Guamiranga",
            "Guapirama",
            "Guaporema",
            "Guaraci",
            "Guaraniaçu",
            "Guarapuava",
            "Guaraqueçaba",
            "Guaratuba",
            "Honório Serpa",
            "Ibaiti",
            "Ibema",
            "Ibiporã",
            "Icaraíma",
            "Iguaraçu",
            "Iguatu",
            "Imbaú",
            "Imbituva",
            "Inácio Martins",
            "Inajá",
            "Indianópolis",
            "Ipiranga",
            "Iporã",
            "Iracema do Oeste",
            "Irati",
            "Iretama",
            "Itaguajé",
            "Itaipulândia",
            "Itambaracá",
            "Itambé",
            "Itapejara d'Oeste",
            "Itaperuçu",
            "Itaúna do Sul",
            "Ivaí",
            "Ivaiporã",
            "Ivaté",
            "Ivatuba",
            "Jaboti",
            "Jacarezinho",
            "Jaguapitã",
            "Jaguariaíva",
            "Jandaia do Sul",
            "Janiópolis",
            "Japira",
            "Japurá",
            "Jardim Alegre",
            "Jardim Olinda",
            "Jataizinho",
            "Jesuítas",
            "Joaquim Távora",
            "Jundiaí do Sul",
            "Juranda",
            "Jussara",
            "Kaloré",
            "Lapa",
            "Laranjal",
            "Laranjeiras do Sul",
            "Leópolis",
            "Lidianópolis",
            "Lindoeste",
            "Loanda",
            "Lobato",
            "Londrina",
            "Luiziana",
            "Lunardelli",
            "Lupionópolis",
            "Mallet",
            "Mamborê",
            "Mandaguaçu",
            "Mandaguari",
            "Mandirituba",
            "Manfrinópolis",
            "Mangueirinha",
            "Manoel Ribas",
            "Marechal Cândido Rondon",
            "Maria Helena",
            "Marialva",
            "Marilândia do Sul",
            "Marilena",
            "Mariluz",
            "Maringá",
            "Mariópolis",
            "Maripá",
            "Marmeleiro",
            "Marquinho",
            "Marumbi",
            "Matelândia",
            "Matinhos",
            "Mato Rico",
            "Mauá da Serra",
            "Medianeira",
            "Mercedes",
            "Mirador",
            "Miraselva",
            "Missal",
            "Moreira Sales",
            "Morretes",
            "Munhoz de Melo",
            "Nossa Senhora das Graças",
            "Nova Aliança do Ivaí",
            "Nova América da Colina",
            "Nova Aurora",
            "Nova Cantu",
            "Nova Esperança",
            "Nova Esperança do Sudoeste",
            "Nova Fátima",
            "Nova Laranjeiras",
            "Nova Londrina",
            "Nova Olímpia",
            "Nova Prata do Iguaçu",
            "Nova Santa Bárbara",
            "Nova Santa Rosa",
            "Nova Tebas",
            "Novo Itacolomi",
            "Ortigueira",
            "Ourizona",
            "Ouro Verde do Oeste",
            "Paiçandu",
            "Palmas",
            "Palmeira",
            "Palmital",
            "Palotina",
            "Paraíso do Norte",
            "Paranacity",
            "Paranaguá",
            "Paranapoema",
            "Paranavaí",
            "Pato Bragado",
            "Pato Branco",
            "Paula Freitas",
            "Paulo Frontin",
            "Peabiru",
            "Perobal",
            "Pérola",
            "Pérola d'Oeste",
            "Piên",
            "Pinhais",
            "Pinhal de São Bento",
            "Pinhalão",
            "Pinhão",
            "Piraí do Sul",
            "Piraquara",
            "Pitanga",
            "Pitangueiras",
            "Planaltina do Paraná",
            "Planalto",
            "Ponta Grossa",
            "Pontal do Paraná",
            "Porecatu",
            "Porto Amazonas",
            "Porto Barreiro",
            "Porto Rico",
            "Porto Vitória",
            "Prado Ferreira",
            "Pranchita",
            "Presidente Castelo Branco",
            "Primeiro de Maio",
            "Prudentópolis",
            "Quarto Centenário",
            "Quatiguá",
            "Quatro Barras",
            "Quatro Pontes",
            "Quedas do Iguaçu",
            "Querência do Norte",
            "Quinta do Sol",
            "Quitandinha",
            "Ramilândia",
            "Rancho Alegre",
            "Rancho Alegre d'Oeste",
            "Realeza",
            "Rebouças",
            "Renascença",
            "Reserva",
            "Reserva do Iguaçu",
            "Ribeirão Claro",
            "Ribeirão do Pinhal",
            "Rio Azul",
            "Rio Bom",
            "Rio Bonito do Iguaçu",
            "Rio Branco do Ivaí",
            "Rio Branco do Sul",
            "Rio Negro",
            "Rolândia",
            "Roncador",
            "Rondon",
            "Rosário do Ivaí",
            "Sabáudia",
            "Salgado Filho",
            "Salto do Itararé",
            "Salto do Lontra",
            "Santa Amélia",
            "Santa Cecília do Pavão",
            "Santa Cruz Monte Castelo",
            "Santa Fé",
            "Santa Helena",
            "Santa Inês",
            "Santa Isabel do Ivaí",
            "Santa Izabel do Oeste",
            "Santa Lúcia",
            "Santa Maria do Oeste",
            "Santa Mariana",
            "Santa Mônica",
            "Santa Tereza do Oeste",
            "Santa Terezinha de Itaipu",
            "Santana do Itararé",
            "Santo Antônio da Platina",
            "Santo Antônio do Caiuá",
            "Santo Antônio do Paraíso",
            "Santo Antônio do Sudoeste",
            "Santo Inácio",
            "São Carlos do Ivaí",
            "São Jerônimo da Serra",
            "São João",
            "São João do Caiuá",
            "São João do Ivaí",
            "São João do Triunfo",
            "São Jorge d'Oeste",
            "São Jorge do Ivaí",
            "São Jorge do Patrocínio",
            "São José da Boa Vista",
            "São José das Palmeiras",
            "São José dos Pinhais",
            "São Manoel do Paraná",
            "São Mateus do Sul",
            "São Miguel do Iguaçu",
            "São Pedro do Iguaçu",
            "São Pedro do Ivaí",
            "São Pedro do Paraná",
            "São Sebastião da Amoreira",
            "São Tomé",
            "Sapopema",
            "Sarandi",
            "Saudade do Iguaçu",
            "Sengés",
            "Serranópolis do Iguaçu",
            "Sertaneja",
            "Sertanópolis",
            "Siqueira Campos",
            "Sulina",
            "Tamarana",
            "Tamboara",
            "Tapejara",
            "Tapira",
            "Teixeira Soares",
            "Telêmaco Borba",
            "Terra Boa",
            "Terra Rica",
            "Terra Roxa",
            "Tibagi",
            "Tijucas do Sul",
            "Toledo",
            "Tomazina",
            "Três Barras do Paraná",
            "Tunas do Paraná",
            "Tuneiras do Oeste",
            "Tupãssi",
            "Turvo",
            "Ubiratã",
            "Umuarama",
            "União da Vitória",
            "Uniflor",
            "Uraí",
            "Ventania",
            "Vera Cruz do Oeste",
            "Verê",
            "Vila Alta",
            "Virmond",
            "Vitorino",
            "Wenceslau Braz",
            "Xambrê"
        ]
    },
    {
        uf: "RJ",
        state: "Rio de Janeiro",
        city: [
            "Angra dos Reis",
            "Aperibé",
            "Araruama",
            "Areal",
            "Armação de Búzios",
            "Arraial do Cabo",
            "Barra do Piraí",
            "Barra Mansa",
            "Belford Roxo",
            "Bom Jardim",
            "Bom Jesus do Itabapoana",
            "Cabo Frio",
            "Cachoeiras de Macacu",
            "Cambuci",
            "Campos dos Goytacazes",
            "Cantagalo",
            "Carapebus",
            "Cardoso Moreira",
            "Carmo",
            "Casimiro de Abreu",
            "Comendador Levy Gasparian",
            "Conceição de Macabu",
            "Cordeiro",
            "Duas Barras",
            "Duque de Caxias",
            "Engenheiro Paulo de Frontin",
            "Guapimirim",
            "Iguaba Grande",
            "Itaboraí",
            "Itaguaí",
            "Italva",
            "Itaocara",
            "Itaperuna",
            "Itatiaia",
            "Japeri",
            "Laje do Muriaé",
            "Macaé",
            "Macuco",
            "Magé",
            "Mangaratiba",
            "Maricá",
            "Mendes",
            "Mesquita",
            "Miguel Pereira",
            "Miracema",
            "Natividade",
            "Nilópolis",
            "Niterói",
            "Nova Friburgo",
            "Nova Iguaçu",
            "Paracambi",
            "Paraíba do Sul",
            "Parati",
            "Paty do Alferes",
            "Petrópolis",
            "Pinheiral",
            "Piraí",
            "Porciúncula",
            "Porto Real",
            "Quatis",
            "Queimados",
            "Quissamã",
            "Resende",
            "Rio Bonito",
            "Rio Claro",
            "Rio das Flores",
            "Rio das Ostras",
            "Rio de Janeiro",
            "Santa Maria Madalena",
            "Santo Antônio de Pádua",
            "São Fidélis",
            "São Francisco de Itabapoana",
            "São Gonçalo",
            "São João da Barra",
            "São João de Meriti",
            "São José de Ubá",
            "São José do Vale do Rio Preto",
            "São Pedro da Aldeia",
            "São Sebastião do Alto",
            "Sapucaia",
            "Saquarema",
            "Seropédica",
            "Silva Jardim",
            "Sumidouro",
            "Tanguá",
            "Teresópolis",
            "Trajano de Morais",
            "Três Rios",
            "Valença",
            "Varre-Sai",
            "Vassouras",
            "Volta Redonda"
        ]
    },
    {
        uf: "RN",
        state: "Rio Grande do Norte",
        city: [
            "Acari",
            "Açu",
            "Afonso Bezerra",
            "Água Nova",
            "Alexandria",
            "Almino Afonso",
            "Alto do Rodrigues",
            "Angicos",
            "Antônio Martins",
            "Apodi",
            "Areia Branca",
            "Arês",
            "Augusto Severo",
            "Baía Formosa",
            "Baraúna",
            "Barcelona",
            "Bento Fernandes",
            "Bodó",
            "Bom Jesus",
            "Brejinho",
            "Caiçara do Norte",
            "Caiçara do Rio do Vento",
            "Caicó",
            "Campo Redondo",
            "Canguaretama",
            "Caraúbas",
            "Carnaúba dos Dantas",
            "Carnaubais",
            "Ceará-Mirim",
            "Cerro Corá",
            "Coronel Ezequiel",
            "Coronel João Pessoa",
            "Cruzeta",
            "Currais Novos",
            "Doutor Severiano",
            "Encanto",
            "Equador",
            "Espírito Santo",
            "Extremoz",
            "Felipe Guerra",
            "Fernando Pedroza",
            "Florânia",
            "Francisco Dantas",
            "Frutuoso Gomes",
            "Galinhos",
            "Goianinha",
            "Governador Dix-Sept Rosado",
            "Grossos",
            "Guamaré",
            "Ielmo Marinho",
            "Ipanguaçu",
            "Ipueira",
            "Itajá",
            "Itaú",
            "Jaçanã",
            "Jandaíra",
            "Janduís",
            "Januário Cicco",
            "Japi",
            "Jardim de Angicos",
            "Jardim de Piranhas",
            "Jardim do Seridó",
            "João Câmara",
            "João Dias",
            "José da Penha",
            "Jucurutu",
            "Jundiá",
            "Lagoa d'Anta",
            "Lagoa de Pedras",
            "Lagoa de Velhos",
            "Lagoa Nova",
            "Lagoa Salgada",
            "Lajes",
            "Lajes Pintadas",
            "Lucrécia",
            "Luís Gomes",
            "Macaíba",
            "Macau",
            "Major Sales",
            "Marcelino Vieira",
            "Martins",
            "Maxaranguape",
            "Messias Targino",
            "Montanhas",
            "Monte Alegre",
            "Monte das Gameleiras",
            "Mossoró",
            "Natal",
            "Nísia Floresta",
            "Nova Cruz",
            "Olho-d'Água do Borges",
            "Ouro Branco",
            "Paraná",
            "Paraú",
            "Parazinho",
            "Parelhas",
            "Parnamirim",
            "Passa e Fica",
            "Passagem",
            "Patu",
            "Pau dos Ferros",
            "Pedra Grande",
            "Pedra Preta",
            "Pedro Avelino",
            "Pedro Velho",
            "Pendências",
            "Pilões",
            "Poço Branco",
            "Portalegre",
            "Porto do Mangue",
            "Presidente Juscelino",
            "Pureza",
            "Rafael Fernandes",
            "Rafael Godeiro",
            "Riacho da Cruz",
            "Riacho de Santana",
            "Riachuelo",
            "Rio do Fogo",
            "Rodolfo Fernandes",
            "Ruy Barbosa",
            "Santa Cruz",
            "Santa Maria",
            "Santana do Matos",
            "Santana do Seridó",
            "Santo Antônio",
            "São Bento do Norte",
            "São Bento do Trairí",
            "São Fernando",
            "São Francisco do Oeste",
            "São Gonçalo do Amarante",
            "São João do Sabugi",
            "São José de Mipibu",
            "São José do Campestre",
            "São José do Seridó",
            "São Miguel",
            "São Miguel de Touros",
            "São Paulo do Potengi",
            "São Pedro",
            "São Rafael",
            "São Tomé",
            "São Vicente",
            "Senador Elói de Souza",
            "Senador Georgino Avelino",
            "Serra de São Bento",
            "Serra do Mel",
            "Serra Negra do Norte",
            "Serrinha",
            "Serrinha dos Pintos",
            "Severiano Melo",
            "Sítio Novo",
            "Taboleiro Grande",
            "Taipu",
            "Tangará",
            "Tenente Ananias",
            "Tenente Laurentino Cruz",
            "Tibau",
            "Tibau do Sul",
            "Timbaúba dos Batistas",
            "Touros",
            "Triunfo Potiguar",
            "Umarizal",
            "Upanema",
            "Várzea",
            "Venha-Ver",
            "Vera Cruz",
            "Viçosa",
            "Vila Flor"
        ]
    },
    {
        uf: "RO",
        state: "Rondônia",
        city: [
            "Alta Floresta d'Oeste",
            "Alto Alegre do Parecis",
            "Alto Paraíso",
            "Alvorada d'Oeste",
            "Ariquemes",
            "Buritis",
            "Cabixi",
            "Cacaulândia",
            "Cacoal",
            "Campo Novo de Rondônia",
            "Candeias do Jamari",
            "Castanheiras",
            "Cerejeiras",
            "Chupinguaia",
            "Colorado do Oeste",
            "Corumbiara",
            "Costa Marques",
            "Cujubim",
            "Espigão d'Oeste",
            "Governador Jorge Teixeira",
            "Guajará-Mirim",
            "Itapuã do Oeste",
            "Jaru",
            "Ji-Paraná",
            "Machadinho d'Oeste",
            "Ministro Andreazza",
            "Mirante da Serra",
            "Monte Negro",
            "Nova Brasilândia d'Oeste",
            "Nova Mamoré",
            "Nova União",
            "Novo Horizonte do Oeste",
            "Ouro Preto do Oeste",
            "Parecis",
            "Pimenta Bueno",
            "Pimenteiras do Oeste",
            "Porto Velho",
            "Presidente Médici",
            "Primavera de Rondônia",
            "Rio Crespo",
            "Rolim de Moura",
            "Santa Luzia d'Oeste",
            "São Felipe d'Oeste",
            "São Francisco do Guaporé",
            "São Miguel do Guaporé",
            "Seringueiras",
            "Teixeirópolis",
            "Theobroma",
            "Urupá",
            "Vale do Anari",
            "Vale do Paraíso",
            "Vilhena"
        ]
    },
    {
        uf: "RR",
        state: "Roraima",
        city: [
            "Alto Alegre",
            "Amajari",
            "Boa Vista",
            "Bonfim",
            "Cantá",
            "Caracaraí",
            "Caroebe",
            "Iracema",
            "Mucajaí",
            "Normandia",
            "Pacaraima",
            "Rorainópolis",
            "São João da Baliza",
            "São Luiz",
            "Uiramutã"
        ]
    },
    {
        uf: "RS",
        state: "Rio Grande do Sul",
        city: [
            "Aceguá",
            "Água Santa",
            "Agudo",
            "Ajuricaba",
            "Alecrim",
            "Alegrete",
            "Alegria",
            "Almirante Tamandaré do Sul",
            "Alpestre",
            "Alto Alegre",
            "Alto Feliz",
            "Alvorada",
            "Amaral Ferrador",
            "Ametista do Sul",
            "André da Rocha",
            "Anta Gorda",
            "Antônio Prado",
            "Arambaré",
            "Araricá",
            "Aratiba",
            "Arroio do Meio",
            "Arroio do Padre",
            "Arroio do Sal",
            "Arroio do Tigre",
            "Arroio dos Ratos",
            "Arroio Grande",
            "Arvorezinha",
            "Augusto Pestana",
            "Áurea",
            "Bagé",
            "Balneário Pinhal",
            "Barão",
            "Barão de Cotegipe",
            "Barão do Triunfo",
            "Barra do Guarita",
            "Barra do Quaraí",
            "Barra do Ribeiro",
            "Barra do Rio Azul",
            "Barra Funda",
            "Barracão",
            "Barros Cassal",
            "Benjamin Constan do Sul",
            "Bento Gonçalves",
            "Boa Vista das Missões",
            "Boa Vista do Buricá",
            "Boa Vista do Cadeado",
            "Boa Vista do Incra",
            "Boa Vista do Sul",
            "Bom Jesus",
            "Bom Princípio",
            "Bom Progresso",
            "Bom Retiro do Sul",
            "Boqueirão do Leão",
            "Bossoroca",
            "Bozano",
            "Braga",
            "Brochier",
            "Butiá",
            "Caçapava do Sul",
            "Cacequi",
            "Cachoeira do Sul",
            "Cachoeirinha",
            "Cacique Doble",
            "Caibaté",
            "Caiçara",
            "Camaquã",
            "Camargo",
            "Cambará do Sul",
            "Campestre da Serra",
            "Campina das Missões",
            "Campinas do Sul",
            "Campo Bom",
            "Campo Novo",
            "Campos Borges",
            "Candelária",
            "Cândido Godói",
            "Candiota",
            "Canela",
            "Canguçu",
            "Canoas",
            "Canudos do Vale",
            "Capão Bonito do Sul",
            "Capão da Canoa",
            "Capão do Cipó",
            "Capão do Leão",
            "Capela de Santana",
            "Capitão",
            "Capivari do Sul",
            "Caraá",
            "Carazinho",
            "Carlos Barbosa",
            "Carlos Gomes",
            "Casca",
            "Caseiros",
            "Catuípe",
            "Caxias do Sul",
            "Centenário",
            "Cerrito",
            "Cerro Branco",
            "Cerro Grande",
            "Cerro Grande do Sul",
            "Cerro Largo",
            "Chapada",
            "Charqueadas",
            "Charrua",
            "Chiapeta",
            "Chuí",
            "Chuvisca",
            "Cidreira",
            "Ciríaco",
            "Colinas",
            "Colorado",
            "Condor",
            "Constantina",
            "Coqueiro Baixo",
            "Coqueiros do Sul",
            "Coronel Barros",
            "Coronel Bicaco",
            "Coronel Pilar",
            "Cotiporã",
            "Coxilha",
            "Crissiumal",
            "Cristal",
            "Cristal do Sul",
            "Cruz Alta",
            "Cruzaltense",
            "Cruzeiro do Sul",
            "David Canabarro",
            "Derrubadas",
            "Dezesseis de Novembro",
            "Dilermando de Aguiar",
            "Dois Irmãos",
            "Dois Irmãos das Missões",
            "Dois Lajeados",
            "Dom Feliciano",
            "Dom Pedrito",
            "Dom Pedro de Alcântara",
            "Dona Francisca",
            "Doutor Maurício Cardoso",
            "Doutor Ricardo",
            "Eldorado do Sul",
            "Encantado",
            "Encruzilhada do Sul",
            "Engenho Velho",
            "Entre Rios do Sul",
            "Entre-Ijuís",
            "Erebango",
            "Erechim",
            "Ernestina",
            "Erval Grande",
            "Erval Seco",
            "Esmeralda",
            "Esperança do Sul",
            "Espumoso",
            "Estação",
            "Estância Velha",
            "Esteio",
            "Estrela",
            "Estrela Velha",
            "Eugênio de Castro",
            "Fagundes Varela",
            "Farroupilha",
            "Faxinal do Soturno",
            "Faxinalzinho",
            "Fazenda Vilanova",
            "Feliz",
            "Flores da Cunha",
            "Floriano Peixoto",
            "Fontoura Xavier",
            "Formigueiro",
            "Forquetinha",
            "Fortaleza dos Valos",
            "Frederico Westphalen",
            "Garibaldi",
            "Garruchos",
            "Gaurama",
            "General Câmara",
            "Gentil",
            "Getúlio Vargas",
            "Giruá",
            "Glorinha",
            "Gramado",
            "Gramado dos Loureiros",
            "Gramado Xavier",
            "Gravataí",
            "Guabiju",
            "Guaíba",
            "Guaporé",
            "Guarani das Missões",
            "Harmonia",
            "Herval",
            "Herveiras",
            "Horizontina",
            "Hulha Negra",
            "Humaitá",
            "Ibarama",
            "Ibiaçá",
            "Ibiraiaras",
            "Ibirapuitã",
            "Ibirubá",
            "Igrejinha",
            "Ijuí",
            "Ilópolis",
            "Imbé",
            "Imigrante",
            "Independência",
            "Inhacorá",
            "Ipê",
            "Ipiranga do Sul",
            "Iraí",
            "Itaara",
            "Itacurubi",
            "Itapuca",
            "Itaqui",
            "Itati",
            "Itatiba do Sul",
            "Ivorá",
            "Ivoti",
            "Jaboticaba",
            "Jacuizinho",
            "Jacutinga",
            "Jaguarão",
            "Jaguari",
            "Jaquirana",
            "Jari",
            "Jóia",
            "Júlio de Castilhos",
            "Lagoa Bonita do Sul",
            "Lagoa dos Três Cantos",
            "Lagoa Vermelha",
            "Lagoão",
            "Lajeado",
            "Lajeado do Bugre",
            "Lavras do Sul",
            "Liberato Salzano",
            "Lindolfo Collor",
            "Linha Nova",
            "Maçambara",
            "Machadinho",
            "Mampituba",
            "Manoel Viana",
            "Maquiné",
            "Maratá",
            "Marau",
            "Marcelino Ramos",
            "Mariana Pimentel",
            "Mariano Moro",
            "Marques de Souza",
            "Mata",
            "Mato Castelhano",
            "Mato Leitão",
            "Mato Queimado",
            "Maximiliano de Almeida",
            "Minas do Leão",
            "Miraguaí",
            "Montauri",
            "Monte Alegre dos Campos",
            "Monte Belo do Sul",
            "Montenegro",
            "Mormaço",
            "Morrinhos do Sul",
            "Morro Redondo",
            "Morro Reuter",
            "Mostardas",
            "Muçum",
            "Muitos Capões",
            "Muliterno",
            "Não-Me-Toque",
            "Nicolau Vergueiro",
            "Nonoai",
            "Nova Alvorada",
            "Nova Araçá",
            "Nova Bassano",
            "Nova Boa Vista",
            "Nova Bréscia",
            "Nova Candelária",
            "Nova Esperança do Sul",
            "Nova Hartz",
            "Nova Pádua",
            "Nova Palma",
            "Nova Petrópolis",
            "Nova Prata",
            "Nova Ramada",
            "Nova Roma do Sul",
            "Nova Santa Rita",
            "Novo Barreiro",
            "Novo Cabrais",
            "Novo Hamburgo",
            "Novo Machado",
            "Novo Tiradentes",
            "Novo Xingu",
            "Osório",
            "Paim Filho",
            "Palmares do Sul",
            "Palmeira das Missões",
            "Palmitinho",
            "Panambi",
            "Pântano Grande",
            "Paraí",
            "Paraíso do Sul",
            "Pareci Novo",
            "Parobé",
            "Passa Sete",
            "Passo do Sobrado",
            "Passo Fundo",
            "Paulo Bento",
            "Paverama",
            "Pedras Altas",
            "Pedro Osório",
            "Pejuçara",
            "Pelotas",
            "Picada Café",
            "Pinhal",
            "Pinhal da Serra",
            "Pinhal Grande",
            "Pinheirinho do Vale",
            "Pinheiro Machado",
            "Pirapó",
            "Piratini",
            "Planalto",
            "Poço das Antas",
            "Pontão",
            "Ponte Preta",
            "Portão",
            "Porto Alegre",
            "Porto Lucena",
            "Porto Mauá",
            "Porto Vera Cruz",
            "Porto Xavier",
            "Pouso Novo",
            "Presidente Lucena",
            "Progresso",
            "Protásio Alves",
            "Putinga",
            "Quaraí",
            "Quatro Irmãos",
            "Quevedos",
            "Quinze de Novembro",
            "Redentora",
            "Relvado",
            "Restinga Seca",
            "Rio dos Índios",
            "Rio Grande",
            "Rio Pardo",
            "Riozinho",
            "Roca Sales",
            "Rodeio Bonito",
            "Rolador",
            "Rolante",
            "Ronda Alta",
            "Rondinha",
            "Roque Gonzales",
            "Rosário do Sul",
            "Sagrada Família",
            "Saldanha Marinho",
            "Salto do Jacuí",
            "Salvador das Missões",
            "Salvador do Sul",
            "Sananduva",
            "Santa Bárbara do Sul",
            "Santa Cecília do Sul",
            "Santa Clara do Sul",
            "Santa Cruz do Sul",
            "Santa Margarida do Sul",
            "Santa Maria",
            "Santa Maria do Herval",
            "Santa Rosa",
            "Santa Tereza",
            "Santa Vitória do Palmar",
            "Santana da Boa Vista",
            "Santana do Livramento",
            "Santiago",
            "Santo Ângelo",
            "Santo Antônio da Patrulha",
            "Santo Antônio das Missões",
            "Santo Antônio do Palma",
            "Santo Antônio do Planalto",
            "Santo Augusto",
            "Santo Cristo",
            "Santo Expedito do Sul",
            "São Borja",
            "São Domingos do Sul",
            "São Francisco de Assis",
            "São Francisco de Paula",
            "São Gabriel",
            "São Jerônimo",
            "São João da Urtiga",
            "São João do Polêsine",
            "São Jorge",
            "São José das Missões",
            "São José do Herval",
            "São José do Hortêncio",
            "São José do Inhacorá",
            "São José do Norte",
            "São José do Ouro",
            "São José do Sul",
            "São José dos Ausentes",
            "São Leopoldo",
            "São Lourenço do Sul",
            "São Luiz Gonzaga",
            "São Marcos",
            "São Martinho",
            "São Martinho da Serra",
            "São Miguel das Missões",
            "São Nicolau",
            "São Paulo das Missões",
            "São Pedro da Serra",
            "São Pedro das Missões",
            "São Pedro do Butiá",
            "São Pedro do Sul",
            "São Sebastião do Caí",
            "São Sepé",
            "São Valentim",
            "São Valentim do Sul",
            "São Valério do Sul",
            "São Vendelino",
            "São Vicente do Sul",
            "Sapiranga",
            "Sapucaia do Sul",
            "Sarandi",
            "Seberi",
            "Sede Nova",
            "Segredo",
            "Selbach",
            "Senador Salgado Filho",
            "Sentinela do Sul",
            "Serafina Corrêa",
            "Sério",
            "Sertão",
            "Sertão Santana",
            "Sete de Setembro",
            "Severiano de Almeida",
            "Silveira Martins",
            "Sinimbu",
            "Sobradinho",
            "Soledade",
            "Tabaí",
            "Tapejara",
            "Tapera",
            "Tapes",
            "Taquara",
            "Taquari",
            "Taquaruçu do Sul",
            "Tavares",
            "Tenente Portela",
            "Terra de Areia",
            "Teutônia",
            "Tio Hugo",
            "Tiradentes do Sul",
            "Toropi",
            "Torres",
            "Tramandaí",
            "Travesseiro",
            "Três Arroios",
            "Três Cachoeiras",
            "Três Coroas",
            "Três de Maio",
            "Três Forquilhas",
            "Três Palmeiras",
            "Três Passos",
            "Trindade do Sul",
            "Triunfo",
            "Tucunduva",
            "Tunas",
            "Tupanci do Sul",
            "Tupanciretã",
            "Tupandi",
            "Tuparendi",
            "Turuçu",
            "Ubiretama",
            "União da Serra",
            "Unistalda",
            "Uruguaiana",
            "Vacaria",
            "Vale do Sol",
            "Vale Real",
            "Vale Verde",
            "Vanini",
            "Venâncio Aires",
            "Vera Cruz",
            "Veranópolis",
            "Vespasiano Correa",
            "Viadutos",
            "Viamão",
            "Vicente Dutra",
            "Victor Graeff",
            "Vila Flores",
            "Vila Lângaro",
            "Vila Maria",
            "Vila Nova do Sul",
            "Vista Alegre",
            "Vista Alegre do Prata",
            "Vista Gaúcha",
            "Vitória das Missões",
            "Westfália",
            "Xangri-lá"
        ]
    },
    {
        uf: "SC",
        state: "Santa Catarina",
        city: [
            "Abdon Batista",
            "Abelardo Luz",
            "Agrolândia",
            "Agronômica",
            "Água Doce",
            "Águas de Chapecó",
            "Águas Frias",
            "Águas Mornas",
            "Alfredo Wagner",
            "Alto Bela Vista",
            "Anchieta",
            "Angelina",
            "Anita Garibaldi",
            "Anitápolis",
            "Antônio Carlos",
            "Apiúna",
            "Arabutã",
            "Araquari",
            "Araranguá",
            "Armazém",
            "Arroio Trinta",
            "Arvoredo",
            "Ascurra",
            "Atalanta",
            "Aurora",
            "Balneário Arroio do Silva",
            "Balneário Barra do Sul",
            "Balneário Camboriú",
            "Balneário Gaivota",
            "Bandeirante",
            "Barra Bonita",
            "Barra Velha",
            "Bela Vista do Toldo",
            "Belmonte",
            "Benedito Novo",
            "Biguaçu",
            "Blumenau",
            "Bocaina do Sul",
            "Bom Jardim da Serra",
            "Bom Jesus",
            "Bom Jesus do Oeste",
            "Bom Retiro",
            "Bombinhas",
            "Botuverá",
            "Braço do Norte",
            "Braço do Trombudo",
            "Brunópolis",
            "Brusque",
            "Caçador",
            "Caibi",
            "Calmon",
            "Camboriú",
            "Campo Alegre",
            "Campo Belo do Sul",
            "Campo Erê",
            "Campos Novos",
            "Canelinha",
            "Canoinhas",
            "Capão Alto",
            "Capinzal",
            "Capivari de Baixo",
            "Catanduvas",
            "Caxambu do Sul",
            "Celso Ramos",
            "Cerro Negro",
            "Chapadão do Lageado",
            "Chapecó",
            "Cocal do Sul",
            "Concórdia",
            "Cordilheira Alta",
            "Coronel Freitas",
            "Coronel Martins",
            "Correia Pinto",
            "Corupá",
            "Criciúma",
            "Cunha Porã",
            "Cunhataí",
            "Curitibanos",
            "Descanso",
            "Dionísio Cerqueira",
            "Dona Emma",
            "Doutor Pedrinho",
            "Entre Rios",
            "Ermo",
            "Erval Velho",
            "Faxinal dos Guedes",
            "Flor do Sertão",
            "Florianópolis",
            "Formosa do Sul",
            "Forquilhinha",
            "Fraiburgo",
            "Frei Rogério",
            "Galvão",
            "Garopaba",
            "Garuva",
            "Gaspar",
            "Governador Celso Ramos",
            "Grão Pará",
            "Gravatal",
            "Guabiruba",
            "Guaraciaba",
            "Guaramirim",
            "Guarujá do Sul",
            "Guatambú",
            "Herval d'Oeste",
            "Ibiam",
            "Ibicaré",
            "Ibirama",
            "Içara",
            "Ilhota",
            "Imaruí",
            "Imbituba",
            "Imbuia",
            "Indaial",
            "Iomerê",
            "Ipira",
            "Iporã do Oeste",
            "Ipuaçu",
            "Ipumirim",
            "Iraceminha",
            "Irani",
            "Irati",
            "Irineópolis",
            "Itá",
            "Itaiópolis",
            "Itajaí",
            "Itapema",
            "Itapiranga",
            "Itapoá",
            "Ituporanga",
            "Jaborá",
            "Jacinto Machado",
            "Jaguaruna",
            "Jaraguá do Sul",
            "Jardinópolis",
            "Joaçaba",
            "Joinville",
            "José Boiteux",
            "Jupiá",
            "Lacerdópolis",
            "Lages",
            "Laguna",
            "Lajeado Grande",
            "Laurentino",
            "Lauro Muller",
            "Lebon Régis",
            "Leoberto Leal",
            "Lindóia do Sul",
            "Lontras",
            "Luiz Alves",
            "Luzerna",
            "Macieira",
            "Mafra",
            "Major Gercino",
            "Major Vieira",
            "Maracajá",
            "Maravilha",
            "Marema",
            "Massaranduba",
            "Matos Costa",
            "Meleiro",
            "Mirim Doce",
            "Modelo",
            "Mondaí",
            "Monte Carlo",
            "Monte Castelo",
            "Morro da Fumaça",
            "Morro Grande",
            "Navegantes",
            "Nova Erechim",
            "Nova Itaberaba",
            "Nova Trento",
            "Nova Veneza",
            "Novo Horizonte",
            "Orleans",
            "Otacílio Costa",
            "Ouro",
            "Ouro Verde",
            "Paial",
            "Painel",
            "Palhoça",
            "Palma Sola",
            "Palmeira",
            "Palmitos",
            "Papanduva",
            "Paraíso",
            "Passo de Torres",
            "Passos Maia",
            "Paulo Lopes",
            "Pedras Grandes",
            "Penha",
            "Peritiba",
            "Petrolândia",
            "Piçarras",
            "Pinhalzinho",
            "Pinheiro Preto",
            "Piratuba",
            "Planalto Alegre",
            "Pomerode",
            "Ponte Alta",
            "Ponte Alta do Norte",
            "Ponte Serrada",
            "Porto Belo",
            "Porto União",
            "Pouso Redondo",
            "Praia Grande",
            "Presidente Castelo Branco",
            "Presidente Getúlio",
            "Presidente Nereu",
            "Princesa",
            "Quilombo",
            "Rancho Queimado",
            "Rio das Antas",
            "Rio do Campo",
            "Rio do Oeste",
            "Rio do Sul",
            "Rio dos Cedros",
            "Rio Fortuna",
            "Rio Negrinho",
            "Rio Rufino",
            "Riqueza",
            "Rodeio",
            "Romelândia",
            "Salete",
            "Saltinho",
            "Salto Veloso",
            "Sangão",
            "Santa Cecília",
            "Santa Helena",
            "Santa Rosa de Lima",
            "Santa Rosa do Sul",
            "Santa Terezinha",
            "Santa Terezinha do Progresso",
            "Santiago do Sul",
            "Santo Amaro da Imperatriz",
            "São Bento do Sul",
            "São Bernardino",
            "São Bonifácio",
            "São Carlos",
            "São Cristovão do Sul",
            "São Domingos",
            "São Francisco do Sul",
            "São João Batista",
            "São João do Itaperiú",
            "São João do Oeste",
            "São João do Sul",
            "São Joaquim",
            "São José",
            "São José do Cedro",
            "São José do Cerrito",
            "São Lourenço do Oeste",
            "São Ludgero",
            "São Martinho",
            "São Miguel da Boa Vista",
            "São Miguel do Oeste",
            "São Pedro de Alcântara",
            "Saudades",
            "Schroeder",
            "Seara",
            "Serra Alta",
            "Siderópolis",
            "Sombrio",
            "Sul Brasil",
            "Taió",
            "Tangará",
            "Tigrinhos",
            "Tijucas",
            "Timbé do Sul",
            "Timbó",
            "Timbó Grande",
            "Três Barras",
            "Treviso",
            "Treze de Maio",
            "Treze Tílias",
            "Trombudo Central",
            "Tubarão",
            "Tunápolis",
            "Turvo",
            "União do Oeste",
            "Urubici",
            "Urupema",
            "Urussanga",
            "Vargeão",
            "Vargem",
            "Vargem Bonita",
            "Vidal Ramos",
            "Videira",
            "Vitor Meireles",
            "Witmarsum",
            "Xanxerê",
            "Xavantina",
            "Xaxim",
            "Zortéa"
        ]
    },
    {
        uf: "SE",
        state: "Sergipe",
        city: [
            "Amparo de São Francisco",
            "Aquidabã",
            "Aracaju",
            "Arauá",
            "Areia Branca",
            "Barra dos Coqueiros",
            "Boquim",
            "Brejo Grande",
            "Campo do Brito",
            "Canhoba",
            "Canindé de São Francisco",
            "Capela",
            "Carira",
            "Carmópolis",
            "Cedro de São João",
            "Cristinápolis",
            "Cumbe",
            "Divina Pastora",
            "Estância",
            "Feira Nova",
            "Frei Paulo",
            "Gararu",
            "General Maynard",
            "Gracho Cardoso",
            "Ilha das Flores",
            "Indiaroba",
            "Itabaiana",
            "Itabaianinha",
            "Itabi",
            "Itaporanga d'Ajuda",
            "Japaratuba",
            "Japoatã",
            "Lagarto",
            "Laranjeiras",
            "Macambira",
            "Malhada dos Bois",
            "Malhador",
            "Maruim",
            "Moita Bonita",
            "Monte Alegre de Sergipe",
            "Muribeca",
            "Neópolis",
            "Nossa Senhora Aparecida",
            "Nossa Senhora da Glória",
            "Nossa Senhora das Dores",
            "Nossa Senhora de Lourdes",
            "Nossa Senhora do Socorro",
            "Pacatuba",
            "Pedra Mole",
            "Pedrinhas",
            "Pinhão",
            "Pirambu",
            "Poço Redondo",
            "Poço Verde",
            "Porto da Folha",
            "Propriá",
            "Riachão do Dantas",
            "Riachuelo",
            "Ribeirópolis",
            "Rosário do Catete",
            "Salgado",
            "Santa Luzia do Itanhy",
            "Santa Rosa de Lima",
            "Santana do São Francisco",
            "Santo Amaro das Brotas",
            "São Cristóvão",
            "São Domingos",
            "São Francisco",
            "São Miguel do Aleixo",
            "Simão Dias",
            "Siriri",
            "Telha",
            "Tobias Barreto",
            "Tomar do Geru",
            "Umbaúba"
        ]
    },
    {
        uf: "SP",
        state: "São Paulo",
        city: [
            "Adamantina",
            "Adolfo",
            "Aguaí",
            "Águas da Prata",
            "Águas de Lindóia",
            "Águas de Santa Bárbara",
            "Águas de São Pedro",
            "Agudos",
            "Alambari",
            "Alfredo Marcondes",
            "Altair",
            "Altinópolis",
            "Alto Alegre",
            "Alumínio",
            "Álvares Florence",
            "Álvares Machado",
            "Álvaro de Carvalho",
            "Alvinlândia",
            "Americana",
            "Américo Brasiliense",
            "Américo de Campos",
            "Amparo",
            "Analândia",
            "Andradina",
            "Angatuba",
            "Anhembi",
            "Anhumas",
            "Aparecida",
            "Aparecida d'Oeste",
            "Apiaí",
            "Araçariguama",
            "Araçatuba",
            "Araçoiaba da Serra",
            "Aramina",
            "Arandu",
            "Arapeí",
            "Araraquara",
            "Araras",
            "Arco-Íris",
            "Arealva",
            "Areias",
            "Areiópolis",
            "Ariranha",
            "Artur Nogueira",
            "Arujá",
            "Aspásia",
            "Assis",
            "Atibaia",
            "Auriflama",
            "Avaí",
            "Avanhandava",
            "Avaré",
            "Bady Bassitt",
            "Balbinos",
            "Bálsamo",
            "Bananal",
            "Barão de Antonina",
            "Barbosa",
            "Bariri",
            "Barra Bonita",
            "Barra do Chapéu",
            "Barra do Turvo",
            "Barretos",
            "Barrinha",
            "Barueri",
            "Bastos",
            "Batatais",
            "Bauru",
            "Bebedouro",
            "Bento de Abreu",
            "Bernardino de Campos",
            "Bertioga",
            "Bilac",
            "Birigui",
            "Biritiba-Mirim",
            "Boa Esperança do Sul",
            "Bocaina",
            "Bofete",
            "Boituva",
            "Bom Jesus dos Perdões",
            "Bom Sucesso de Itararé",
            "Borá",
            "Boracéia",
            "Borborema",
            "Borebi",
            "Botucatu",
            "Bragança Paulista",
            "Braúna",
            "Brejo Alegre",
            "Brodowski",
            "Brotas",
            "Buri",
            "Buritama",
            "Buritizal",
            "Cabrália Paulista",
            "Cabreúva",
            "Caçapava",
            "Cachoeira Paulista",
            "Caconde",
            "Cafelândia",
            "Caiabu",
            "Caieiras",
            "Caiuá",
            "Cajamar",
            "Cajati",
            "Cajobi",
            "Cajuru",
            "Campina do Monte Alegre",
            "Campinas",
            "Campo Limpo Paulista",
            "Campos do Jordão",
            "Campos Novos Paulista",
            "Cananéia",
            "Canas",
            "Cândido Mota",
            "Cândido Rodrigues",
            "Canitar",
            "Capão Bonito",
            "Capela do Alto",
            "Capivari",
            "Caraguatatuba",
            "Carapicuíba",
            "Cardoso",
            "Casa Branca",
            "Cássia dos Coqueiros",
            "Castilho",
            "Catanduva",
            "Catiguá",
            "Cedral",
            "Cerqueira César",
            "Cerquilho",
            "Cesário Lange",
            "Charqueada",
            "Chavantes",
            "Clementina",
            "Colina",
            "Colômbia",
            "Conchal",
            "Conchas",
            "Cordeirópolis",
            "Coroados",
            "Coronel Macedo",
            "Corumbataí",
            "Cosmópolis",
            "Cosmorama",
            "Cotia",
            "Cravinhos",
            "Cristais Paulista",
            "Cruzália",
            "Cruzeiro",
            "Cubatão",
            "Cunha",
            "Descalvado",
            "Diadema",
            "Dirce Reis",
            "Divinolândia",
            "Dobrada",
            "Dois Córregos",
            "Dolcinópolis",
            "Dourado",
            "Dracena",
            "Duartina",
            "Dumont",
            "Echaporã",
            "Eldorado",
            "Elias Fausto",
            "Elisiário",
            "Embaúba",
            "Embu",
            "Embu-Guaçu",
            "Emilianópolis",
            "Engenheiro Coelho",
            "Espírito Santo do Pinhal",
            "Espírito Santo do Turvo",
            "Estiva Gerbi",
            "Estrela d'Oeste",
            "Estrela do Norte",
            "Euclides da Cunha Paulista",
            "Fartura",
            "Fernando Prestes",
            "Fernandópolis",
            "Fernão",
            "Ferraz de Vasconcelos",
            "Flora Rica",
            "Floreal",
            "Florínia",
            "Flórida Paulista",
            "Franca",
            "Francisco Morato",
            "Franco da Rocha",
            "Gabriel Monteiro",
            "Gália",
            "Garça",
            "Gastão Vidigal",
            "Gavião Peixoto",
            "General Salgado",
            "Getulina",
            "Glicério",
            "Guaiçara",
            "Guaimbê",
            "Guaíra",
            "Guapiaçu",
            "Guapiara",
            "Guará",
            "Guaraçaí",
            "Guaraci",
            "Guarani d'Oeste",
            "Guarantã",
            "Guararapes",
            "Guararema",
            "Guaratinguetá",
            "Guareí",
            "Guariba",
            "Guarujá",
            "Guarulhos",
            "Guatapará",
            "Guzolândia",
            "Herculândia",
            "Holambra",
            "Hortolândia",
            "Iacanga",
            "Iacri",
            "Iaras",
            "Ibaté",
            "Ibirá",
            "Ibirarema",
            "Ibitinga",
            "Ibiúna",
            "Icém",
            "Iepê",
            "Igaraçu do Tietê",
            "Igarapava",
            "Igaratá",
            "Iguape",
            "Ilha Comprida",
            "Ilha Solteira",
            "Ilhabela",
            "Indaiatuba",
            "Indiana",
            "Indiaporã",
            "Inúbia Paulista",
            "Ipauçu",
            "Iperó",
            "Ipeúna",
            "Ipiguá",
            "Iporanga",
            "Ipuã",
            "Iracemápolis",
            "Irapuã",
            "Irapuru",
            "Itaberá",
            "Itaí",
            "Itajobi",
            "Itaju",
            "Itanhaém",
            "Itaóca",
            "Itapecerica da Serra",
            "Itapetininga",
            "Itapeva",
            "Itapevi",
            "Itapira",
            "Itapirapuã Paulista",
            "Itápolis",
            "Itaporanga",
            "Itapuí",
            "Itapura",
            "Itaquaquecetuba",
            "Itararé",
            "Itariri",
            "Itatiba",
            "Itatinga",
            "Itirapina",
            "Itirapuã",
            "Itobi",
            "Itu",
            "Itupeva",
            "Ituverava",
            "Jaborandi",
            "Jaboticabal",
            "Jacareí",
            "Jaci",
            "Jacupiranga",
            "Jaguariúna",
            "Jales",
            "Jambeiro",
            "Jandira",
            "Jardinópolis",
            "Jarinu",
            "Jaú",
            "Jeriquara",
            "Joanópolis",
            "João Ramalho",
            "José Bonifácio",
            "Júlio Mesquita",
            "Jumirim",
            "Jundiaí",
            "Junqueirópolis",
            "Juquiá",
            "Juquitiba",
            "Lagoinha",
            "Laranjal Paulista",
            "Lavínia",
            "Lavrinhas",
            "Leme",
            "Lençóis Paulista",
            "Limeira",
            "Lindóia",
            "Lins",
            "Lorena",
            "Lourdes",
            "Louveira",
            "Lucélia",
            "Lucianópolis",
            "Luís Antônio",
            "Luiziânia",
            "Lupércio",
            "Lutécia",
            "Macatuba",
            "Macaubal",
            "Macedônia",
            "Magda",
            "Mairinque",
            "Mairiporã",
            "Manduri",
            "Marabá Paulista",
            "Maracaí",
            "Marapoama",
            "Mariápolis",
            "Marília",
            "Marinópolis",
            "Martinópolis",
            "Matão",
            "Mauá",
            "Mendonça",
            "Meridiano",
            "Mesópolis",
            "Miguelópolis",
            "Mineiros do Tietê",
            "Mira Estrela",
            "Miracatu",
            "Mirandópolis",
            "Mirante do Paranapanema",
            "Mirassol",
            "Mirassolândia",
            "Mococa",
            "Mogi das Cruzes",
            "Mogi-Guaçu",
            "Mogi-Mirim",
            "Mombuca",
            "Monções",
            "Mongaguá",
            "Monte Alegre do Sul",
            "Monte Alto",
            "Monte Aprazível",
            "Monte Azul Paulista",
            "Monte Castelo",
            "Monte Mor",
            "Monteiro Lobato",
            "Morro Agudo",
            "Morungaba",
            "Motuca",
            "Murutinga do Sul",
            "Nantes",
            "Narandiba",
            "Natividade da Serra",
            "Nazaré Paulista",
            "Neves Paulista",
            "Nhandeara",
            "Nipoã",
            "Nova Aliança",
            "Nova Campina",
            "Nova Canaã Paulista",
            "Nova Castilho",
            "Nova Europa",
            "Nova Granada",
            "Nova Guataporanga",
            "Nova Independência",
            "Nova Luzitânia",
            "Nova Odessa",
            "Novais",
            "Novo Horizonte",
            "Nuporanga",
            "Ocauçu",
            "Óleo",
            "Olímpia",
            "Onda Verde",
            "Oriente",
            "Orindiúva",
            "Orlândia",
            "Osasco",
            "Oscar Bressane",
            "Osvaldo Cruz",
            "Ourinhos",
            "Ouro Verde",
            "Ouroeste",
            "Pacaembu",
            "Palestina",
            "Palmares Paulista",
            "Palmeira d'Oeste",
            "Palmital",
            "Panorama",
            "Paraguaçu Paulista",
            "Paraibuna",
            "Paraíso",
            "Paranapanema",
            "Paranapuã",
            "Parapuã",
            "Pardinho",
            "Pariquera-Açu",
            "Parisi",
            "Patrocínio Paulista",
            "Paulicéia",
            "Paulínia",
            "Paulistânia",
            "Paulo de Faria",
            "Pederneiras",
            "Pedra Bela",
            "Pedranópolis",
            "Pedregulho",
            "Pedreira",
            "Pedrinhas Paulista",
            "Pedro de Toledo",
            "Penápolis",
            "Pereira Barreto",
            "Pereiras",
            "Peruíbe",
            "Piacatu",
            "Piedade",
            "Pilar do Sul",
            "Pindamonhangaba",
            "Pindorama",
            "Pinhalzinho",
            "Piquerobi",
            "Piquete",
            "Piracaia",
            "Piracicaba",
            "Piraju",
            "Pirajuí",
            "Pirangi",
            "Pirapora do Bom Jesus",
            "Pirapozinho",
            "Pirassununga",
            "Piratininga",
            "Pitangueiras",
            "Planalto",
            "Platina",
            "Poá",
            "Poloni",
            "Pompéia",
            "Pongaí",
            "Pontal",
            "Pontalinda",
            "Pontes Gestal",
            "Populina",
            "Porangaba",
            "Porto Feliz",
            "Porto Ferreira",
            "Potim",
            "Potirendaba",
            "Pracinha",
            "Pradópolis",
            "Praia Grande",
            "Pratânia",
            "Presidente Alves",
            "Presidente Bernardes",
            "Presidente Epitácio",
            "Presidente Prudente",
            "Presidente Venceslau",
            "Promissão",
            "Quadra",
            "Quatá",
            "Queiroz",
            "Queluz",
            "Quintana",
            "Rafard",
            "Rancharia",
            "Redenção da Serra",
            "Regente Feijó",
            "Reginópolis",
            "Registro",
            "Restinga",
            "Ribeira",
            "Ribeirão Bonito",
            "Ribeirão Branco",
            "Ribeirão Corrente",
            "Ribeirão do Sul",
            "Ribeirão dos Índios",
            "Ribeirão Grande",
            "Ribeirão Pires",
            "Ribeirão Preto",
            "Rifaina",
            "Rincão",
            "Rinópolis",
            "Rio Claro",
            "Rio das Pedras",
            "Rio Grande da Serra",
            "Riolândia",
            "Riversul",
            "Rosana",
            "Roseira",
            "Rubiácea",
            "Rubinéia",
            "Sabino",
            "Sagres",
            "Sales",
            "Sales Oliveira",
            "Salesópolis",
            "Salmourão",
            "Saltinho",
            "Salto",
            "Salto de Pirapora",
            "Salto Grande",
            "Sandovalina",
            "Santa Adélia",
            "Santa Albertina",
            "Santa Bárbara d'Oeste",
            "Santa Branca",
            "Santa Clara d'Oeste",
            "Santa Cruz da Conceição",
            "Santa Cruz da Esperança",
            "Santa Cruz das Palmeiras",
            "Santa Cruz do Rio Pardo",
            "Santa Ernestina",
            "Santa Fé do Sul",
            "Santa Gertrudes",
            "Santa Isabel",
            "Santa Lúcia",
            "Santa Maria da Serra",
            "Santa Mercedes",
            "Santa Rita d'Oeste",
            "Santa Rita do Passa Quatro",
            "Santa Rosa de Viterbo",
            "Santa Salete",
            "Santana da Ponte Pensa",
            "Santana de Parnaíba",
            "Santo Anastácio",
            "Santo André",
            "Santo Antônio da Alegria",
            "Santo Antônio de Posse",
            "Santo Antônio do Aracanguá",
            "Santo Antônio do Jardim",
            "Santo Antônio do Pinhal",
            "Santo Expedito",
            "Santópolis do Aguapeí",
            "Santos",
            "São Bento do Sapucaí",
            "São Bernardo do Campo",
            "São Caetano do Sul",
            "São Carlos",
            "São Francisco",
            "São João da Boa Vista",
            "São João das Duas Pontes",
            "São João de Iracema",
            "São João do Pau d'Alho",
            "São Joaquim da Barra",
            "São José da Bela Vista",
            "São José do Barreiro",
            "São José do Rio Pardo",
            "São José do Rio Preto",
            "São José dos Campos",
            "São Lourenço da Serra",
            "São Luís do Paraitinga",
            "São Manuel",
            "São Miguel Arcanjo",
            "São Paulo",
            "São Pedro",
            "São Pedro do Turvo",
            "São Roque",
            "São Sebastião",
            "São Sebastião da Grama",
            "São Simão",
            "São Vicente",
            "Sarapuí",
            "Sarutaiá",
            "Sebastianópolis do Sul",
            "Serra Azul",
            "Serra Negra",
            "Serrana",
            "Sertãozinho",
            "Sete Barras",
            "Severínia",
            "Silveiras",
            "Socorro",
            "Sorocaba",
            "Sud Mennucci",
            "Sumaré",
            "Suzanápolis",
            "Suzano",
            "Tabapuã",
            "Tabatinga",
            "Taboão da Serra",
            "Taciba",
            "Taguaí",
            "Taiaçu",
            "Taiúva",
            "Tambaú",
            "Tanabi",
            "Tapiraí",
            "Tapiratiba",
            "Taquaral",
            "Taquaritinga",
            "Taquarituba",
            "Taquarivaí",
            "Tarabai",
            "Tarumã",
            "Tatuí",
            "Taubaté",
            "Tejupá",
            "Teodoro Sampaio",
            "Terra Roxa",
            "Tietê",
            "Timburi",
            "Torre de Pedra",
            "Torrinha",
            "Trabiju",
            "Tremembé",
            "Três Fronteiras",
            "Tuiuti",
            "Tupã",
            "Tupi Paulista",
            "Turiúba",
            "Turmalina",
            "Ubarana",
            "Ubatuba",
            "Ubirajara",
            "Uchoa",
            "União Paulista",
            "Urânia",
            "Uru",
            "Urupês",
            "Valentim Gentil",
            "Valinhos",
            "Valparaíso",
            "Vargem",
            "Vargem Grande do Sul",
            "Vargem Grande Paulista",
            "Várzea Paulista",
            "Vera Cruz",
            "Vinhedo",
            "Viradouro",
            "Vista Alegre do Alto",
            "Vitória Brasil",
            "Votorantim",
            "Votuporanga",
            "Zacarias"
        ]
    },
    {
        uf: "TO",
        state: "Tocantins",
        city: [
            "Abreulândia",
            "Aguiarnópolis",
            "Aliança do Tocantins",
            "Almas",
            "Alvorada",
            "Ananás",
            "Angico",
            "Aparecida do Rio Negro",
            "Aragominas",
            "Araguacema",
            "Araguaçu",
            "Araguaína",
            "Araguanã",
            "Araguatins",
            "Arapoema",
            "Arraias",
            "Augustinópolis",
            "Aurora do Tocantins",
            "Axixá do Tocantins",
            "Babaçulândia",
            "Bandeirantes do Tocantins",
            "Barra do Ouro",
            "Barrolândia",
            "Bernardo Sayão",
            "Bom Jesus do Tocantins",
            "Brasilândia do Tocantins",
            "Brejinho de Nazaré",
            "Buriti do Tocantins",
            "Cachoeirinha",
            "Campos Lindos",
            "Cariri do Tocantins",
            "Carmolândia",
            "Carrasco Bonito",
            "Caseara",
            "Centenário",
            "Chapada da Natividade",
            "Chapada de Areia",
            "Colinas do Tocantins",
            "Colméia",
            "Combinado",
            "Conceição do Tocantins",
            "Couto Magalhães",
            "Cristalândia",
            "Crixás do Tocantins",
            "Darcinópolis",
            "Dianópolis",
            "Divinópolis do Tocantins",
            "Dois Irmãos do Tocantins",
            "Dueré",
            "Esperantina",
            "Fátima",
            "Figueirópolis",
            "Filadélfia",
            "Formoso do Araguaia",
            "Fortaleza do Tabocão",
            "Goianorte",
            "Goiatins",
            "Guaraí",
            "Gurupi",
            "Ipueiras",
            "Itacajá",
            "Itaguatins",
            "Itapiratins",
            "Itaporã do Tocantins",
            "Jaú do Tocantins",
            "Juarina",
            "Lagoa da Confusão",
            "Lagoa do Tocantins",
            "Lajeado",
            "Lavandeira",
            "Lizarda",
            "Luzinópolis",
            "Marianópolis do Tocantins",
            "Mateiros",
            "Maurilândia do Tocantins",
            "Miracema do Tocantins",
            "Miranorte",
            "Monte do Carmo",
            "Monte Santo do Tocantins",
            "Muricilândia",
            "Natividade",
            "Nazaré",
            "Nova Olinda",
            "Nova Rosalândia",
            "Novo Acordo",
            "Novo Alegre",
            "Novo Jardim",
            "Oliveira de Fátima",
            "Palmas",
            "Palmeirante",
            "Palmeiras do Tocantins",
            "Palmeirópolis",
            "Paraíso do Tocantins",
            "Paranã",
            "Pau d'Arco",
            "Pedro Afonso",
            "Peixe",
            "Pequizeiro",
            "Pindorama do Tocantins",
            "Piraquê",
            "Pium",
            "Ponte Alta do Bom Jesus",
            "Ponte Alta do Tocantins",
            "Porto Alegre do Tocantins",
            "Porto Nacional",
            "Praia Norte",
            "Presidente Kennedy",
            "Pugmil",
            "Recursolândia",
            "Riachinho",
            "Rio da Conceição",
            "Rio dos Bois",
            "Rio Sono",
            "Sampaio",
            "Sandolândia",
            "Santa Fé do Araguaia",
            "Santa Maria do Tocantins",
            "Santa Rita do Tocantins",
            "Santa Rosa do Tocantins",
            "Santa Tereza do Tocantins",
            "Santa Terezinha do Tocantins",
            "São Bento do Tocantins",
            "São Félix do Tocantins",
            "São Miguel do Tocantins",
            "São Salvador do Tocantins",
            "São Sebastião do Tocantins",
            "São Valério",
            "Silvanópolis",
            "Sítio Novo do Tocantins",
            "Sucupira",
            "Taguatinga",
            "Taipas do Tocantins",
            "Talismã",
            "Tocantínia",
            "Tocantinópolis",
            "Tupirama",
            "Tupiratins",
            "Wanderlândia",
            "Xambioá"
        ]
    }
];

let UfService = class UfService {
    constructor() {
        this.listUF = [
            { 'name': 'AC', 'value': 'AC' },
            { 'name': 'AL', 'value': 'AL' },
            { 'name': 'AM', 'value': 'AM' },
            { 'name': 'AP', 'value': 'AP' },
            { 'name': 'BA', 'value': 'BA' },
            { 'name': 'CE', 'value': 'CE' },
            { 'name': 'DF', 'value': 'DF' },
            { 'name': 'ES', 'value': 'ES' },
            { 'name': 'GO', 'value': 'GO' },
            { 'name': 'MA', 'value': 'MA' },
            { 'name': 'MG', 'value': 'MG' },
            { 'name': 'MS', 'value': 'MS' },
            { 'name': 'MT', 'value': 'MT' },
            { 'name': 'PA', 'value': 'PA' },
            { 'name': 'PB', 'value': 'PB' },
            { 'name': 'PE', 'value': 'PE' },
            { 'name': 'PI', 'value': 'PI' },
            { 'name': 'PR', 'value': 'PR' },
            { 'name': 'RJ', 'value': 'RJ' },
            { 'name': 'RN', 'value': 'RN' },
            { 'name': 'RR', 'value': 'RR' },
            { 'name': 'RS', 'value': 'RS' },
            { 'name': 'SC', 'value': 'SC' },
            { 'name': 'SE', 'value': 'SE' },
            { 'name': 'SP', 'value': 'SP' },
            { 'name': 'TO', 'value': 'TO' },
            { 'name': 'RO', 'value': 'RO' }
        ];
        this.listState = [
            { name: 'Acre', value: 'AC' },
            { name: 'Alagoas', value: 'AL' },
            { name: 'Amap\u00e1', value: 'AP' },
            { name: 'Amazonas', value: 'AM' },
            { name: 'Bahia', value: 'BA' },
            { name: 'Cear\u00e1', value: 'CE' },
            { name: 'Distrito Federal', value: 'DF' },
            { name: 'Esp\u00edrito Santo', value: 'ES' },
            { name: 'Goi\u00e1s', value: 'GO' },
            { name: 'Maranh\u00e3o', value: 'MA' },
            { name: 'Mato Grosso', value: 'MT' },
            { name: 'Mato Grosso do Sul', value: 'MS' },
            { name: 'Minas Gerais', value: 'MG' },
            { name: 'Paran\u00e1', value: 'PR' },
            { name: 'Para\u00edba', value: 'PB' },
            { name: 'Par\u00e1', value: 'PA' },
            { name: 'Pernambuco', value: 'PE' },
            { name: 'Piau\u00ed', value: 'PI' },
            { name: 'Rio Grande do Norte', value: 'RN' },
            { name: 'Rio Grande do Sul', value: 'RS' },
            { name: 'Rio de Janeiro', value: 'RJ' },
            { name: 'Rond\u00f4nia', value: 'RO' },
            { name: 'Roraima', value: 'RR' },
            { name: 'Santa Catarina', value: 'SC' },
            { name: 'Sergipe', value: 'SE' },
            { name: 'S\u00e3o Paulo', value: 'SP' },
            { name: 'Tocantins', value: 'TO' }
        ];
        // lista das cidades (utils/list-cities)
        this.listCities = LIST_CITIES;
    }
    getListUf() {
        return this.listUF;
    }
    getListState() {
        return this.listState;
    }
    getListCities(uf) {
        let cities = [];
        this.listCities.map(arr => {
            if (arr.uf === uf) {
                cities = arr.city;
            }
        });
        // caso nao encontrar nenhuma cidade
        if (cities.length === 0)
            console.warn('Nao foi encontrado nenhuma cidade da uf => ', uf);
        return cities;
    }
};
UfService = __decorate([
    Injectable()
], UfService);

let UiBsUtilModule = class UiBsUtilModule {
};
UiBsUtilModule = __decorate([
    NgModule({
        imports: [
            CommonModule,
            ReactiveFormsModule,
            IonicModule,
            IonicStorageModule.forRoot({
                driverOrder: ['indexeddb', 'sqlite', 'websql']
            }),
            UiBsOauthModule
        ],
        providers: [
            ErrorMessageService,
            UfService,
            MaskService,
            CertifiedService,
            BanksService,
            CurrencyPipe,
            Base64Service,
            PrintService,
            PartnerIndustriesService,
            CreditCardFlagService,
            IpService,
        ]
    })
], UiBsUtilModule);

class BaseService {
    constructor(storage, configService) {
        this.storage = storage;
        this.configService = configService;
    }
    loadKey() {
        return __awaiter(this, void 0, void 0, function* () {
            const key = yield this.storage.get(this.configService.getKeyForm());
            this.keyPreAccount = key;
        });
    }
    loadTypeUpload() {
        return __awaiter(this, void 0, void 0, function* () {
            const typeUploadResponse = yield this.storage.get(this.configService.getTypeUpload());
            this.typeUpload = typeUploadResponse;
        });
    }
    formatDateToString(date) {
        return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
    }
    cleanStorage() {
        this.storage.clear().then((x) => {
            // console.log(x);
        });
    }
    addItem(key, value) {
        this.storage.set(key, value);
    }
    removeItem(key) {
        this.storage.remove(key);
    }
}

var TypeCurrency;
(function (TypeCurrency) {
    TypeCurrency["BRL"] = "BRL";
    TypeCurrency["EUR"] = "EUR";
    TypeCurrency["USD"] = "USD";
})(TypeCurrency || (TypeCurrency = {}));

/*
 * Public API Surface of ui-c-button
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BanksService, Base64Service, BaseService, CertifiedService, CreditCardFlagService, DateValidator, DocumentValidator, ErrorMessageService, IpService, MaskService, MatchValidator, MoneyValidator, PartnerIndustriesService, PasswordValidator, PrintService, TypeCurrency, UfService, UiBsUtilModule, minValueValidator };
//# sourceMappingURL=wlp-ui-bs-util.js.map
